<template>
  <div id="player-wrapper" :class="showPlayerHeader ? '' : 'without-header'">
    <div id="enableModalCenter" class="player-modal" style="display: none">
      <div class="custom-modal-wrapper">
        <div class="custom-modal-inner" role="document">
          <div class="custom-modal-body">
            <div class="custom-modal-content">
              <div class="inner-allow-body2">
                <div class="row">
                  <div class="col-md-5">
                    <div class="pre-call-test-wrap">
                      <p>
                        <a
                          href="https://precalltest.e2m.live"
                          target="_blank"
                          >{{ $t("agoracall.precalltest") }}</a
                        >
                      </p>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="allow-msg-div">
                      <h3>
                        {{ $t("agoracall.abouttojoinsessionas") }}
                        {{ attendeeTypeName }}
                      </h3>
                      <p>{{ $t("agoracall.whatwillyouneed") }}</p>
                      <div class="validation-check-sec">
                        <ul>
                          <li>
                            <span
                              :class="
                                isSupportedBrowser ? 'active' : 'vitality'
                              "
                              ><img
                                src="@/assets/Player/images/browser.svg"
                                alt="Browser"
                            /></span>
                            {{ $t("agoracall.chromeoredge") }}
                          </li>
                          <li>
                            <span
                              :class="isSupportedDevice ? 'active' : 'vitality'"
                              ><img
                                src="@/assets/Player/images/device.svg"
                                alt="Device"
                            /></span>
                            {{ $t("agoracall.desktoplandscapeview") }}
                          </li>
                          <li>
                            <span
                              :class="
                                IsMicExist &&
                                IsCameraExist &&
                                hasMicAccess &&
                                hasCamAccess
                                  ? 'active'
                                  : !hasMicAccess || !hasCamAccess
                                  ? 'inactive'
                                  : 'vitality'
                              "
                              ><img
                                src="@/assets/Player/images/camera-mic.svg"
                                alt="Camera and Mic"
                            /></span>
                            {{ $t("agoracall.camera") }} &amp;
                            {{ $t("agoracall.micpermission") }}
                          </li>
                        </ul>
                      </div>
                      <div class="validation-button">
                        <div v-show="micAccessChecked && camAccessChecked">
                          <!--v-show="IsMicExist && IsCameraExist && hasMicAccess && hasCamAccess"-->
                          <span v-show="!IsMicExist || !hasMicAccess">{{
                            $t("agoracall.checkmicandcamera")
                          }}</span>
                          <!--<a
                            v-show="!IsMicExist || !hasMicAccess"
                            href="javascript:(0);"
                            class="joinasaud"
                            @click="applyMicCamAccess(false, false)"
                            >{{ $t("agoracall.joinasaudience") }}</a
                          >-->
                          <!--<a
                              href="javascript:(0);"
                              class="enable-button"
                              @click="applyMicCamAccess(true, true)"
                              >Enable camera &amp; mic</a
                            >-->
                          <a
                            v-show="IsMicExist && hasMicAccess"
                            href="javascript:(0);"
                            class="without-enable-button"
                            @click="applyMicCamAccess(true, false)"
                            >{{ $t("agoracall.joinwithoutcamera") }}</a
                          >
                          <a
                            v-show="
                              IsMicExist &&
                              IsCameraExist &&
                              hasMicAccess &&
                              hasCamAccess
                            "
                            href="javascript:(0);"
                            class="join-button"
                            @click="applyMicCamAccess(true, true)"
                            >{{ $t("agoracall.joinwithcamera") }}</a
                          >
                        </div>
                      </div>
                      <p class="caution">
                        <span>*</span>{{ $t("agoracall.pleaseensure") }}
                        <b>{{ $t("agoracall.safarinotrecommended") }}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="allowModalCenter" class="player-modal" style="display: none">
      <div class="custom-modal-wrapper">
        <div class="custom-modal-inner" role="document">
          <div class="custom-modal-body">
            <div class="custom-modal-content">
              <div class="inner-allow-body">
                <div class="row">
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <div class="allow-msg-div">
                      <h3>
                        {{ $t("agoracall.allocaccess") }} &amp;
                        {{ $t("agoracall.microphone") }}
                      </h3>
                      <a
                        @click="applyBrowserPermission"
                        href="javscript: void(0);"
                        class="close-popup"
                        >{{ $t("agoracall.ok") }}</a
                      >
                    </div>
                    <!--<video
                    ref="video"
                    id="video"
                    :style="{ width: divWidth }"
                    autoplay
                  ></video>-->

                    <!--<ul>
                    <li>Connected cameras: {{ camerasLabels }}</li>
                    <li>
                      Connected microphones: {{ getDevicesLabels(microphones) }}
                    </li>
                    <li>
                      Connected speakers: {{ getDevicesLabels(speakers) }}
                    </li>
                  </ul>-->
                    <!--<video id="videotag" autoplay></video>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<iframe allow="camera;microphone" />-->
    <div
      id="debugWrap"
      v-show="false"
      style="
        position: fixed;
        top: 0;
        left: calc(50% - 250px);
        width: 200px;
        height: calc(100% - 50px);
        overflow-y: auto;
        z-index: 9999999;
        background: #fff;
      "
    >
      <div
        @click="clearDebugPanel"
        style="
          text-align: center;
          background: #dbdbdb;
          padding: 2px 5px;
          position: absolute;
          top: 0px;
        "
      >
        {{ $t("agoracall.clear") }}
      </div>
      <div id="debugPanel"></div>
      <div
        @click="hideDebugPanel"
        style="
          text-align: center;
          background: #dbdbdb;
          padding: 2px 5px;
          position: absolute;
          bottom: 0px;
        "
      >
        {{ $t("agoracall.hide") }}
      </div>
    </div>
    <div id="player-not-ready" class="player-not-ready">
      <img
        src="@/assets/Player/images/sand-clock.svg"
        width="45px"
        class="nb-3"
      />
      <h3 class="msg">{{ playerWaitText }}</h3>
    </div>
    <div id="ag-parent-canvas" class="d-none">
      <section id="ag-left-panel" />
      <section id="ag-canvas" class="one" />
      <section id="ag-right-panel" />
    </div>
    <div
      id="ag-sponsor-panel"
      class="ag-btn-group message-group-wrapper active d-none"
    >
      <div class="sponsor-title">
        <p>{{ $t("agoracall.sessionsponseredby") }}</p>
      </div>
      <div class="sponsors">
        <hooper
          style="height: 80px"
          :vertical="false"
          :itemsToShow="7"
          :itemsToSlide="1"
          :centerMode="true"
          :autoPlay="true"
          :playSpeed="5000"
          :transition="1000"
          :hoverPause="true"
          :pagination="false"
          :infiniteScroll="true"
        >
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
          <slide class="single-sponsor">
            <img src="../../../assets/Images/spnsr1.png" />
          </slide>
        </hooper>
      </div>
    </div>
    <div
      v-if="!newDesign"
      id="ag-button-panel"
      class="ag-btn-group button-group-wrapper active"
    >
      <div class="btn-group-left-area show-on-call d-none">
        <div v-show="IsLive" class="live-signify">
          <span class="blink-dot"></span> {{ $t("livestage.live") }}
        </div>
        <div
          v-show="!IsLive && !IsGoLive"
          class="live-signify back-stage"
          data-toggle="tooltip"
          title="The Backstage is a private video chat that allows Speakers and Organizers rehearse before going live in front of attendees."
        >
          Back Stage
        </div>
        <div
          v-show="IsGoLive"
          class="live-signify go-live"
          @click="GoLive"
          data-toggle="tooltip"
          title="Attendees won&#39;t see you until you go-live"
        >
          Click Here to Go Live
        </div>
        <div
          v-show="IsLive && sessionTypeId != 6 && sessionTypeId != 7"
          id="viewCountWrap"
          class="view-count"
        >
          <p>
            <img src="../../../assets/Images/viewer.png" alt="viewer" />
            <span id="spanAttendeeCount" class="viewer-count">0</span>
          </p>
        </div>
      </div>
      <div
        v-show="
          attendeeMode !== 'audience' &&
          readyState &&
          !inProcess &&
          IsMicExist &&
          hasMicAccess
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <span
          @click="handleMic"
          class="ag-btn audioControlBtn"
          title="Enable/Disable Audio"
        >
          <i class="ag-icon ag-icon-mic">
            <img src="../../../assets/Images/unmute.svg" />
          </i>
          <i class="ag-icon ag-icon-mic-off">
            <img src="../../../assets/Images/mute.svg" />
          </i>
        </span>
        <span v-if="!isMicOn" class="icondesc">{{
          $t("agoracall.unmute")
        }}</span>
        <span v-if="isMicOn" class="icondesc">{{ $t("agoracall.mute") }}</span>
      </div>
      <div
        v-show="
          attendeeMode === 'video' &&
          readyState &&
          !inProcess &&
          IsCameraExist &&
          hasCamAccess
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <span
          @click="handleCamera"
          class="ag-btn videoControlBtn"
          title="Enable/Disable Video"
        >
          <i class="ag-icon ag-icon-camera">
            <img src="../../../assets/Images/video-camera.svg" />
          </i>
          <i class="ag-icon ag-icon-camera-off">
            <img src="../../../assets/Images/video-off.svg" />
          </i>
        </span>
        <span v-if="!isVideoOn" class="icondesc">{{
          $t("agoracall.startvideo")
        }}</span>
        <span v-if="isVideoOn" class="icondesc">{{
          $t("agoracall.stopvideo")
        }}</span>
      </div>
      <div
        v-if="AllowScreenShare && attendeeMode !== 'audience'"
        class="single-call-handle-butn show-on-call d-none"
      >
        <span
          class="ag-btn disableRemoteBtn1"
          @click="hideRemote"
          title="Hide Remote Stream"
        >
          <i class="ag-icon ag-icon-remove-pip">
            <img src="../../../assets/Images/screen-share.svg" />
          </i>
        </span>
        <span v-if="!readyShareState" class="icondesc">{{
          $t("agoracall.startsharing")
        }}</span>
        <span v-if="readyShareState" class="icondesc">{{
          $t("agoracall.stopsharing")
        }}</span>
      </div>
      <div
        v-show="
          IsLive && AllowRecording && (userType == 1 || isCurrentUserCoHost)
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <button
          v-show="!recordingStartStopInProcess"
          id="btnRecording"
          @click="togglRecording"
          class="record-session-button recording-btn"
        >
          <span class="record-btn-out">
            <span class="record-btn"></span>
          </span>
        </button>
        <button
          v-show="recordingStartStopInProcess"
          id="btnRecordingLoader"
          class="record-session-button recording-btn"
        >
          <span class="record-btn-out">
            <span
              class="record-btn fa fa-spinner fa-spin fa-circle-o-notch"
            ></span>
          </span>
        </button>
        <span id="lblRecording" class="icondesc record-text">{{
          $t("agoracall.startrecording")
        }}</span>
      </div>
      <div class="bottom-right-area">
        <div
          v-show="streamList.length > 1 && displayMode == 'pip'"
          class="single-call-handle-butn1"
        >
          <span
            @click="switchToTileView"
            class="ag-btn displayModeBtn switch-tile"
            :class="{
              disabled: streamList.length <= 1 || displayMode == 'tile',
            }"
            title="Switch Display Mode"
          >
            <i class="ag-icon ag-icon-switch-display">{{
              $t("agoracall.switchtileview")
            }}</i>
          </span>
        </div>
        <div
          v-if="attendeeType < 14 && !callSwitchingInProcess"
          class="single-call-handle-butn"
        >
          <span
            :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
          >
            <i
              v-show="readyState && !inProcess"
              class="ag-icon ag-icon-leave"
              @click="onConfirmEndCall"
              >{{ $t("agoracall.leave") }}</i
            >
            <i
              v-show="!readyState && !inProcess"
              class="ag-icon ag-icon-leave"
              @click="onEndCall"
              >{{ $t("agoracall.join") }}</i
            >
            <i v-show="inProcess" class="fa fa-spinner fa-spin"></i>
          </span>
        </div>
      </div>
    </div>

    <div
      v-else
      id="ag-button-panel"
      class="ag-btn-group button-group-wrapper active"
    >
      <div class="btn-group-left-area show-on-call d-none">
        <div v-show="IsLive" class="live-signify">
          <span class="blink-dot"></span>
          {{ recordingStarted ? "REC" : $t("livestage.live") }}
        </div>
        <!--<div
          v-show="!IsLive && !IsGoLive"
          class="live-signify back-stage"
          data-toggle="tooltip"
          title="The Backstage is a private video chat that allows Speakers and Organizers rehearse before going live in front of attendees."
        >
          Back Stage
        </div>
        <div
          v-show="IsGoLive"
          class="live-signify go-live"
          @click="GoLive"
          data-toggle="tooltip"
          title="Attendees won&#39;t see you until you go-live"
        >
          Click Here to Go Live
        </div>-->
        <div
          v-show="exPageId == '' || exPageId == 'sn'"
          @click="displaySessionDetails"
          class="information-wrap fa fa-info"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Click to view Session details"
        >
          <!--<img
            src="../../../assets/Images/rounded-info-button.svg"
            style="width: 25px; height: 28px; margin-left: 22px"
          />-->
          <p>Info</p>
        </div>
        <div
          v-show="
            !exStageUrl &&
            DisplayAudienceCounter &&
            sessionTypeId < 4 &&
            IsLive &&
            (userType < 4 || (viewersCountVisible && attendeeEnabled))
          "
          class="view-count"
          style="display: block"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Click or Show/Hide Attendee List"
        >
          <p @click="openAttendeePanel">
            <img src="../../../assets/Images/viewer.png" alt="viewer" />
            <span class="viewer-count">{{ viewersCount }}</span>
          </p>
        </div>
        <div
          v-if="[3, 4].includes(sessionTypeId) && !exStageUrl"
          id="brandLogoBottom"
          class="brand-logo-wrap"
        >
          <!--<p>This Session is Sponsored by</p>-->
          <div class="brand-logo-inner">
            <a v-if="playerLogoLink" :href="playerLogoLink" target="_blank">
              <img :src="playerLogo" />
            </a>
            <img v-else :src="playerLogo" />
          </div>
        </div>
      </div>
      <div
        v-show="
          attendeeMode !== 'audience' &&
          readyState &&
          !inProcess &&
          IsMicExist &&
          hasMicAccess
        "
        class="single-call-handle-butn voice-button-wrap show-on-call d-none"
      >
        <span @click="handleMic" class="ag-btn audioControlBtn">
          <i class="ag-icon ag-icon-mic">
            <img src="../../../assets/Images/unmute.svg" />
          </i>
          <i class="ag-icon ag-icon-mic-off">
            <img src="../../../assets/Images/mute.svg" />
          </i>
        </span>
        <span v-if="!isMicOn" class="icondesc">{{
          $t("agoracall.unmute")
        }}</span>
        <span v-if="isMicOn" class="icondesc">{{ $t("agoracall.mute") }}</span>
        <span
          v-show="false"
          class="button-setting-dropdown"
          @click="toggleAudioSettings"
        >
          <img
            src="../../../assets/Images/down-arrow-settings.svg"
            style="width: 8px; height: 10px"
          />
        </span>
        <div
          v-show="audioSettingsOpened"
          class="voice-settings-wrap"
          @click="playerSettingsOnClick"
        >
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="toggleAudioSettings"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <h4>Audio Settings</h4>
          <div>
            <div id="divDDLMicrophone">
              <span class="d-block mt-3 mb-1 text-left">{{
                $t("rightpanel.microphone")
              }}</span>
              <select
                style="-webkit-appearance: menulist"
                id="ddlNDMic"
                v-model="microphone"
                @change="onMicChange"
              >
                <option
                  v-for="(item, index) in microphoneOptions"
                  :key="index"
                  :value="item"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div>
              <span class="d-block mt-3 mb-1 text-left">{{
                $t("rightpanel.speakers")
              }}</span>
              <select
                style="-webkit-appearance: menulist"
                v-model="speaker"
                @change="onSpeakerChange"
              >
                <option
                  v-for="(item, index) in speakerOptions"
                  :key="index"
                  :value="item"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="
          attendeeMode === 'video' &&
          readyState &&
          !inProcess &&
          IsCameraExist &&
          hasCamAccess
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <span @click="handleCamera" class="ag-btn videoControlBtn">
          <i class="ag-icon ag-icon-camera">
            <img src="../../../assets/Images/video-camera.svg" />
          </i>
          <i class="ag-icon ag-icon-camera-off">
            <img src="../../../assets/Images/video-off.svg" />
          </i>
        </span>
        <span v-if="!isVideoOn" class="icondesc">{{
          $t("agoracall.startvideo")
        }}</span>
        <span v-if="isVideoOn" class="icondesc">{{
          $t("agoracall.stopvideo")
        }}</span>
        <span class="button-setting-dropdown" @click="toggleVideoSettings">
          <img
            src="../../../assets/Images/down-arrow-settings.svg"
            style="width: 8px; height: 10px"
          />
        </span>
        <div
          v-show="videoSettingsOpened"
          class="video-settings-wrap"
          @click="playerSettingsOnClick"
        >
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="toggleVideoSettings"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>
          <h4>Video Settings</h4>
          <div>
            <div>
              <span class="d-block mt-3 mb-1 text-left">{{
                $t("rightpanel.camera")
              }}</span>
              <select
                style="-webkit-appearance: menulist"
                v-model="camera"
                @change="onCameraChange"
              >
                <option
                  v-for="(item, index) in cameraOptions"
                  :key="index"
                  :value="item"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div>
              <span class="d-block mt-3 mb-1 text-left">{{
                $t("rightpanel.videoquality")
              }}</span>
              <select
                style="-webkit-appearance: menulist"
                v-model="videoResolution"
                @change="onVideoResolutionChange"
                class="is-clipped"
              >
                <option
                  v-for="(item, index) in videoResolutions"
                  :key="index"
                  :value="index.split(',')[0]"
                >
                  <!--{{ item[0] }}x{{ item[1] }}, {{ item[2] }}fps,
                  {{ item[3] }}kbps-->
                  {{ item[4] }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="AllowScreenShare && attendeeMode !== 'audience'"
        class="single-call-handle-butn show-on-call d-none"
      >
        <span class="ag-btn disableRemoteBtn1" @click="hideRemote">
          <i class="ag-icon ag-icon-remove-pip">
            <img src="../../../assets/Images/screen-share.svg" />
          </i>
        </span>
        <span v-if="!readyShareState" class="icondesc">{{
          $t("agoracall.startsharing")
        }}</span>
        <span v-if="readyShareState" class="icondesc">{{
          $t("agoracall.stopsharing")
        }}</span>
      </div>
      <!--<div
        v-if="
          IsLive && AllowRecording && (userType == 1 || isCurrentUserCoHost)
        "
        class="single-call-handle-butn rec-btn-wrap show-on-call d-none"
      >
        <button
          v-show="!recordingStartStopInProcess"
          id="btnRecording"
          @click="togglRecording"
          class="record-session-button recording-btn"
        >
          <span class="record-btn-out">
            <span class="record-btn"></span>
          </span>
        </button>
        <button
          v-show="recordingStartStopInProcess"
          id="btnRecordingLoader"
          class="record-session-button recording-btn"
        >
          <span class="record-btn-out">
            <span
              class="record-btn fa fa-spinner fa-spin fa-circle-o-notch"
            ></span>
          </span>
        </button>
        <span id="lblRecording" class="icondesc record-text">{{
          $t("agoracall.startrecording")
        }}</span>
      </div>-->

      <div
        v-show="
          [3, 4].includes(sessionTypeId) &&
          readyState &&
          (userType == 1 || isUserCoHost(uid)) &&
          ((IsLive && AllowRecording) ||
            (hostCanMuteSpeaker && streamList.length > 1))
        "
        class="single-call-handle-butn show-on-call d-none"
      >
        <div class="more-option-btn-wrap" @click="toggleHideMoreOption">
          <div class="ag-btn more-option" title="">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span class="icondesc">More</span>
        </div>
        <div
          v-show="moreOptionVisibility"
          class="more-option-wrap"
          @click="MoreOptionPanelOnClick"
        >
          <div
            class="more-action-notification action-notification hidden"
          ></div>
          <div
            v-if="
              IsLive && AllowRecording && (userType == 1 || isUserCoHost(uid))
            "
            id="btnRecording"
            class="ag-option"
            @click="togglRecording"
          >
            <span
              v-show="!recordingStarted && !recordingStartStopInProcess"
              class="ag-option-icon ag-start-recording"
            ></span>
            <span
              v-show="recordingStarted && !recordingStartStopInProcess"
              class="ag-option-icon ag-stop-recording"
            ></span>
            <span
              v-show="recordingStartStopInProcess"
              class="ag-option-icon ag-recording-in-process"
            ></span>
            <span v-if="!recordingStarted">Start Recording</span>
            <span v-else>Stop Recording</span>
          </div>
          <div
            v-if="
              [3, 4].includes(sessionTypeId) &&
              hostCanMuteSpeaker &&
              (userType == 1 || isUserCoHost(uid)) &&
              streamList.length > 1
            "
            class="ag-option ag-option-mute-all"
            @click="onRequestAllSpeakersToMute(0, true)"
          >
            <span class="ag-option-icon ag-mute-all"></span>Mute All
          </div>
          <!--<div class="ag-option">
            <span class="ag-option-icon ag-unhide-speakers"></span>Unhide
            Speakers
          </div>-->
          <!--<div
            v-if="switchTableVisible"
            class="ag-option"
            @click="displayTablesPopup"
          >
            <span class="ag-option-icon ag-switch-rt"></span>Switch Table
          </div>-->
        </div>
        <!--<div
          v-show="attendeeMode !== 'audience' && readyState && !inProcess"
          @click="HiddenSpeakersPanelOnClick"
          class="hide-screen-dropdown"
        >
          <span @click="toggleHideSpeaker">Unhide Speaker </span>
          <div v-show="hiddenSpeakerListVisibility" class="hidden-speaker-list">
            <div class="speaker-list-head">
              <h3>Unhide Speakers</h3>
              <span
                v-show="hiddenSpeakerList.length > 1"
                @click="unhideAllSpeakers"
                :class="hiddenSpeakerList.length > 4 ? '' : 'no-scroll'"
                >Unhide all
                <img src="../../../assets/Player/images/hide-view.svg"
              /></span>
            </div>
            <div class="hidden-speakers-inner-wrap">
              <div
                v-for="hiddenSpeaker in hiddenSpeakerList"
                :key="'hiddenSpeaker_' + hiddenSpeaker.AttendeeId"
                class="single-hidden-speaker"
              >
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div
                  @click="unhideSpeaker"
                  :data-val="hiddenSpeaker.AttendeeId"
                  class="un-hide-btn"
                >
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>

      <div class="bottom-right-area">
        <div
          v-show="switchTableVisible"
          class="switch-table-area"
          title="Click to switch Table"
        >
          <span @click="displayTablesPopup"
            ><i><img src="../../../assets/Images/icons/switch-table.svg" /></i
          ></span>
        </div>

        <div
          v-show="
            hostOptionsEnabled &&
            hostCanHideSpeaker &&
            (userType == 1 || isCurrentUserCoHost) &&
            readyState &&
            !inProcess &&
            hiddenSpeakerList.length > 0
          "
          @click="HiddenSpeakersPanelOnClick"
          class="hide-screen-dropdown"
        >
          <span @click="toggleHideSpeaker">Unhide Speaker </span>
          <div v-show="hiddenSpeakerListVisibility" class="hidden-speaker-list">
            <div class="speaker-list-head">
              <h3>Unhide Speakers</h3>
              <span
                v-show="hiddenSpeakerList.length > 1"
                @click="unhideAllSpeakers"
                :class="hiddenSpeakerList.length > 4 ? '' : 'no-scroll'"
                >Unhide all
                <img src="../../../assets/Player/images/hide-view.svg"
              /></span>
            </div>
            <div class="hidden-speakers-inner-wrap">
              <div
                v-for="hiddenSpeaker in hiddenSpeakerList"
                :key="'hiddenSpeaker_' + hiddenSpeaker.AttendeeId"
                class="single-hidden-speaker"
              >
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div
                  @click="unhideSpeaker"
                  :data-val="hiddenSpeaker.AttendeeId"
                  class="un-hide-btn"
                >
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <!--<div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>
              <div class="single-hidden-speaker">
                <div class="single-speaker-hidden-left">
                  <div class="hidden-speaker-img">
                    <img src="../../../assets/Images/avatar.jpg" />
                  </div>
                  <div class="hidden-speakers-details">
                    <h4>Maureen Rocha</h4>
                    <p>Vice President, Nonprofits</p>
                  </div>
                </div>
                <div class="un-hide-btn">
                  <img src="../../../assets/Player/images/hide-view.svg" />
                  <span>Unhide</span>
                </div>
              </div>-->
            </div>
          </div>
        </div>

        <div
          v-show="streamList.length > 1 && displayMode == 'pip'"
          class="single-call-handle-butn1"
          title="Click to switch to Tile View"
        >
          <span
            @click="switchToTileView"
            class="ag-btn displayModeBtn switch-tile"
            :class="{
              disabled: streamList.length <= 1 || displayMode == 'tile',
            }"
            title="Click to switch to Tile View"
          >
            <i class="ag-icon ag-icon-switch-display">
              <img src="../../../assets/Images/icons/tile-view.svg" />
            </i>
          </span>
        </div>

        <!--<div v-show="timerVisible" class="session-end-countdown">
          <p>
            <span class="ml-2 label">{{ timerLabel }}</span>
            <span :class="endsIn > 60 ? 'ml-2' : 'ml-2 blink'">{{
              timerValue
            }}</span>
          </p>
        </div>-->

        <div id="session-end-countdown" class="session-end-countdown d-none">
          <p>
            <span id="timerLabel" class="ml-2 label">{{ timerLabel }}</span>
            <span id="timerValue">{{ timerValue }}</span>
          </p>
        </div>

        <div
          v-show="!IsLive && !IsGoLive"
          class="back-stage"
          data-toggle="tooltip"
          title="The Backstage is a private video chat that allows Speakers and Organizers rehearse before going live in front of attendees."
        >
          Back Stage
        </div>
        <div
          v-show="IsGoLive"
          class="go-live"
          @click="GoLive"
          data-toggle="tooltip"
          title="Attendees won&#39;t see you until you go-live"
        >
          Enter Live Broadcast
        </div>

        <!--<div class="">
          <div
            v-if="attendeeType < 14 && !callSwitchingInProcess"
            class="single-call-handle-butn End-handle-butn"
          >
            <div
              :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
            >
              <div class="exit-butn-wrap">
                <i
                  v-show="readyState && !inProcess"
                  class="ag-icon ag-icon-leave"
                  @click="onConfirmEndCall"
                  ><img src="../../../assets/Images/leave-call.svg" />
                </i>
                <span v-show="readyState && !inProcess">{{
                  $t("agoracall.leave")
                }}</span>

                <i
                  v-show="!readyState && !inProcess"
                  class="ag-icon ag-icon-leave ag-icon-join"
                  @click="onEndCall"
                  ><img src="../../../assets/Images/join-call.svg" />
                </i>
                <span v-show="!readyState && !inProcess">{{
                  $t("agoracall.join")
                }}</span>
                <i v-show="inProcess" class="ag-icon-dialing"
                  ><img src="../../../assets/Images/dialing.gif"
                /></i>
                <span v-show="inProcess">Joining</span>
              </div>
            </div>
          </div>
        </div>-->

        <div
          v-if="attendeeType < 14 && !callSwitchingInProcess"
          class="single-call-handle-butn exit-btn-wrap"
        >
          <span
            :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
          >
            <i
              v-show="readyState && !inProcess"
              class="ag-icon ag-icon-leave 1a"
              @click="onConfirmEndCall"
              >{{ $t("agoracall.leave") }}</i
            >
            <i
              v-show="!readyState && !inProcess"
              class="ag-icon ag-icon-leave"
              @click="onEndCall"
              >{{ $t("agoracall.join") }}</i
            >
            <i v-show="inProcess" class="fa fa-spinner fa-spin"></i>
          </span>
        </div>

        <div
          v-if="
            sessionTypeId == 6 &&
            displayNextMeetingJoinLink &&
            nextMeetingId &&
            !callSwitchingInProcess
          "
          class="single-call-handle-butn exit-btn-wrap"
        >
          <div
            v-show="false"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              v-if="nextMeetingAttendeeProfilePictureURL"
              :src="nextMeetingAttendeeProfilePictureURL"
              style="
                height: 36px;
                width: 36px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 10px;
              "
              @error="nextMeetingAttendeeProfilePictureURL = ''"
            />
            <span
              v-else
              style="
                height: 36px;
                width: 36px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 10px;
                font-size: 18px;
                color: #fff;
                border: 2px solid #fff;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ nextMeetingAttendeeInitial }}
            </span>
            <span style="color: #fff">
              {{ nextMeetingAttendeeName }}
            </span>
          </div>
          <span
            :class="'ag-btn exitBtn' + (readyState ? '' : ' start-call-btn')"
            style="
              width: auto !important;
              padding: 0 6px;
              background: #669c10 !important;
            "
          >
            <i
              v-if="enableNextMeetingJoinLink"
              class="ag-icon ag-icon-leave"
              @click="startMeeting(nextMeetingId)"
              >Join Next Meeting</i
            >
            <i v-else class="ag-icon ag-icon-leave disabled"
              >Join Next Meeting</i
            >
            <i v-show="inProcess" class="fa fa-spinner fa-spin"></i>
          </span>
        </div>
      </div>
    </div>
    <div
      id="lp"
      style="
        position: absolute;
        z-index: 1000000;
        top: 0;
        left: 0;
        height: 0px;
        width: 0px;
        display: none;
      "
    >
      <video-player
        id="vpLivePlayer"
        ref="lPlayer"
        class="vjs-custom-skin l-player"
        :options="streamPlayerOptions"
        @volumechange="onLPlayerVolumeChange($event)"
        @play="onLPlayerPlay($event)"
        @ready="onLPlayerReady($event)"
      ></video-player>
    </div>
    <div
      id="popupLeaveConfirm"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div
              v-if="
                (userType == 1 || isCurrentUserCoHost) &&
                endForAllEnabled &&
                [3, 4].includes(sessionTypeId)
              "
              class="session-details p-4"
            >
              <div class="host">
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="onEndSession"
                  >END SESSION FOR ALL</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="onEndCall"
                  >LEAVE SESSION</a
                >
              </div>
            </div>
            <div v-else class="session-details p-4">
              <p>{{ $t("agoracall.areyousureyouwanttoleave") }}</p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="onCanceEndCall"
                  >{{ $t("agoracall.cancel") }}</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="onEndCall"
                  >{{ $t("agoracall.leave") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="popupUnmute"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div class="session-details p-4">
              <p>The Host {{ unmuteRequester }} would like you to unmute</p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="onUnmute(0)"
                  >Stay Muted</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="onUnmute(1)"
                  >Unmute Myself</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Popups-->
    <!--<div
      id="tempButtons"
      style="position: absolute; z-index: 999; top: 0; left: 0; display: none"
    >
      <button data-toggle="modal" data-target="#allowModalCenter">
        Click 1
      </button>
      <button data-toggle="modal" data-target="#enableModalCenter">
        Click 2
      </button>
    </div>-->
    <!-- Modal -->
  </div>
</template>      
<!--<div class="single-call-handle-butn" v-on:click="RH">RH</div>-->

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import jQuery from "jquery";
let $ = jQuery;
import * as Cookies from "js-cookie";
import { merge } from "lodash";
import AgoraRTC from "agora-rtc-sdk";
import { RESOLUTION_ARR } from "../utils/Settings";
//import AgoraRTC from "https://cdn.agora.io/sdk/web/AgoraRTCSDK-2.1.0.js";
import db from "../../../components/firebaseInit";
//import { PlayerAPIConfig } from "../player-api-config";
import APIs from "@/components/APIInit";
import VideoPlayer from "@/components/VideoPlayer.vue";
import "../../../assets/player.css";
//import VueCompositionApi from "@vue/composition-api";
import playerLog from "@/views/Player/utils/PlayerLog";
import axios from "axios";
import router from "@/router";
import common from "@/common";

//import { useCamera } from "../use/camera";
//import { useMicrophone } from "../use/microphone";
//import { useSpeaker } from "../use/speaker";

var clientError = {
  1003: { code: "SEND_VIDEO_BITRATE_TOO_LOW", msg: "Poor network connection" },
  3003: {
    code: "SEND_VIDEO_BITRATE_TOO_LOW_RECOVER",
    msg: "Connection slow. Retrying...",
  },
  1005: { code: "RECV_VIDEO_DECODE_FAILED", msg: "Poor network connection" },
  3005: {
    code: "RECV_VIDEO_DECODE_FAILED_RECOVER",
    msg: "Connection slow. Retrying...",
  },
};
var streamError = {
  "isErrorState:true;status:paused": { msg: "Retrying to connect..." },
};
var avatarImageUrl =
  "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media";

var injectStreamConfig = {
  width: 0,
  height: 0,
  videoGop: 30,
  videoFramerate: 15,
  videoBitrate: 400,
  audioSampleRate: 44100,
  audioChannels: 1,
};
//const constraints = (window.constraints = {
//  audio: true,
//  video: true,
//});
let vm;
let myVoiceDetectTimer;
let goLiveTimer;
let streamRepairTimer;
let ProfileRepairTimer;
let ReConnectCallTimer;
//const camerasLabels;
export default {
  components: {
    Hooper,
    Slide,
    VideoPlayer,
    //VueCompositionApi,
  },
  props: [
    "transcode",
    "videoProfile",
    "event_collectionName",
    "channel",
    "baseMode",
    "appId",
    "eventName",
    "roomId",
    "exStageUrl",
    "allAttendees1",
    "uid",
    "firstName",
    "fullName",
    "instance",
    "callSwitchingInProcess",
    "askForMicCam",
    "askForBrowserPermission",
    "endForAllEnabled",
    "newDesign",
    "DebugMode",
    "EnableAgoraProxy",
    "rememberSettings",
    "exPageId",
    "autoRecovery",
    "advancedAutoRecovery",
    "displayNetworkError",
    "enableLogUpload",
    "uploadLogLevel",
    "agoraPlayerClientsideLog",
    "showPlayerHeader",
    "hostOptionsEnabled",
    "hostCanMuteSpeaker",
    "hostCanHideSpeaker",
    "hostCanSpotlightSpeaker",
    "stageUrl",
  ],
  data() {
    return {
      unmuteRequester: "Host",
      timerVisible: false,
      timerLabel: "",
      timerValue: "",
      endsIn: 0,
      viewersCountVisible: false,
      attendeeEnabled: false,
      viewersCount: 0,
      switchTableVisible: false,
      moreOptionVisibility: false,
      hiddenSpeakerListVisibility: false,
      //hiddenSpeakerList: [],
      hiddenSpeakerList: [
        { AttendeeId: 111 },
        { AttendeeId: 222 },
        { AttendeeId: 333 },
        { AttendeeId: 444 },
        { AttendeeId: 555 },
        { AttendeeId: 666 },
      ],

      minOutgoungBandwidth: 100,
      minIncomingBandwidth: 100,
      outgoungBandwidth: 100,
      incomingBandwidth: 100,
      networkType: "",
      playerLog: playerLog,
      logUserIDs: [],
      logRecipientId: "onairadmin@e2m.live",
      //camerasLabels,
      //microphones,
      //speakers,
      //getDevicesLabels,
      hasConnection: true,
      playerWaitText: "Please wait, stage will be live soon...",
      IsLive: true,
      IsGoLive: false,

      player: this,
      PlayerAPIConfig: null,
      channelName: "",
      isMicOn: true,
      isVideoOn: true,
      isShareOn: true,
      inProcess: false,
      playerLogo: "",
      playerLogoLink: "",
      OnDemandTypeID: 1,
      LiveStreamTypeID: 2,
      LivePanelTypeID: 3,
      RoundTableTypeID: 4,
      O2OTypeID: 6,
      E2OTypeID: 7,

      microphoneOptions: [],
      microphone: {},
      speakerOptions: [],
      speaker: {},
      cameraOptions: [],
      camera: {},
      videoResolutions: RESOLUTION_ARR,
      videoResolution: "360p_7",

      playerSettings: {
        cameraOptions: [],
        camera: {},
        cameraOld: {},
        microphoneOptions: [],
        microphone: {},
        speakerOptions: [],
        speaker: {},
        videoProfile: "360p_7",
      },

      autoStartRecording: false,
      enableDeviceAccessibility: false,
      callStep: 0,

      isSupportedDevice: false,
      isSupportedBrowser: false,
      hasBrowserDeviceAccess: false,

      allowMic: false,
      allowCam: false,
      hasMicAccess: false,
      hasCamAccess: false,
      micAccessChecked: false,
      camAccessChecked: false,

      tempValues: null,

      sessionTypeId: 0,
      session: null,
      sessionId: "",
      roundTable: null,
      roundTableId: "",
      o2oMeeting: null,
      meetingId: "",
      meetingHostId: "",
      allAttendees: [],
      allHosts: [],
      allCoHosts: [],
      allSpeakers: [],
      attendeeType: 4, //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      userType: 4, //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      //attendeeMode: "audience", //"video", "share","audio-only"
      clientId: "",
      eventId: "",
      RecResourceId: "",
      RecSid: "",

      client: null,
      localStream: null,
      shareClient: null,
      shareStream: null,
      liveClient: null,
      liveStream: null,
      displayMode: "tile",
      streamList: [],
      streamUserList: [],
      readyState: false,
      localStreamVolume: 0,
      manuallyStopped: false,
      recordingStarted: false,
      recordingStartStopInProcess: false,

      testIdStartsAfter: 2000000000,
      testUid: 2000000000,
      shareIdStartsAfter: 1000000000,
      shareUid: 1000000000, //"share",
      latestShareUid: 0,
      screenStartedCount: 0,
      sessionVideoProfile: "",
      shareVideoProfile: "720p_1",
      volumeLevel: 100,
      readyShareState: false,
      readyLiveState: false,
      activeScreenUID: 0,
      pinSelected: false,
      specialTileViewMinTiles: 500,
      specialTileViewMaxTiles: 700,
      settings: {
        maxScrollbarLength: 100,
      },
      ActiveSpeakerFocus: false,
      ActiveSpeakerMinVolume: 10,
      ActiveSpeakerSorting: false,

      //DebugMode: false,
      ShowAudioVolume: false,
      ShowVideoProfile: false,
      DisplayAudienceCounter: true,
      DisplayCompanyAndTitleInVideoTile: true,

      AllowScreenShare: false,
      AllowRecording: false,
      AutoStartRecording: false,
      AllowPinVideoTile: false,
      PinShareScreen: true,

      micMuteUnmuteInProcess: false,
      cameraList: [],
      liveVideoApiDetails: {
        AppID: "605f401455444442838e00cb859c037b",
        Certificate: "8f472eef21f64cba97c105eab797522f",
        SpeakerTokenApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        AttendeeTokenApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        TokenValidityHours: "72",
      },
      token: "",
      IsCameraExist: false,
      IsMicExist: false,
      IsSpeakerExist: false,

      useE2MInjection: false,
      useAgoraInjection: false,
      streamPlayerOptions: {
        autoplay: true,
        controls: false,
        //controlBar: {
        //  timeDivider: false,
        //  durationDisplay: false,
        //},
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      liveStreamStarted: false,
      hlsInjectionURL: "",
      //hlsInjectionURL:
      //  "https://d190a6h3bsi1px.cloudfront.net/OAUAT/C1591904892446/E1591907102804/198000/Video_Final_mp4.m3u8",
      //rtmpInjectionURL:
      //  "https://d2znwc15337no5.cloudfront.net/OA_UAT/C1591205467009/E1591206650065/1590000/index.m3u8",
      rtmpInjectionURL: "",
      //rtmpInjectionURL:
      //  "https://d3dnabu1axuoxq.cloudfront.net/stream/index.m3u8",
      //rtmpInjectionURL:
      //  "rtmp://x.rtmp.youtube.com/live2",
      //video: {},
      audioSettingsOpened: false,
      videoSettingsOpened: false,

      displayNextMeetingJoinLink: false,
      enableNextMeetingJoinLink: false,
      nextMeetingId: "",
      nextMeetingAttendeeName: "",
      nextMeetingAttendeeInitial: "",
      nextMeetingAttendeeProfilePictureURL: "",
    };
  },

  computed: {
    //playerLogo() {
    //  let logo = vm.LiveStageLogo;
    //  if ([1, 2, 3, 5].includes(vm.sessionTypeId)) {
    //    if (vm.session && vm.session.Logo) {
    //      logo = vm.session.Logo;
    //    } else if (vm.SessionSettingsLogo != "") {
    //      logo = vm.SessionSettingsLogo;
    //    }
    //  } else if (vm.sessionTypeId == 4) {
    //    if (vm.roundTable && vm.roundTable.Logo) {
    //      logo = vm.roundTable.Logo;
    //    } else if (vm.session && vm.session.Logo) {
    //      logo = vm.session.Logo;
    //    } else if (vm.SessionSettingsLogo != "") {
    //      logo = vm.SessionSettingsLogo;
    //    }
    //  } else if (vm.sessionTypeId == 7) {
    //    // Exhibitor Logo
    //  }
    //  return logo;
    //},
    //playerLogoLink() {
    //  let link = vm.LiveStageLogoLink;
    //  if ([1, 2, 3, 5].includes(vm.sessionTypeId)) {
    //    if (vm.SessionSettingsLogoLink != "") {
    //      link = vm.SessionSettingsLogoLink;
    //    }
    //  } else if (
    //    vm.sessionTypeId == 4 &&
    //    vm.exPageId == "" &&
    //    vm.exPageId == "sn"
    //  ) {
    //    if (vm.RoundTableSettingsLogoLink != "") {
    //      link = vm.RoundTableSettingsLogoLink;
    //    } else if (vm.SessionSettingsLogoLink != "") {
    //      link = vm.SessionSettingsLogoLink;
    //    }
    //  }
    //  link = "";
    //  return link;
    //},
    ////camerasLabels,
    //microphones,
    //speakers,
    //getDevicesLabels,

    ////const { camera, cameras } = useCamera();
    ////const { microphone, microphones } = useMicrophone();
    ////const { speaker, speakers } = useSpeaker();
    //microphones: function () {
    //  useMicrophone.useMicrophone();
    //},
    //camerasLabels: function () {
    //  cameras.value.map((camera) => camera.label);
    //},
    attendeeMode: function () {
      //1:Host, 2,Speaker, 3:Guest, 4:Attendee
      //attendeeMode: "audience", //"video", "share","audio-only"
      if (vm.userType == 1 || vm.userType == 2 || vm.userType == 3) {
        return "video";
      } else {
        return "audience";
      }
    },
    attendeeTypeName: function () {
      let typeName = "Attendee";
      if (vm.sessionTypeId == vm.E2OTypeID) {
        if (vm.attendeeType == 1) {
          typeName = "Booth Representative";
        } else if (vm.attendeeType != 4) {
          typeName = "Visitor";
        }
      } else {
        let coHosts = [];
        if (vm.allCoHosts) {
          //alert("attendeeTypeName:" + vm.allCoHosts.length);
          //alert("uid:" + vm.uid);
          coHosts = vm.allCoHosts.filter(function (item) {
            //alert(" item.AttendeeId:" + item.AttendeeId);
            return item.AttendeeId == vm.uid;
          });
          //alert("coHosts:" + coHosts.length);
        }
        if (vm.attendeeType == 1) {
          typeName = "Host";
        } else if (coHosts.length > 0) {
          typeName = "Co-Host";
        } else if (vm.attendeeType == 2) {
          typeName = "Speaker";
        } else if (vm.attendeeType == 3) {
          typeName = "Guest";
        }
      }
      return typeName;
    },
    //isCallStarted: function () {

    //},
    lPlayer() {
      return vm.$refs.lPlayer.player;
    },
    //video() {
    //  return vm.$refs.video;
    //},
    isCurrentUserCoHost: function () {
      let result = false;
      if (vm.uid) {
        result = vm.isUserCoHost(vm.uid);
      }
      return result;
    },
  },

  watch: {
    hasConnection: function (val) {
      if (val) {
        vm.playerWaitText = "Please wait, stage will be live soon...";
      } else {
        vm.playerWaitText = "Weak or No Internet. Trying to Reconnect...";
        //vm.onEndCall();
      }
    },
    outgoungBandwidth: function () {
      //if (vm.userType < 4) {
      //  if (val < vm.minOutgoungBandwidth) {
      //    $("#player-network-error-" + vm.uid).html("Slow Network Detected");
      //    $("#player-network-error-" + vm.uid).removeClass("d-none");
      //  } else {
      //    $("#player-network-error-" + vm.uid).addClass("d-none");
      //  }
      //}
    },
    incomingBandwidth: function () {
      //if (val < vm.minIncomingBandwidth) {
      //  $("#player-network-error-" + vm.uid).html("Poor Network Detected");
      //  $("#player-network-error-" + vm.uid).removeClass("d-none");
      //} else {
      //  $("#player-network-error-" + vm.uid).addClass("d-none");
      //}
    },
    //userType: function () {
    //  //attendeeMode: "audience","video", "share","audio-only"
    //  if (vm.userType == 1 || vm.userType == 2 || vm.userType == 3) {
    //    vm.attendeeMode = "video";
    //  } else {
    //    vm.attendeeMode = "audience";
    //  }
    //  //alert(vm.attendeeMode);
    //},
    streamList: function () {
      vm.showHideVideoPanel();
    },
    //localStream: function () {
    //  vm.showHideVideoPanel();
    //},
    recordingStarted: function (val) {
      vm.$emit("recordingStatusChanged", vm.recordingStarted);
      if (val) {
        let shareScreenCount = vm.shareScreenCount();
        if (vm.shareClient) {
          if (shareScreenCount == 1) {
            //alert(shareScreenCount);
            vm.updateRecordingLayout(true);
          } else if (shareScreenCount > 1) {
            //alert(shareScreenCount);
            let shareId = $("#ag-canvas").attr("shareid");
            if (shareId && !isNaN(shareId)) {
              shareId = parseInt(shareId);
              if (shareId == vm.shareUid) {
                vm.updateRecordingLayout(true);
              }
            }
          }
        }
      }
    },
    DebugMode(val) {
      vm.ShowAudioVolume = val;
      vm.ShowVideoProfile = val;
    },
  },

  created() {
    vm = this;
    vm.DetectBrowser();
    //vm.shareUid = vm.shareUid + "_" + vm.uid.toString();
    vm.shareUid = vm.shareIdStartsAfter + parseInt(vm.uid);
    vm.PlayerAPIConfig = APIs.PlayerAPIConfig;
    vm.setFirebaseLivePanelAppsettings();
    vm.readAllAttendees();

    //alert("created");
    //vm.StartCall();
    //alert("window-height:" + $(window).height());
    //alert("window-width:" + $(window).width());

    //alert("document-height:" + $(document).height());
    //alert("document-width:" + $(document).width());

    //alert("window.screen-height:" + window.screen.height);
    //alert("window.screen-width:" + window.screen.width);
    if (window.screen.height > 1000) {
      vm.specialTileViewMinTiles = 500;
      vm.specialTileViewMaxTiles = 900;
    }
    //alert(window.screen.width);
    if (window.screen.width >= 1024) {
      vm.isSupportedDevice = true;
    }
  },

  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
    //var constraints = (window.constraints = {
    //  audio: true,
    //  video: true,
    //});
    //navigator.mediaDevices
    //  .getUserMedia(constraints)
    //  .then(function (stream) {
    //    alert("on");
    //    var videoTracks = stream.getVideoTracks();
    //    console.log("Got stream with constraints:", constraints);
    //    console.log("Using video device: " + videoTracks[0].label);
    //    stream.onremovetrack = function () {
    //      console.log("Stream ended");
    //    };
    //    window.stream = stream; // make variable available to browser console
    //    //video.srcObject = stream;
    //  })
    //  .catch(function (error) {
    //    alert("off");
    //    if (error.name === "ConstraintNotSatisfiedError") {
    //      //errorMsg('The resolution ' + constraints.video.width.exact + 'x' +
    //      //constraints.video.height.exact + ' px is not supported by your device.');
    //    } else if (error.name === "PermissionDeniedError") {
    //      //errorMsg('Permissions have not been granted to use your camera and ' +
    //      //    'microphone, you need to allow the page access to your devices in ' +
    //      //    'order for the demo to work.');
    //    }
    //    //errorMsg('getUserMedia error: ' + error.name, error);
    //  });

    //let MediaDeviceInfo = navigator.mediaDevices.enumerateDevices;
    //alert(MediaDeviceInfo);
    //let aaa = MediaDeviceInfo.map((device) => device.label);
    //setTimeout(() => {
    //  alert(aaa);
    //}, 10000);
    //return navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
    //navigator.getUserMedia =
    //  navigator.getUserMedia ||
    //  navigator.webkitGetUserMedia ||
    //  navigator.mozGetUserMedia;

    //// Start video camera
    //navigator.getUserMedia(
    //  {
    //    video: true,
    //    audio: true,
    //  },
    //  function (stream) {
    //    document.getElementById("videotag").srcObject = stream;
    //  },
    //  function (error) {
    //    console.error(error);
    //  }
    //);
    //navigator.getUserMedia =
    //  navigator.getUserMedia ||
    //  navigator.webkitGetUserMedia ||
    //  navigator.mozGetUserMedia;

    //// Start video camera
    //navigator.getUserMedia(
    //  {
    //    video: true,
    //    audio: true,
    //  },
    //  function (stream) {
    //    document.getElementById("videotag").srcObject = stream;
    //  },
    //  function (error) {
    //    console.error(error);
    //  }
    //);
    //navigator.mediaDevices.enumerateDevices;
    //this.camera("environment");
    //$("#enableModalCenter").modal({
    //  show: false,
    //  backdrop: "static",
    //});
    //$("#enableModalCenter").modal("show");

    //$("#enableModalCenter").modal({ backdrop: "static", keyboard: false });
    //$("#enableModalCenter").modal({ backdrop: "static", keyboard: false });

    //alert("mounted");
    //alert("instance:" + vm.instance);
    //alert("uid:" + vm.uid);

    this.$nextTick(() => {
      // add listener to control btn group
      let canvas = document.querySelector("#ag-canvas");
      //let sponsorPanel = document.querySelector("#ag-sponsor-panel");
      //let btnGroup = document.querySelector("#ag-button-panel");
      canvas.addEventListener("mousemove", () => {
        if (global._toolbarToggle) {
          clearTimeout(global._toolbarToggle);
        }
        //sponsorPanel.classList.remove("active");
        //btnGroup.classList.add("active");
        global._toolbarToggle = setTimeout(function () {
          //sponsorPanel.classList.add("active");
          //btnGroup.classList.remove("active");
        }, 10000);
      });
    });
  },

  beforeUpdate() {
    if (vm.streamList.length == 1) {
      $("#ag-canvas").addClass("one");
    } else {
      $("#ag-canvas").removeClass("one");
    }
    vm.arrangeVideoFrame();
    let speakerIdList = [];
    vm.streamList.forEach((element) => {
      let id = element.getId();
      //if (id.indexOf("share" > -1)) {
      if (id < vm.shareIdStartsAfter) {
        speakerIdList.push(id);
      }
    });
    //alert(speakerIdList.length);
    vm.$emit("SpeakerPanelOnUpdate", speakerIdList);
  },

  beforeDestroy() {
    this.client && this.client.unpublish(this.localStream);
    this.localStream && this.localStream.close();
    if (vm.client && vm.EnableAgoraProxy) {
      vm.client.stopProxyServer();
    }
    this.client &&
      this.client.leave(
        () => {
          console.log("Client succeed to leave.");
        },
        () => {
          console.log("Client failed to leave.");
        }
      );

    if (myVoiceDetectTimer) {
      clearInterval(myVoiceDetectTimer);
    }
    if (goLiveTimer) {
      clearInterval(goLiveTimer);
    }
    if (streamRepairTimer) {
      clearInterval(streamRepairTimer);
    }
    if (ProfileRepairTimer) {
      clearInterval(ProfileRepairTimer);
    }
    if (ReConnectCallTimer) {
      clearInterval(ReConnectCallTimer);
    }
  },

  methods: {
    //New Design START
    displayTimer(isVisible, label, value, endsIn) {
      //console.log(isVisible, label, value, endsIn);
      //vm.timerVisible = isVisible;
      //vm.timerLabel = label + ":";
      //vm.timerValue = value;
      //vm.endsIn = endsIn;
      if (isVisible) {
        $("#session-end-countdown").removeClass("d-none");
      } else {
        $("#session-end-countdown").addClass("d-none");
      }
      $("#timerLabel").html(label);
      $("#timerValue").html(value);
      if (endsIn > 60 || !vm.IsLive) {
        $("#timerValue").attr("class", "ml-2");
      } else {
        $("#timerValue").attr("class", "ml-2 blink");
      }
    },
    AttendeeEnabled(val) {
      vm.attendeeEnabled = val;
    },
    displayViewersCount(isVisible, value) {
      if (value) {
        vm.viewersCount = value;
      }
      if (vm.DisplayAudienceCounter) {
        let coHosts = [];
        if (vm.allCoHosts) {
          coHosts = vm.allCoHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
        }
        if (vm.attendeeType < 3 || coHosts.length > 0) {
          vm.viewersCountVisible = true;
        } else {
          if (
            vm.session &&
            vm.session.SessionTypeDetails &&
            vm.session.SessionTypeDetails.ShowAttendeeList
          ) {
            vm.viewersCountVisible = isVisible;
          }
        }
      } else {
        vm.viewersCountVisible = false;
      }
    },
    displaySwitchTable(isVisible) {
      vm.switchTableVisible = isVisible;
    },
    displayTablesPopup() {
      vm.$emit("displayTablesPopup");
    },
    hidePopup() {
      if (vm.audioSettingsOpened) {
        vm.toggleAudioSettings();
      }
      if (vm.videoSettingsOpened) {
        vm.toggleVideoSettings();
      }
      if (vm.hiddenSpeakerListVisibility) {
        vm.toggleHideSpeaker();
      }
      vm.moreOptionVisibility = false;

      $(".ag-option-group").addClass("hidden");
    },
    toggleAudioSettings: function (e) {
      if (!vm.audioSettingsOpened) {
        vm.hidePopup();
      }
      vm.audioSettingsOpened = !vm.audioSettingsOpened;
      if (vm.audioSettingsOpened) {
        vm.getAudioSettings();
        if (vm.videoSettingsOpened) {
          vm.toggleVideoSettings();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    toggleVideoSettings: function (e) {
      if (!vm.videoSettingsOpened) {
        vm.hidePopup();
      }
      vm.videoSettingsOpened = !vm.videoSettingsOpened;
      if (vm.videoSettingsOpened) {
        vm.getVideoSettings();
        if (vm.audioSettingsOpened) {
          vm.toggleAudioSettings();
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    playerSettingsOnClick(e) {
      e.stopPropagation();
    },
    HiddenSpeakersPanelOnClick(e) {
      e.stopPropagation();
    },
    MoreOptionPanelOnClick(e) {
      e.stopPropagation();
    },
    displaySessionDetails() {
      vm.$emit("displaySessionDetails");
    },
    showNextMeetingJoinLink(display, enabled) {
      if (vm.nextMeetingId) {
        vm.displayNextMeetingJoinLink = display;
        vm.enableNextMeetingJoinLink = enabled;
      } else {
        vm.nextMeetingId = "";
        vm.displayNextMeetingJoinLink = false;
        vm.enableNextMeetingJoinLink = false;
      }
    },
    setNextMeetingData(meetingId, meeting) {
      if (meetingId && meeting && meeting.MeetingId) {
        vm.nextMeetingId = meetingId;
        //console.log("showNextMeetingJoinLink----------------" + meetingId);
        if (vm.uid == meeting.SenderId) {
          vm.nextMeetingAttendeeName = meeting.Name;
          vm.nextMeetingAttendeeProfilePictureURL = meeting.Image;
          vm.nextMeetingAttendeeInitial = common.getInitials(
            vm.nextMeetingAttendeeName
          );
        } else if (vm.uid == meeting.ReceiverId) {
          vm.nextMeetingAttendeeName = meeting.Organizername;
          vm.nextMeetingAttendeeProfilePictureURL = meeting.Organizerprofilepic;
          vm.nextMeetingAttendeeInitial = common.getInitials(
            vm.nextMeetingAttendeeName
          );
        }
      } else {
        vm.nextMeetingId = "";
        vm.displayNextMeetingJoinLink = false;
        vm.enableNextMeetingJoinLink = false;
      }
    },
    //New Design END
    shareScreenCount() {
      let shareScreens = vm.streamList.filter(function (item) {
        return item.getId() > vm.shareIdStartsAfter;
      });
      return shareScreens.length;
    },
    canStopshareScreen() {
      let shareScreens = vm.streamList.filter(function (item) {
        return item.getId() > vm.shareIdStartsAfter;
      });
      return shareScreens.length;
    },
    updateSessionSpeakers(session) {
      if (session) {
        if (session.SessionTypeDetails) {
          vm.viewersCountVisible = session.SessionTypeDetails.ShowAttendeeList
            ? session.SessionTypeDetails.ShowAttendeeList
            : false;
        }
        let speakers = session.MappedSpeakers;
        let speakersToUpdate = [];
        speakers.map(function (item) {
          let spkrs = vm.allSpeakers.filter(function (val) {
            return item.AttendeeId == val.AttendeeId;
          });
          if (spkrs.length > 0) {
            speakersToUpdate.push(item.AttendeeId);
            spkrs[0].FirstName = item.FirstName;
            spkrs[0].LastName = item.LastName;
            spkrs[0].Name = item.Name;
            spkrs[0].Company = item.Company;
            spkrs[0].Designation = item.Designation;
            spkrs[0].ProfilePictureURL = item.ProfilePictureURL;
          } else {
            speakersToUpdate.push(item.AttendeeId);
            vm.allSpeakers.push(item);
          }
        });

        speakers.map(function (item) {
          if (speakersToUpdate.includes(item.AttendeeId)) {
            $("#profile-" + item.AttendeeId + " .ag-profile-name").html(
              item.Name
            );
            $("#profile-" + item.AttendeeId + " .ag-profile-title").html(
              item.Designation
            );
            $("#profile-" + item.AttendeeId + " .ag-profile-company").html(
              item.Company
            );
            let profileImage = item.ProfilePictureURL;
            if (profileImage == avatarImageUrl) {
              profileImage = "";
            }
            if (profileImage == "") {
              let nameInitial = common.getInitials(item.Name);
              $("#profileImage_" + item.AttendeeId + ".ag-profile-image").html(
                "<h4>" + nameInitial + "</h4>"
              );
            } else {
              $("#profileImage_" + item.AttendeeId + ".ag-profile-image").html(
                "<img src='" + profileImage + "' height='132px' width='132px'/>"
              );
            }
            //$("#profileImage_" + item.AttendeeId + ".ag-profile-image img").attr(
            //  "src",
            //  profileImage
            //);
          }
        });
      }
    },
    UpdateRTGuests(allGuests) {
      //alert(allGuests.length);
      allGuests.map(function (item) {
        let speakers = vm.allSpeakers.filter(function (speaker) {
          return item.AttendeeId == speaker.AttendeeId;
        });
        if (speakers.length == 0) {
          vm.allSpeakers.push(item);
        }
      });
      //vm.allSpeakers = allGuests;
    },
    changeConnectionState: function (val) {
      vm.hasConnection = val;
    },
    DetectBrowser() {
      //var docRefGeneralSettings = db
      //  .collection("OA_UAT")
      //  .doc("GeneralSettings");
      //docRefGeneralSettings.get().then(function (doc) {
      //  if (doc.exists) {
      //    if (doc.data().IsBrowserCheck !== undefined) {
      //      if (doc.data().IsBrowserCheck === true) {
      if (vm.$browserDetect.isChrome) {
        vm.isSupportedBrowser = true;
      } else if (vm.$browserDetect.isEdge) {
        vm.isSupportedBrowser = true;
      } else if (vm.$browserDetect.isChromeIOS) {
        vm.isSupportedBrowser = true;
      } else if (vm.$browserDetect.meta.name === "Edge") {
        vm.isSupportedBrowser = true;
      }
      //      } else {
      //        vm.IsBrowserCheck = false;
      //      }
      //    } else {
      //      vm.IsBrowserCheck = false;
      //    }
      //  } else {
      //    vm.IsBrowserCheck = false;
      //  }
      //});
    },
    askForCM() {
      alert("askForCM");
      var constraints = (window.constraints = {
        audio: true,
        video: true,
      });
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          var videoTracks = stream.getVideoTracks();
          console.log("Got stream with constraints:", constraints);
          console.log("Using video device: " + videoTracks[0].label);
          stream.onremovetrack = function () {
            console.log("Stream ended");
          };
          window.stream = stream; // make variable available to browser console
          //video.srcObject = stream;
        })
        .catch(function (error) {
          if (error.name === "ConstraintNotSatisfiedError") {
            //errorMsg('The resolution ' + constraints.video.width.exact + 'x' +
            //constraints.video.height.exact + ' px is not supported by your device.');
          } else if (error.name === "PermissionDeniedError") {
            //errorMsg('Permissions have not been granted to use your camera and ' +
            //    'microphone, you need to allow the page access to your devices in ' +
            //    'order for the demo to work.');
          }
          //errorMsg('getUserMedia error: ' + error.name, error);
        });

      let MediaDeviceInfo = navigator.mediaDevices.enumerateDevices;
      let aaa = MediaDeviceInfo.map((device) => device.label);
      setTimeout(() => {
        alert(aaa);
      }, 10000);
      return navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
      //navigator.getUserMedia =
      //  navigator.getUserMedia ||
      //  navigator.webkitGetUserMedia ||
      //  navigator.mozGetUserMedia;

      //// Start video camera
      //navigator.getUserMedia(
      //  {
      //    video: true,
      //    audio: true,
      //  },
      //  function (stream) {
      //    document.getElementById("videotag").srcObject = stream;
      //  },
      //  function (error) {
      //    console.error(error);
      //  }
      //);
    },
    //getDevicesLabels(devices: MediaDeviceInfo[]) {
    //  return devices.map((device) => device.label);
    //},
    //camera(face) {
    //  this.stop();
    //  this.gum(face);
    //},
    //stop() {
    //  return (
    //    this.video.srcObject &&
    //    this.AppIDvideo.srcObject.getTracks().map((t) => t.stop())
    //  );
    //},
    //gum(face) {
    //  if (face === "user") {
    //    return navigator.mediaDevices
    //      .getUserMedia({ video: { facingMode: face } })
    //      .then((stream) => {
    //        vm.video.srcObject = stream;
    //        this.localstream = stream;
    //      });
    //  }
    //  if (face === "environment") {
    //    return navigator.mediaDevices
    //      .getUserMedia({ video: { facingMode: { exact: face } } })
    //      .then((stream) => {
    //        vm.video.srcObject = stream;
    //        this.localstream = stream;
    //      });
    //  }
    //},
    closeModal() {
      $(".modal").modal("hide");
    },
    onLPlayerVolumeChange(player) {
      console.log("player play!", player);
      //////let volumeLevel = parseFloat(player.techGet_("volume"));
      //////volumeLevel = isNaN(volumeLevel) ? 1 : volumeLevel;
      //////vm.volumeLevel = parseInt(volumeLevel * 100);
      //////vm.muted = player.muted();
      //if (player.muted()) {
      //  vm.volumeLevel = 0;
      //}
      //alert(vm.volumeLevel);
    },
    onLPlayerPlay(player) {
      //////player.muted(vm.muted);
      console.log("player play!", player);
      //player.usingNativeControls_ = false;
      //player.removeTechControlsListeners_();
      //this.removeClass("vjs-using-native-controls");
    },
    onLPlayerReady(player) {
      //alert("aa");
      //alert($(window).findControl("vjs_video_3"));
      //alert($(window).querySelector("#ag-canvas"));
      console.log("player ready!", player);
      //vm.player.usingNativeControls_ = false;
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeTechControlsListeners_();
      //vm.player.removeClass("vjs-using-native-controls");
      //vm.player.techCall_("setPlaysinline", false);
      //if (vm.player.tech_) {
      //  vm.player.techCall_("setAutoplay", false);
      //}
      //controls autoplay muted aspectRatio allow="autoplay; fullscreen"
      //setTimeout(() => {
      //  //alert();
      //  //vm.player.autoplay(true);
      //  //vm.player.trigger("loadstart");
      //  //vm.player.trigger("firstplay");
      //  //vm.player.manualAutoplay_(vm.player.autoplay());
      //  //vm.player.options_.autoplay = true;
      //  //let promise;
      //  // if muted defaults to true
      //  // the only thing we can do is call play
      //  //promise = vm.player.play();
      //  //promise.catch(false);
      //  vm.player.play();
      //}, 5000);
      //alert("bb");
      //player.play();
    },
    playStream: function (source) {
      const video = {
        //autoplay: true,
        //controls: true,
        //techOrder: ["flash", "html5"],
        //sourceOrder: true,
        //Promise: vm.player.options_.Promise,
        withCredentials: false,
        type: "application/x-mpegurl",
        src: source,
        //sources: [
        //  {
        //    type: "rtmp/mp4",
        //    src: "application/x-mpegurl",
        //  },
        //],
      };
      vm.lPlayer.reset(); // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
      vm.lPlayer.src(video);
      // vm.player.load()
      //vm.player.trigger("usingnativecontrols");
      //vm.player.trigger("usingcustomcontrols");
      //vm.player.usingNativeControls_ = false;
      //vm.player.autoplay(true);

      //////vm.streamPlayer.muted(vm.muted);
      //////vm.streamPlayer.volume(vm.volumeLevel / 100);
      //vm.streamPlayer.currentTime(timeElapsed);
      //vm.streamPlayer.play();
      //alert(timeElapsed);
    },
    startLStream() {
      //alert("startLStream");
      if (vm.hlsInjectionURL && vm.hlsInjectionURL != "") {
        vm.streamPlayerOptions.controls == false;
        vm.playStream(vm.hlsInjectionURL);
      }
    },
    stopLStream: function () {
      vm.lPlayer.reset();
    },
    injectStream() {
      if (vm.useE2MInjection) {
        alert("useE2MInjection");
        vm.startLStream();
      } else if (vm.useAgoraInjection) {
        if (vm.uid == "221000") {
          alert("useAgoraInjection");
          if (vm.rtmpInjectionURL && vm.rtmpInjectionURL != "") {
            vm.client.addInjectStreamUrl(
              vm.rtmpInjectionURL,
              injectStreamConfig
            );
          }
        }
      }
    },

    startLiveStream() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //alert();
      if (obj != undefined && obj != null) {
        if (
          vm.liveClient == {} ||
          vm.liveClient == undefined ||
          vm.liveClient == null
        ) {
          //vm.liveClient = AgoraRTC.createClient({ mode: vm.transcode });
          vm.liveClient = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
        }
        vm.liveClient.init(
          vm.liveVideoApiDetails.AppID,
          () => {
            //console.log("AgoraRTC liveClient initialized");
            //vm.subscribeShareStreamEvents();
            //alert("vm.channel:" + vm.channel);
            //vm.liveClient.join(
            //  vm.appId,
            //  vm.channelName,
            //  vm.shareUid,
            //  (uid) => {

            vm.liveClient.setClientRole(
              "host",
              function () {
                //console.log('Client role set to audience');
              },
              function (e) {
                console.log("setClientRole failed", e);
              }
            );
            vm.liveClient.join(vm.token, vm.channelName, 666, (uid) => {
              //vm.liveClient.join(token, vm.channel, 0, (uid) => {
              //liveClient.join(token, channelName, 0, function(uid) {
              console.log("User " + uid + " join channel successfully");
              console.log("At " + new Date().toLocaleTimeString());
              vm.injectStream();
              // create local stream
              // It is not recommended to setState in function addStream
              //vm.liveStream = this.streamInit(uid, "share", vm.videoProfile);

              //vm.liveStream.on("stopScreenSharing", function (evt) {
              //  console.log("" + evt);
              //  //if(screenShareActive) {
              //  vm.stopShareScreen();
              //  //}
              //});
              //vm.liveStream.init(
              //  () => {
              //    if (vm.attendeeMode !== "audience") {
              //      //	vm.addStream(vm.shareStream, true);
              //      vm.liveClient.publish(vm.liveStream, (err) => {
              //        console.log("Publish local stream error: " + err);
              //      });
              //    }
              //    vm.readyLiveState = true;
              //  },
              //  (err) => {
              //    //vm.stopShareScreen();
              //    console.log("getUserMedia failed", err);
              //    //vm.readyShareState = true;
              //  }
              //);
            });
          },
          (err) => {
            //vm.stopShareScreen();
            console.log("getUserMedia failed", err);
            //vm.readyShareState = true;
          }
        );
        //}
      }
    },

    validateDevices: function () {
      //alert("validateDevices");
      AgoraRTC.getDevices(function (devices) {
        //vm.IsCameraExist = false;
        //vm.IsMicExist = false;
        //vm.IsSpeakerExist = false;
        devices.forEach(function (item) {
          //alert("deviceId:" + item.deviceId);
          //alert("groupId:" + item.groupId);
          if (item.kind == "audioinput") {
            vm.IsMicExist = true;
            //alert("MicExist");
          } else if (item.kind == "audiooutput") {
            vm.IsSpeakerExist = true;
            //alert("SpeakerExist");
          } else if (item.kind == "videoinput") {
            vm.IsCameraExist = true;
            //alert("CameraExist");
          }
        });
      });
    },
    setRecResourceId: function (recResourceId) {
      vm.RecResourceId = recResourceId;
    },
    setRecSid: function (recSid) {
      vm.RecSid = recSid;
    },
    enableDisableButtonRecording: function (value) {
      if (value == 1) {
        $("#btnRecording").addClass("start-record");
        $("#btnRecording1").addClass("start-record");
        $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
        //$("#recordingIndicator").show();
        vm.recordingStarted = true;
      } else {
        $("#btnRecording").removeClass("start-record");
        $("#btnRecording1").removeClass("start-record");
        $("#lblRecording").text(vm.$t("agoracall.startrecording"));
        //$("#recordingIndicator").hide();
        vm.recordingStarted = false;
      }
    },
    getRecordingParamFromFirebase: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      let recCollection = "Session";
      let SessionIdForRec = vm.sessionId;
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        recCollection = "RoundTable";
        SessionIdForRec = vm.roundTableId;
      } else if (vm.sessionTypeId == vm.O2OTypeID) {
        recCollection = "OneToOneMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == vm.E2OTypeID) {
        recCollection = "ExhibitorMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == 100) {
        recCollection = "ChatRoom";
        SessionIdForRec = vm.roomId;
      }
      if (obj) {
        db.collection(obj.eventcollectionname)
          .doc("UserVideoActivity")
          .collection(recCollection)
          .doc(SessionIdForRec)
          .onSnapshot(function (doc) {
            if (doc.exists) {
              if (doc.data() != undefined) {
                if (
                  typeof doc.data().recording != undefined &&
                  typeof doc.data().recResourceId != undefined &&
                  typeof doc.data().recSid != undefined
                ) {
                  vm.enableDisableButtonRecording(doc.data().recording);
                  vm.setRecResourceId(doc.data().recResourceId);
                  vm.setRecSid(doc.data().recSid);
                }
              }
            }
          });
      }
    },
    setRecordingParamToFirebase: function (value) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      let recCollection = "Session";
      let SessionIdForRec = vm.sessionId;
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        recCollection = "RoundTable";
        SessionIdForRec = vm.roundTableId;
      } else if (vm.sessionTypeId == vm.O2OTypeID) {
        recCollection = "OneToOneMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == vm.E2OTypeID) {
        recCollection = "ExhibitorMeeting";
        SessionIdForRec = vm.exMeetingId;
      } else if (vm.sessionTypeId == 100) {
        recCollection = "ChatRoom";
        SessionIdForRec = vm.roomId;
      }
      if (obj && vm.RecResourceId && vm.RecSid) {
        var docRef = db
          .collection(obj.eventcollectionname)
          .doc("UserVideoActivity")
          .collection(recCollection)
          .doc(SessionIdForRec);
        docRef.get().then(function (doc) {
          if (!doc.exists) {
            var settingsObject = new Object();
            settingsObject.recording = value;
            settingsObject.recResourceId = vm.RecResourceId;
            settingsObject.recSid = vm.RecSid;
            docRef.set(settingsObject);
          } else {
            var option = new Object();
            option["recording"] = value;
            option["recResourceId"] = vm.RecResourceId;
            option["recSid"] = vm.RecSid;
            docRef.get().then((querySnapshot) => {
              querySnapshot.ref.update(option);
            });
          }
        });
      }
    },
    setFirebaseLivePanelAppsettings: function () {
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");
      docRef.get().then(function (doc) {
        if (doc.exists) {
          let data = doc.data();
          vm.liveVideoApiDetails.AppID = data.AppIDRTC;
          vm.liveVideoApiDetails.Certificate = data.CertificateRTC;
          vm.liveVideoApiDetails.SpeakerTokenApiUrl = data.SpeakerTokenURL;
          vm.liveVideoApiDetails.AttendeeTokenApiUrl = data.AttendeeTokenURL;
          vm.liveVideoApiDetails.TokenValidityHours = data.TokenValidityHours;
          vm.appId = data.AppIDRTC;
          vm.enableDeviceAccessibility = data.EnableDeviceAccessibility
            ? true
            : false;
          vm.autoStartRecording = data.AutoStartRecording ? true : false;
          //alert(vm.enableDeviceAccessibility);
          vm.enableDeviceAccessibility = true;
          vm.validateDevices();
        }
      });
    },
    showHideVideoPanel() {
      //alert(vm.userType);
      //alert(vm.localStream);
      //alert(vm.streamList.length);
      if (vm.userType == 4 && vm.streamList.length == 0) {
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        vm.$emit("livePanelOnEnd", vm.roundTableId, false);
      } else if (vm.userType != 4 && vm.localStream == null) {
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        vm.$emit("livePanelOnEnd", vm.roundTableId, false);
      } else {
        $("#player-not-ready").addClass("d-none");
        $("#ag-parent-canvas").removeClass("d-none");
        $(".show-on-call").removeClass("d-none");
        vm.$emit("livePanelOnStart", vm.roundTableId);
      }
    },
    showHideVideoPanel1() {
      //alert(vm.userType);
      //alert(vm.localStream);
      //alert(vm.streamList.length);
      if (vm.localStream == null) {
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        vm.$emit("livePanelOnEnd", vm.roundTableId, true);
      } else if (vm.userType == 4 && vm.streamList.length == 0) {
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        vm.$emit("livePanelOnEnd", vm.roundTableId, false);
      } else {
        $("#player-not-ready").addClass("d-none");
        $("#ag-parent-canvas").removeClass("d-none");
        $(".show-on-call").removeClass("d-none");
        vm.$emit("livePanelOnStart", vm.roundTableId);
      }
    },
    showLog(text) {
      if (location.origin.startsWith("http://localhost")) {
        //vm.DebugMode = true;
        if ($("#debugPanel")) {
          $("#debugPanel").append("<div>" + text + "</dib>");
        }
      } else {
        vm.hideDebugPanel();
      }
    },
    clearDebugPanel() {
      $("#debugPanel").html("");
    },
    hideDebugPanel() {
      $("#debugWrap").hide();
    },
    RH() {
      //vm.streamList.map((item) => {
      //  let id = item.getId();
      //  if (id == "221000") {
      //    alert("221000");
      //  }
      //});
      //vm.EndCall();
      //setTimeout(() => {
      //  vm.attendeeMode = "video";
      //  vm.StartCall();
      //}, 5000);

      //vm.addStream(vm.localStream, true);
      //vm.client.publish(vm.localStream, (err) => {
      //  console.log("Publish local stream error: " + err);
      //});
      if (vm.attendeeMode == "audience") {
        vm.attendeeMode = "video";
        vm.localStream = this.streamInit(
          vm.uid,
          vm.attendeeMode,
          vm.videoProfile
        );
        vm.localStream.init(
          () => {
            if (vm.attendeeMode !== "audience") {
              vm.addStream(vm.localStream, true);
              vm.client.publish(vm.localStream, (err) => {
                console.log("Publish local stream error: " + err);
              });
            }
            vm.readyState = true;
          },
          (err) => {
            console.log("getUserMedia failed", err);
            vm.readyState = true;
          }
        );
      } else {
        vm.attendeeMode = "audience";
        this.client.unpublish(this.localStream);
        this.removeStream(vm.uid);
        //this.client.leave(
        //  () => {
        //    console.log("Client succeed to leave.");
        //  },
        //  () => {
        //    console.log("Client failed to leave.");
        //  }
        //);

        //vm.attendeeMode = "audience";
        //vm.localStream = this.streamInit(
        //  vm.uid,
        //  vm.attendeeMode,
        //  vm.videoProfile
        //);
        //vm.localStream.init(
        //  () => {
        //    if (vm.attendeeMode !== "audience") {
        //      vm.addStream(vm.localStream, true);
        //      vm.client.publish(vm.localStream, (err) => {
        //        console.log("Publish local stream error: " + err);
        //      });
        //    }
        //    vm.readyState = true;
        //  },
        //  (err) => {
        //    console.log("getUserMedia failed", err);
        //    vm.readyState = true;
        //  }
        //);
      }
    },

    changePlayerVolume(volumeLevel) {
      //alert(volumeLevel);
      vm.volumeLevel = parseInt(volumeLevel);
      vm.streamList.map((item) => {
        //item.enableAudio();
        //item.disableAudio();
        if (item.getId() != vm.shareUid) {
          item.setAudioVolume(vm.volumeLevel);
        }
        //alert(item.getAudioVolume());
      });
    },

    initPlayerSettings(playerSettings) {
      //alert("initPlayerSettings");
      //alert(playerSettings.ActiveSpeakerFocus);
      //alert("initPlayerSettings: " + playerSettings.videoProfile);
      if (playerSettings.videoProfile && playerSettings.videoProfile != "") {
        vm.sessionVideoProfile = playerSettings.videoProfile;
      }
      vm.ActiveSpeakerFocus = playerSettings.ActiveSpeakerFocus;
      vm.ActiveSpeakerMinVolume = playerSettings.ActiveSpeakerMinVolume;
      vm.ActiveSpeakerSorting = playerSettings.ActiveSpeakerSorting;
      //vm.DebugMode = playerSettings.DebugMode;
      //vm.ShowAudioVolume = playerSettings.DebugMode;
      //vm.ShowVideoProfile = playerSettings.DebugMode;
      vm.DisplayAudienceCounter = playerSettings.DisplayAudienceCounter;
      vm.DisplayCompanyAndTitleInVideoTile =
        playerSettings.DisplayCompanyAndTitleInVideoTile;
      if (vm.DisplayAudienceCounter) {
        if (vm.sessionTypeId < 4) {
          $("#viewCountWrap").show();
          //vm.viewersCountVisible = true;
          vm.displayViewersCount(true);
        } else {
          $("#viewCountWrap").hide();
          vm.viewersCountVisible = false;
          vm.displayViewersCount(false);
        }
      } else {
        $("#viewCountWrap").hide();
        vm.viewersCountVisible = false;
        vm.displayViewersCount(false);
      }
    },

    setCanvasRowColumn() {
      //let rowCount = 1;
      let colCount = 1;
      let canvas = document.querySelector("#ag-canvas");
      let canvasItemCount = canvas.childNodes.length;
      //alert(canvasItemCount);
      if (vm.displayMode === "tile") {
        if (canvasItemCount == 1) {
          colCount = 1;
        } else if (canvasItemCount == 2 || canvasItemCount == 4) {
          colCount = 2;
        } else if (
          canvasItemCount == 3 ||
          canvasItemCount == 5 ||
          canvasItemCount == 6
        ) {
          colCount = 3;
        } else if (
          canvasItemCount == 7 ||
          canvasItemCount == 8 ||
          canvasItemCount == 9 ||
          canvasItemCount == 10 ||
          canvasItemCount == 11 ||
          canvasItemCount == 12
        ) {
          colCount = 4;
        } //if (canvasItemCount > 12)
        else {
          colCount = 5;
        }
      } else if (vm.displayMode === "pip") {
        if (canvasItemCount == 2 || canvasItemCount == 4) {
          colCount = 2;
        } else if (canvasItemCount == 3) {
          colCount = 3;
        }
      }
      $(":root").css("--canvas-cols", colCount);
    },

    setLeftCanvasRowColumn() {
      let canvas = document.querySelector("#ag-left-panel");
      let canvasItemCount = canvas.childNodes.length;

      $(":root").css("--left-canvas-rows", canvasItemCount);
    },

    setRightCanvasRowColumn() {
      let canvas = document.querySelector("#ag-left-panel");
      let canvasItemCount = canvas.childNodes.length;

      $(":root").css("--right-canvas-rows", canvasItemCount);
    },

    //async init() {
    //  try {
    //    alert("init");
    //    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    //    //handleSuccess(stream);
    //    alert(stream);
    //    //e.target.disabled = true;
    //  } catch (e) {
    //    //handleError(e);
    //  }
    //},
    openMicCamAccessPopup() {
      //$("#enableModalCenter").modal("show");
      $("#enableModalCenter").show();
      // Put variables in global scope to make them available to the browser console.
      //var video = document.querySelector("video");
      var constraints = (window.constraints = {
        audio: true,
        video: true,
      });
      //var errorElement = document.querySelector("#errorMsg");
      //navigator.mediaDevices
      //  .getUserMedia(constraints)
      //  .then(function () {
      //    vm.hasMicAccess = true;
      //    vm.hasCamAccess = true;
      //    alert("hasMicAccess:" + vm.hasMicAccess);
      //    alert("hasCamAccess:" + vm.hasCamAccess);
      //    //console.log(stream);
      //    //alert("stream:" + stream);
      //    //var videoTracks = stream.getVideoTracks();
      //    //console.log("Got stream with constraints:", constraints);
      //    //console.log("Using video device: " + videoTracks[0].label);
      //    //stream.onremovetrack = function () {
      //    //  console.log("Stream ended");
      //    //};
      //    //window.stream = stream; // make variable available to browser console
      //    //video.srcObject = stream;
      //  })
      //  .catch(function (error) {
      //    vm.hasMicAccess = false;
      //    vm.hasCamAccess = false;
      //    alert("error: hasMicAccess: " + vm.hasMicAccess);
      //    alert("error: hasCamAccess: " + vm.hasCamAccess);
      //    console.log(error);
      //    //alert("error:" + error);
      //    //if (error.name === "ConstraintNotSatisfiedError") {
      //    //  vm.errorMsg(
      //    //    "The resolution " +
      //    //      constraints.video.width.exact +
      //    //      "x" +
      //    //      constraints.video.height.exact +
      //    //      " px is not supported by your device."
      //    //  );
      //    //} else if (error.name === "PermissionDeniedError") {
      //    //  vm.errorMsg(
      //    //    "Permissions have not been granted to use your camera and " +
      //    //      "microphone, you need to allow the page access to your devices in " +
      //    //      "order for the demo to work."
      //    //  );
      //    //}
      //    //vm.errorMsg("getUserMedia error: " + error.name, error);
      //  });
      constraints = window.constraints = {
        audio: true,
        video: false,
      };
      //var errorElement = document.querySelector("#errorMsg");
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function () {
          vm.hasMicAccess = true;
          vm.micAccessChecked = true;
          //if (vm.DebugMode) {
          //  alert("hasMicAccess:" + vm.hasMicAccess);
          //}
        })
        .catch(function (error) {
          vm.hasMicAccess = false;
          vm.micAccessChecked = true;
          console.log(error);
          //if (vm.DebugMode) {
          //  alert("hasMicAccess: " + vm.hasMicAccess);
          //  alert("hasMicAccess error:" + error);
          //}
        });
      constraints = window.constraints = {
        audio: false,
        video: true,
      };
      //var errorElement = document.querySelector("#errorMsg");
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function () {
          vm.hasCamAccess = true;
          vm.camAccessChecked = true;
          //if (vm.DebugMode) {
          //  alert("hasCamAccess:" + vm.hasCamAccess);
          //}
        })
        .catch(function (error) {
          vm.hasCamAccess = false;
          vm.camAccessChecked = true;
          console.log(error);
          //if (vm.DebugMode) {
          //  alert("hasCamAccess: " + vm.hasCamAccess);
          //  alert("hasCamAccess error:" + error);
          //}
        });
    },
    openBrowserPermissionPopup() {
      //$("#allowModalCenter").modal("show");
      $("#allowModalCenter").show();
    },
    errorMsg(msg, error) {
      //alert(msg + ":" + error);
      //errorElement.innerHTML += '<p>' + msg + '</p>';
      if (typeof error !== "undefined") {
        console.error(error);
      }
    },
    applyMicCamAccess(allowMic, allowCam) {
      //$(".audioControlBtn").removeClass("off");
      if (allowMic) {
        $(".audioControlBtn").removeClass("off");
      } else {
        $(".audioControlBtn").addClass("off");
      }
      vm.isMicOn = allowMic;

      //$(".videoControlBtn").removeClass("off");
      if (allowCam) {
        $(".videoControlBtn").removeClass("off");
      } else {
        $(".videoControlBtn").addClass("off");
      }
      vm.isVideoOn = allowCam;

      vm.allowMic = allowMic;
      vm.allowCam = allowCam;
      //$("#enableModalCenter").modal("hide");
      $("#enableModalCenter").hide();
      vm.StartCall(
        vm.tempValues.clientId,
        vm.tempValues.eventId,
        vm.tempValues.channelName,
        vm.tempValues.sessionTypeId,
        vm.tempValues.session,
        vm.tempValues.roundTable,
        vm.tempValues.o2oMeeting,
        vm.tempValues.attendeeType,
        vm.tempValues.callSettings,
        vm.tempValues.exMeetingId,
        vm.tempValues.meetingHostId,
        1
      );
    },
    applyBrowserPermission() {
      //$("#allowModalCenter").modal("hide");
      $("#allowModalCenter").hide();
      vm.StartCall(
        vm.tempValues.clientId,
        vm.tempValues.eventId,
        vm.tempValues.channelName,
        vm.tempValues.sessionTypeId,
        vm.tempValues.session,
        vm.tempValues.roundTable,
        vm.tempValues.o2oMeeting,
        vm.tempValues.attendeeType,
        vm.tempValues.callSettings,
        vm.tempValues.exMeetingId,
        vm.tempValues.meetingHostId,
        2
      );
    },
    repairAllStreams() {
      vm.streamList.map((item) => {
        let uid = item.getId();
        let totalJoinedTime = 0;
        let speakers = vm.allSpeakers.filter((item) => {
          return item.AttendeeId == uid;
        });
        if (speakers.length > 0) {
          totalJoinedTime = speakers[0].TotalTime;
        }
        if (totalJoinedTime > 10000) {
          item.resume("ag-item-" + uid);
          vm.addUserProfile(uid, true);
        }
      });
      ////vm.removeStream(221000);
      ////setTimeout(() => {
      ////  vm.streamList.push(vm.localStream);
      ////}, 10000);
      //vm.streamList.map((item) => {
      //  let id = item.getId();
      //  console.log(id);
      //  ////let canvas = document.querySelector("#ag-canvas");
      //  ////canvas.removeChild(canvas.childNodes[0]);

      //  ////let video = document.getElementById("ag-item-" + id);
      //  ////if (video && video.children && video.children.length > 0) {
      //  ////  video.innerHTML = "";
      //  ////  video.removeAttribute("id");
      //  ////} else {
      //  ////  vm.arrangeVideoFrame();
      //  ////}
      //  ////item.resume("ag-item-" + id);
      //  //vm.removeStream(id);
      //  //item.close();
      //  item.stop();
      //  //let element = document.querySelector("#ag-item-" + id);
      //  //if (element) {
      //  //  element.parentNode.removeChild(element);
      //  //}
      //});
      //setTimeout(() => {
      //  vm.streamList = vm.streamList.filter(function () {
      //    return true;
      //  });
      //  //vm.addStream(vm.localStream);
      //  //vm.arrangeVideoFrame();
      //}, 100);
    },
    showException(uid, exceptionCode, errorMsg) {
      //console.log("uid:" + uid);
      //console.log("exceptionCode:" + exceptionCode);
      //console.log("errorMsg:" + errorMsg);
      //alert("errorMsg:" + errorMsg);
      let msg = "";
      if (exceptionCode) {
        msg += exceptionCode + ":";
      }
      if (errorMsg) {
        msg += errorMsg;
      }
      if (msg) {
        $("#player-network-error-" + uid).removeClass("d-none");
        $("#player-network-error-" + uid + " .ag-err-msg").html(msg);
        setTimeout(() => {
          $("#player-network-error-" + uid).addClass("d-none");
        }, 5000);
      }
      if (!exceptionCode && !errorMsg) {
        $("#player-network-error-" + uid).addClass("d-none");
      }
    },
    repairStream(uid, actionLabel) {
      if (actionLabel == "") {
        //console.log(actionLabel);
      }
      let streams = vm.streamList.filter(function (item) {
        return item.getId() == uid;
      });

      if (streams.length > 0) {
        let stream = streams[0];
        if (vm.advancedAutoRecovery) {
          if (uid == vm.uid) {
            //vm.localStream.camera.stream.stop(); // stop the camera stream playback
            //vm.localStream.camera.stream.close(); // clean up and close the camera stream

            //vm.client.unpublish(vm.localStream.camera.stream); // unpublish the camera stream

            vm.client.unpublish(vm.localStream, (err) => {
              console.log("Publish local stream error: " + err);
            });
            setTimeout(() => {
              vm.client.publish(vm.localStream, (err) => {
                console.log("Publish local stream error: " + err);
              });
              vm.arrangeVideoFrame();
            }, 1000);

            //setTimeout(() => {
            //  vm.streamList = vm.streamList.filter(function () {
            //    return true;
            //  });
            //}, 100);
          } else {
            vm.client.unsubscribe(stream, function (err) {
              console.log("Subscribe stream failed", err);
            });
            setTimeout(() => {
              vm.client.subscribe(stream, function (err) {
                console.log("Subscribe stream failed", err);
              });
              vm.arrangeVideoFrame();
            }, 1000);

            //setTimeout(() => {
            //  vm.streamList = vm.streamList.filter(function () {
            //    return true;
            //  });
            //}, 100);
          }
        } else {
          //alert("");
          stream.stop();
          setTimeout(() => {
            vm.streamList = vm.streamList.filter(function () {
              return true;
            });
          }, 100);
        }
        if (actionLabel != "") {
          vm.saveRepairLog(uid, actionLabel);
        }
      }
    },
    saveRepairLog(uid, actionLabel) {
      let logId = new Date().getTime().toString();
      let logObj = new Object({
        sessionId: vm.sessionId,
        roundTableId: vm.roundTableId,
        clientUserId: vm.uid,
        agoraUserId: uid,
        errorReason: actionLabel,
        CreatedDate: new Date(),
      });

      //.doc("GeneralSettings")
      //.collection("PlayerLog")
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("PlayerLog")
        .doc(logId)
        .set(logObj)
        .then(function () {
          //alert("Success");
        })
        .catch(function (error) {
          console.log(error);
          //alert("Failure");
        });
    },
    savePlayerStatusChangeLog(uid, isErrorState, status, mediaType, reason) {
      let logId = new Date().getTime().toString();
      let logObj = new Object({
        sessionId: vm.sessionId,
        roundTableId: vm.roundTableId,
        clientUserId: vm.uid,
        agoraUserId: uid,
        isErrorState: isErrorState,
        status: status,
        mediaType: mediaType,
        reason: reason,
        CreatedDate: new Date(),
      });

      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("PlayerStatusChangeLog")
        .doc(logId)
        .set(logObj)
        .then(function () {
          //alert("Success");
        })
        .catch(function (error) {
          console.log(error);
          //alert("Failure");
        });
    },
    repairProfile(interval) {
      //if (vm.DebugMode) {
      //  if (vm.localStream) {
      //    vm.localStream.getStats((stats) => {
      //      console.log(`Local Stream accessDelay: ${stats.accessDelay}`);
      //      if (stats.accessDelay) {
      //        //if (stats.accessDelay >= 200) {
      //        //  $("#player-network-error-" + vm.uid).html("Slow Network Detected");
      //        //  $("#player-network-error-" + vm.uid).removeClass("d-none");
      //        //} else {
      //        //  $("#player-network-error-" + vm.uid).addClass("d-none");
      //        //}
      //        if (stats.accessDelay <= 100) {
      //          $("#player-network-error-" + vm.uid).addClass("d-none");
      //        } else {
      //          $("#player-network-error-" + vm.uid).removeClass("d-none");
      //          if (stats.accessDelay > 100 && stats.accessDelay <= 200) {
      //            $("#player-network-error-" + vm.uid + " .ag-err-msg").html(
      //              "Poor Network Detected"
      //            );
      //          } else {
      //            $("#player-network-error-" + vm.uid + " .ag-err-msg").html(
      //              "Bad Network Detected"
      //            );
      //          }
      //        }
      //        $("#player-network-error-" + vm.uid).attr(
      //          "ul",
      //          stats.accessDelay
      //        );
      //        $("#profile-" + vm.uid + " .ag-ul").html(stats.accessDelay);
      //      }
      //      //console.log(`Local Stream audioSendBytes: ${stats.audioSendBytes}`);
      //      //console.log(
      //      //  `Local Stream audioSendPackets: ${stats.audioSendPackets}`
      //      //);
      //      //console.log(
      //      //  `Local Stream audioSendPacketsLost: ${stats.audioSendPacketsLost}`
      //      //);
      //      //console.log(`Local Stream videoSendBytes: ${stats.videoSendBytes}`);
      //      //console.log(
      //      //  `Local Stream videoSendFrameRate: ${stats.videoSendFrameRate}`
      //      //);
      //      //console.log(
      //      //  `Local Stream videoSendPackets: ${stats.videoSendPackets}`
      //      //);
      //      //console.log(
      //      //  `Local Stream videoSendPacketsLost: ${stats.videoSendPacketsLost}`
      //      //);
      //      //console.log(
      //      //  `Local Stream videoSendResolutionHeight: ${stats.videoSendResolutionHeight}`
      //      //);
      //      //console.log(
      //      //  `Local Stream videoSendResolutionWidth: ${stats.videoSendResolutionWidth}`
      //      //);
      //    });
      //  }
      //  vm.streamList.map(function (stream) {
      //    let uid = stream.getId();
      //    if (uid != vm.uid) {
      //      stream.getStats((stats) => {
      //        console.log(
      //          `${uid}: Remote Stream accessDelay: ${stats.accessDelay}`
      //        );
      //        if (stats.accessDelay) {
      //          if (stats.accessDelay <= 200) {
      //            $("#player-network-error-" + uid).addClass("d-none");
      //          } else {
      //            $("#player-network-error-" + uid).removeClass("d-none");
      //            if (stats.accessDelay > 200 && stats.accessDelay <= 400) {
      //              $("#player-network-error-" + uid + " .ag-err-msg").html(
      //                "Poor Network Detected"
      //              );
      //            } else {
      //              $("#player-network-error-" + uid + " .ag-err-msg").html(
      //                "Bad Network Detected"
      //              );
      //            }
      //          }
      //          $("#player-network-error-" + uid).attr("dl", stats.accessDelay);
      //          $("#profile-" + uid + " .ag-dl").html(stats.accessDelay);
      //        }
      //        //console.log(
      //        //  `Remote Stream audioReceiveBytes: ${stats.audioReceiveBytes}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream audioReceiveDelay: ${stats.audioReceiveDelay}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream audioReceivePackets: ${stats.audioReceivePackets}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream audioReceivePacketsLost: ${stats.audioReceivePacketsLost}`
      //        //);
      //        //console.log(`Remote Stream endToEndDelay: ${stats.endToEndDelay}`);
      //        //console.log(
      //        //  `Remote Stream videoReceiveBytes: ${stats.videoReceiveBytes}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceiveDecodeFrameRate: ${stats.videoReceiveDecodeFrameRate}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceiveDelay: ${stats.videoReceiveDelay}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceiveFrameRate: ${stats.videoReceiveFrameRate}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceivePackets: ${stats.videoReceivePackets}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceivePacketsLost: ${stats.videoReceivePacketsLost}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceiveResolutionHeight: ${stats.videoReceiveResolutionHeight}`
      //        //);
      //        //console.log(
      //        //  `Remote Stream videoReceiveResolutionWidth: ${stats.videoReceiveResolutionWidth}`
      //        //);
      //      });
      //    }
      //  });
      //}
      //if (vm.client) {
      //  vm.client.getTransportStats((stats) => {
      //    console.log(
      //      "OutgoingAvailableBandwidth:" + stats.OutgoingAvailableBandwidth
      //    );
      //    let outgoingVal = stats.OutgoingAvailableBandwidth
      //      ? stats.OutgoingAvailableBandwidth
      //      : 0;
      //    vm.networkType = stats.NetworkType ? stats.NetworkType : "";
      //    vm.outgoungBandwidth = parseInt(outgoingVal);

      //    $("#player-network-error-" + vm.uid).attr("ul", vm.outgoungBandwidth);

      //    //if (location.origin.startsWith("http://localhost")) {
      //      //if (vm.outgoungBandwidth < 100 || vm.incomingBandwidth < 100) {
      //        vm.saveNetworkLog(
      //          vm.networkType,
      //          vm.outgoungBandwidth,
      //          vm.incomingBandwidth
      //        );
      //      //}
      //    //}
      //  });
      //} else {
      //  vm.networkType = "";
      //  vm.outgoungBandwidth = 0;
      //}

      //if (window.navigator) {
      //  let downLink = window.navigator.connection.downlink;
      //  vm.incomingBandwidth = downLink * 1024;

      //  $("#player-network-error-" + vm.uid).attr("dl", vm.incomingBandwidth);

      //  //if (location.origin.startsWith("http://localhost")) {
      //    //if (vm.outgoungBandwidth < 100 || vm.incomingBandwidth < 100) {
      //      vm.saveNetworkLog(
      //        vm.networkType,
      //        vm.outgoungBandwidth,
      //        vm.incomingBandwidth
      //      );
      //    //}
      //  //}
      //}

      vm.client.getRemoteAudioStats((remoteAudioStatsMap) => {
        for (var uid in remoteAudioStatsMap) {
          let speakers = vm.allSpeakers.filter((item) => {
            return item.AttendeeId == uid;
          });
          if (speakers.length > 0) {
            speakers[0].IsAudioOn = remoteAudioStatsMap[uid].MuteState == 0;
            if (!speakers[0].TotalTime) {
              speakers[0].TotalTime = 0;
            }
            speakers[0].TotalTime += interval;
          }
        }
      });
      let latestShareId = 0;
      let shareDuration = 1000000000;
      vm.client.getRemoteVideoStats((remoteVideoStatsMap) => {
        for (var uid in remoteVideoStatsMap) {
          let speakers = vm.allSpeakers.filter((item) => {
            return item.AttendeeId == uid;
          });
          if (speakers.length > 0) {
            speakers[0].IsVideoOn = remoteVideoStatsMap[uid].MuteState == 0;
            //console.log(uid + ":" + remoteVideoStatsMap[uid].MuteState);
            //if (remoteVideoStatsMap[uid].MuteState == 0) {
            //  $("#profileImage_" + uid).addClass("d-none");
            //} else {
            //  $("#profileImage_" + uid).removeClass("d-none");
            //}
          }
          if (uid > vm.shareIdStartsAfter) {
            if (remoteVideoStatsMap[uid].TotalPlayDuration < shareDuration) {
              shareDuration = remoteVideoStatsMap[uid].TotalPlayDuration;
              latestShareId = uid;
            }
            console.log(uid + ":" + remoteVideoStatsMap[uid].TotalPlayDuration);
          }
        }
      });
      console.log("Latest Share:" + latestShareId);
      if (latestShareId != 0) {
        $("#ag-canvas").attr("shareid", latestShareId);
      }
      //let speakers = vm.allAttendees.filter((item) => {
      //  return item.AttendeeId == 221000;
      //});
      //if (speakers.length > 0) {
      //  alert(
      //    "IsAudioOn: " +
      //      speakers[0].IsAudioOn +
      //      "; IsVideoOn: " +
      //      speakers[0].IsVideoOn
      //  );
      //}
      //if (location.origin.startsWith("http://localhost")) {
      //  vm.repairStream(221000, "");
      //}

      let unmutedSpeakers = vm.allSpeakers.filter((speaker) => {
        return speaker.AttendeeId != vm.uid && speaker.IsAudioOn;
      });
      if (unmutedSpeakers.length > 0) {
        $(".ag-option-muteall").removeClass("disabled");
        $(".ag-option-mute-all").removeClass("disabled");
      } else {
        $(".ag-option-muteall").addClass("disabled");
        $(".ag-option-mute-all").addClass("disabled");
      }
      let mutedSpeakers = vm.allSpeakers.filter((speaker) => {
        return speaker.AttendeeId != vm.uid && speaker.IsAudioOn == false;
      });
      if (mutedSpeakers.length > 0) {
        $(".ag-option-unmuteall").removeClass("disabled");
      } else {
        $(".ag-option-unmuteall").addClass("disabled");
      }
    },
    saveNetworkLog(networkType, outgoungBandwidth, incomingBandwidth) {
      let logId = new Date().getTime().toString();
      let logObj = new Object({
        sessionId: vm.sessionId,
        roundTableId: vm.roundTableId,
        userId: vm.uid,
        networkType: networkType ? networkType : "",
        outgoungBandwidth: outgoungBandwidth ? outgoungBandwidth : 0,
        incomingBandwidth: incomingBandwidth ? incomingBandwidth : 0,
        CreatedDate: new Date(),
      });

      //.doc("GeneralSettings")
      //.collection("PlayerLog")
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("NetworkLog")
        .doc(logId)
        .set(logObj)
        .then(function () {
          //alert("Success");
        })
        .catch(function (error) {
          console.log(error);
          //alert("Failure");
        });
    },

    StartCall(
      clientId,
      eventId,
      channelName,
      sessionTypeId,
      session,
      roundTable,
      o2oMeeting,
      attendeeType,
      callSettings,
      exMeetingId,
      meetingHostId,
      callStep
    ) {
      vm.displayNextMeetingJoinLink = false;
      vm.enableNextMeetingJoinLink = false;
      vm.nextMeetingId = "";
      vm.nextMeetingAttendeeName = "";
      vm.nextMeetingAttendeeInitial = "";
      vm.nextMeetingAttendeeProfilePictureURL = "";
      //if (!callStep) {
      //  vm.IsLive = true;
      //  vm.IsGoLive = false;
      //  vm.inProcess = false;
      //  vm.readyState = true;
      //  vm.changePlayerStatus(1);
      //  vm.$emit("livePanelOnStart");
      //  return;
      //}
      //alert("StartCall:"+callStep);
      $('[data-toggle="tooltip"]').tooltip();
      vm.sessionTypeId = sessionTypeId;
      vm.attendeeType = attendeeType;
      vm.outgoungBandwidth = vm.minOutgoungBandwidth;
      vm.incomingBandwidth = vm.minIncomingBandwidth;
      //alert(vm.enableDeviceAccessibility);
      //alert(attendeeType);
      if (!callStep) {
        vm.allHosts = [];
        vm.allCoHosts = [];
        vm.allSpeakers = [];
        vm.switchTableVisible = false;
        vm.recordingStarted = false;
        if (sessionTypeId == 3) {
          if (session) {
            vm.allHosts = session.MappedHosts;
            vm.allCoHosts = session.MappedCoHosts;
            vm.allSpeakers = session.MappedSpeakers;
          }
        } else if (sessionTypeId == 4) {
          if (roundTable) {
            vm.allHosts = roundTable.Host;
            vm.allCoHosts = roundTable.CoHost ? [roundTable.CoHost] : [];
          }
        }
        //if (
        //  (sessionTypeId == 3 || sessionTypeId == 4) &&
        //  (attendeeType == 1 || vm.isUserCoHost(vm.uid)) &&
        //  vm.endForAllEnabled
        //) {
        //  vm.restoreSession(session, roundTable);
        //}
        if (goLiveTimer) {
          clearInterval(goLiveTimer);
        }
        vm.IsLive = true;
        vm.IsGoLive = false;
        if (channelName.includes("_gr")) {
          vm.IsLive = false;
          //alert("Back Stage");
          vm.startGoLiveTimer();
        }
        vm.tempValues = {
          clientId: clientId,
          eventId: eventId,
          channelName: channelName,
          sessionTypeId: sessionTypeId,
          session: session,
          roundTable: roundTable,
          o2oMeeting: o2oMeeting,
          attendeeType: attendeeType,
          callSettings: callSettings,
          exMeetingId: exMeetingId,
          meetingHostId: meetingHostId,
        };
      }
      if (vm.enableDeviceAccessibility && attendeeType < 4) {
        if (!callStep) {
          callStep = 0;
        }
        if (callStep == 0) {
          vm.micAccessChecked = false;
          vm.camAccessChecked = false;
          vm.tempValues = {
            clientId: clientId,
            eventId: eventId,
            channelName: channelName,
            sessionTypeId: sessionTypeId,
            session: session,
            roundTable: roundTable,
            o2oMeeting: o2oMeeting,
            attendeeType: attendeeType,
            callSettings: callSettings,
            exMeetingId: exMeetingId,
            meetingHostId: meetingHostId,
          };
          vm.openMicCamAccessPopup();
          return;
        } else if (callStep == 1) {
          if (
            (vm.IsCameraExist && vm.allowCam && !vm.hasCamAccess) ||
            (vm.IsMicExist && vm.allowMic && !vm.hasMicAccess)
          ) {
            vm.tempValues = {
              clientId: clientId,
              eventId: eventId,
              channelName: channelName,
              sessionTypeId: sessionTypeId,
              session: session,
              roundTable: roundTable,
              o2oMeeting: o2oMeeting,
              attendeeType: attendeeType,
              callSettings: callSettings,
              exMeetingId: exMeetingId,
              meetingHostId: meetingHostId,
            };
            vm.openBrowserPermissionPopup();
            return;
          }
        }
      }
      if (streamRepairTimer) {
        clearInterval(streamRepairTimer);
      }
      if (ProfileRepairTimer) {
        clearInterval(ProfileRepairTimer);
      }
      if (ReConnectCallTimer) {
        clearInterval(ReConnectCallTimer);
      }
      // if (vm.DebugMode && vm.autoRecovery && vm.advancedAutoRecovery) {
      //   //alert("autoRecovery");
      //   setTimeout(() => {
      //     streamRepairTimer = setInterval(function () {
      //       vm.repairAllStreams();
      //     }, 10000);
      //   }, 10000);
      // }
      setTimeout(() => {
        ProfileRepairTimer = setInterval(function () {
          vm.repairProfile(5000);
        }, 2000);
      }, 5000);

      //alert("channelName:" + channelName);
      //vm.init();
      let waitTime = 1;
      let flag = false;
      if (vm.readyState && vm.sessionId != "") {
        if (session) {
          if (vm.sessionId != session.SessionId) {
            flag = true;
            //alert("End And Start");
          } else {
            //if (vm.sessionTypeId == vm.LivePanelTypeID) {
            //  flag = true;
            //} else
            if (vm.sessionTypeId == vm.RoundTableTypeID) {
              if (vm.roundTableId != "") {
                if (roundTable && vm.roundTableId != roundTable.TableId) {
                  flag = true;
                  //alert("End And Start");
                } else {
                  return;
                }
              }
            }
          }
        }
      }
      if (flag) {
        waitTime = 2000;
        vm.$emit("livePanelOnBeforeStart");
        vm.onEndCall();
      }
      vm.inProcess = true;
      //alert(waitTime);
      debugger;
      setTimeout(() => {
        vm.playerWaitText = "Please wait, stage will be live soon...";
        //"42001",Dipesh
        //"221000",Debashis
        //"221001",Kuntal
        //"191000",Aditi
        //"191001",Anirban
        //"422037",Rajeshwar
        //"422048",Sayak
        //"191010",Somnath
        //"421030",Pankaj
        //"191002",Debottam
        //"42012",Victor
        //"1556000",Pravakar
        //"99901500",Dipesh

        //MOVE IT TO LOG START LISTENER
        //vm.logUserIDs = ["42001", "221000", "221001", "191000", "99901500"];
        //vm.logUserIDs = [
        //  "221000",
        //  "191000",
        //  "191001",
        //  "422037",
        //  "422048",
        //  "191010",
        //];
        //vm.playerLog.initRTM(channelName, vm.uid, vm.logRecipientId);

        vm.playerLogo = "";
        vm.playerLogoLink = "";
        if (callSettings) {
          vm.playerLogo = callSettings.playerLogo
            ? callSettings.playerLogo
            : "";
          vm.playerLogoLink = callSettings.playerLogoLink
            ? callSettings.playerLogoLink
            : "";
        }
        if (vm.sessionTypeId == 4) {
          $("#viewCountWrap").hide();
          vm.viewersCountVisible = false;
          vm.displayViewersCount(false);
        }
        console.log(channelName);
        //alert(channelName);
        vm.userType = attendeeType;
        vm.clientId = clientId;
        vm.eventId = eventId;
        vm.channelName = channelName;
        vm.sessionTypeId = sessionTypeId;
        vm.localStreamVolume = 0;
        vm.session = session == undefined ? null : session;
        vm.roundTable = roundTable == undefined ? null : roundTable;
        vm.o2oMeeting = o2oMeeting == undefined ? null : o2oMeeting;
        vm.exMeetingId = exMeetingId;

        vm.AllowScreenShare = false;
        vm.AllowRecording = false;
        vm.AutoStartRecording = false;
        vm.AllowPinVideoTile = true;
        //if (vm.sessionVideoProfile != "") {
        //  vm.videoProfile = vm.sessionVideoProfile;
        //}
        if (vm.sessionTypeId == vm.LivePanelTypeID) {
          vm.sessionId = session.SessionId;
          vm.allHosts = session.MappedHosts;
          vm.allCoHosts = session.MappedCoHosts;
          vm.allSpeakers = session.MappedSpeakers;
          let hosts = vm.allHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
          if (hosts.length > 0) {
            vm.userType = 1;
          } else {
            let speakers = vm.allSpeakers.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (speakers.length > 0) {
              vm.userType = 2;
            }
          }

          vm.AllowScreenShare = true;
          vm.AllowRecording = true;
          //vm.AutoStartRecording = true;
          if (callSettings) {
            //vm.AllowScreenShare = callSettings.AllowScreenShare;
            //vm.AllowRecording = callSettings.AllowRecording;
            vm.AutoStartRecording = callSettings.AutoStartRecording;
          }
        } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          //vm.videoProfile = "360p_1";
          //vm.AllowPinVideoTile = false;
          if (session) {
            vm.sessionId = session.SessionId;
          }
          vm.roundTableId = roundTable.TableId;
          vm.allHosts = roundTable.Host;
          vm.allCoHosts = roundTable.CoHost ? [roundTable.CoHost] : [];
          vm.allSpeakers = roundTable.MappedAttendees;
          let hosts = vm.allHosts.filter(function (item) {
            return item.AttendeeId == vm.uid;
          });
          if (hosts.length > 0) {
            vm.userType = 1;
          } else {
            let speakers = vm.allSpeakers.filter(function (item) {
              return item.AttendeeId == vm.uid;
            });
            if (speakers.length > 0) {
              vm.userType = 3;
            }
          }
          if (vm.userType == 4 && vm.roundTable.AvailSeatType == 3) {
            vm.userType = 3;
          }
          if (session) {
            $("#pHeaderSessionName").html(
              session.Name + " (" + roundTable.Name + ")"
            );
            $("#pHeaderSessionName").attr(
              "title",
              session.Name + " (" + roundTable.Name + ")"
            );
            $("#menuSessionInfo p").html(
              session.Name + " (" + roundTable.Name + ")"
            );
          } else {
            $("#pHeaderSessionName").html(roundTable.Name);
            $("#pHeaderSessionName").attr("title", roundTable.Name);
            $("#menuSessionInfo p").html(roundTable.Name);
          }
          //$('[data-toggle="tooltip"]').tooltip();
          if (callSettings) {
            vm.AllowScreenShare = callSettings.AllowScreenShare;
            vm.AllowRecording = callSettings.AllowRecording;
            vm.AutoStartRecording = callSettings.AutoStartRecording;
          }
        } else if (vm.sessionTypeId == vm.O2OTypeID) {
          vm.AllowScreenShare = true;
        } else if (vm.sessionTypeId == vm.E2OTypeID) {
          vm.AllowScreenShare = true;
          vm.meetingHostId = meetingHostId;
          //alert(vm.userType);
          //vm.userType = 1;
        } else {
          vm.userType = 4;
        }
        if (vm.roomId) {
          vm.userType = 1;
        }
        //alert("vm.userType : " + vm.userType);
        //if (vm.userType == 1 || vm.userType == 2 || vm.userType == 3) {
        //  vm.attendeeMode = "video";
        //} else {
        //  vm.attendeeMode = "audience";
        //}
        //alert("vm.attendeeMode : " + vm.attendeeMode);
        let justSkip = true;
        if (justSkip) {
          //return;
        }
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj != undefined && obj != null) {
          if (location.origin.startsWith("http://localhost")) {
            //vm.uid = Math.random().toString().substring(3, 12); //this.getUrlParameter("uid");
          }
          //vm.uid = 2147483647; //"debashis_" + Math.random().toString().substring(3, 12); //this.getUrlParameter("uid");
          vm.activeScreenUID = vm.uid;
          //alert("activeScreenUID:" + vm.activeScreenUID);
          //alert(vm.uid);
          //if (vm.uid == "221000") {
          //  vm.attendeeMode = "audience";
          //}

          if (
            obj.eventcollectionname != undefined &&
            obj.eventcollectionname != ""
          ) {
            Cookies.set("id", vm.uid);
            Cookies.set("baseMode", "avc");
            Cookies.set("transcode", "interop");
            Cookies.set("attendeeMode", "video");
            //Cookies.set("videoProfile", "480p_1");
            //Cookies.set("videoProfile", "480p_1");

            //Cookies.set("id", vm.uid);
            //Cookies.set("channel", "channel");
            //Cookies.set("baseMode", "avc");
            //Cookies.set("transcode", "interop");
            //Cookies.set("attendeeMode", "video");
            //Cookies.set("videoProfile", "480p_1");
            //alert("vm.enableLogUpload:" + vm.enableLogUpload);
            //alert("vm.uploadLogLevel:" + vm.uploadLogLevel);
            if (vm.enableLogUpload) {
              AgoraRTC.Logger.enableLogUpload();
              if (vm.uploadLogLevel == "DEBUG") {
                AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.DEBUG);
              } else if (vm.uploadLogLevel == "INFO") {
                AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.INFO);
              } else if (vm.uploadLogLevel == "WARNING") {
                AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.WARNING);
              } else if (vm.uploadLogLevel == "ERROR") {
                AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.ERROR);
              } else if (vm.uploadLogLevel == "NONE") {
                AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.NONE);
              } else {
                AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.ERROR);
              }
            }
            vm.validateDevices();

            //vm.channelName = "debashis";
            var token = "";
            //Video Token generation
            let headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + vm.getSessionToken(),
            };
            var requestData = {
              app: {
                id: vm.liveVideoApiDetails.AppID.toString(),
                certificate: vm.liveVideoApiDetails.Certificate.toString(),
              },
              channelName: vm.channelName.toString(),
              userId: 0,
              validityHours: parseInt(
                vm.liveVideoApiDetails.TokenValidityHours
              ),
            };
            //if (!vm.IsMicExist || !vm.hasMicAccess) {
            //  vm.attendeeMode == "audience";
            //  vm.userType = 4;
            //}
            axios
              .post(vm.liveVideoApiDetails.SpeakerTokenApiUrl, requestData, {
                headers: headers,
              })
              .then((responseData) => {
                let data = responseData.data;
                console.log(data);
                if (typeof data != "undefined") {
                  //self.hideLoader();
                  let lStatusCode = 0;
                  lStatusCode = data.status;
                  if (lStatusCode == 0) {
                    token = data.token;
                    vm.token = token;
                    vm.client = AgoraRTC.createClient({
                      mode: vm.transcode,
                      codec: "vp8",
                    });

                    if (vm.EnableAgoraProxy) {
                      vm.client.startProxyServer(3);
                    }
                    vm.client.init(
                      vm.liveVideoApiDetails.AppID,
                      () => {
                        //vm.client.init(vm.appId, () => {
                        //vm.getPlayerSettings();
                        console.log("AgoraRTC client initialized");

                        vm.client.enableAudioVolumeIndicator();
                        vm.subscribeStreamEvents();

                        //vm.client.on("volume-indicator", function (evt) {
                        //  //console.log("Sound Coming");
                        //  //alert(evt.attr.length);
                        //  evt.attr.forEach(function (volume) {
                        //    alert(volume);
                        //    //console.log(
                        //    //  "Sound wave coming: " +
                        //    //    volume.uid +
                        //    //    " Volume Level:" +
                        //    //    volume.level
                        //    //);
                        //    //if (!$("#player_" + volume.uid).hasClass("active-speaker")) {
                        //    //  $("#player_" + volume.uid).addClass("active-speaker");
                        //    //}
                        //    //if (volume.level > 10) {
                        //    //  $("#player_" + volume.uid + " span.speaker-wave > img").attr(
                        //    //    "src",
                        //    //    "images/volume-indicator.gif"
                        //    //  );
                        //    //} else {
                        //    //  //$("#player_"+volume.uid).removeClass('active-speaker');
                        //    //  $("#player_" + volume.uid + " span.speaker-wave > img").attr(
                        //    //    "src",
                        //    //    "images/volume-indicator-pause.png"
                        //    //  );
                        //    //}
                        //  });
                        //});
                        //alert(vm.attendeeMode);
                        if (vm.attendeeMode == "audience") {
                          vm.client.setClientRole(
                            "audience",
                            function () {
                              //console.log('Client role set to audience');
                            },
                            function (e) {
                              console.log("setClientRole failed", e);
                            }
                          );
                        } else {
                          vm.client.setClientRole(
                            "host",
                            function () {
                              //console.log('Client role set to audience');
                            },
                            function (e) {
                              console.log("setClientRole failed", e);
                            }
                          );
                        }
                        //alert(vm.channelName);
                        let id = parseInt(vm.uid);
                        vm.client.join(
                          token,
                          vm.channelName,
                          id,
                          (uid) => {
                            //vm.client.join(token, vm.channelName, vm.uid, (uid) => {
                            vm.getRecordingParamFromFirebase();
                            //vm.client.join(vm.appId, vm.channelName, vm.uid, (uid) => {
                            //vm.client.join(token, vm.channelName, vm.uid, (uid) => {
                            //client.join(token, channelName, 0, function(uid) {
                            console.log(
                              "User " + uid + " join channel successfully"
                            );
                            console.log(
                              "At " + new Date().toLocaleTimeString()
                            );
                            // create local stream
                            // It is not recommended to setState in function addStream
                            //alert(vm.attendeeMode);
                            if (vm.attendeeMode !== "audience") {
                              if (vm.IsCameraExist || vm.IsMicExist) {
                                if (vm.rememberSettings) {
                                  if (Cookies.get("videoProfile")) {
                                    vm.videoProfile =
                                      Cookies.get("videoProfile");
                                    vm.videoResolution =
                                      Cookies.get("videoProfile");
                                  }
                                }
                                vm.localStream = vm.streamInit(
                                  uid,
                                  vm.attendeeMode,
                                  vm.videoProfile
                                );
                                vm.localStream.init(
                                  () => {
                                    if (vm.attendeeMode !== "audience") {
                                      vm.addStream(vm.localStream, true);
                                      //alert("Success")
                                      vm.client.publish(
                                        vm.localStream,
                                        (err) => {
                                          console.log(
                                            "Publish local stream error: " + err
                                          );
                                        }
                                      );
                                    }
                                    vm.inProcess = false;
                                  },
                                  (err) => {
                                    console.log("getUserMedia failed", err);
                                    //alert("getUserMedia failed	" + err.info);
                                    vm.takeActionOnDeviceError(err);
                                    vm.readyState = true;
                                    vm.inProcess = false;
                                  }
                                );
                              } else {
                                if (!vm.IsCameraExist) {
                                  $(".videoControlBtn").addClass("off");
                                  vm.handleVideo();
                                }
                                if (!vm.IsMicExist) {
                                  $(".audioControlBtn").addClass("off");
                                  vm.handleAudio();
                                }
                              }
                            } else {
                              vm.inProcess = false;
                            }
                            vm.readyState = true;
                            vm.changePlayerStatus(1);
                            vm.$emit("livePanelOnStart");
                          },
                          function (err) {
                            console.log("client init failed: ", err);
                            // Error handling
                          }
                        );
                      },
                      function (err) {
                        console.log("client init failed: ", err);
                        // Error handling
                      }
                    );

                    console.log("Get Encrypt URL API Call Success");
                  } else {
                    //self.hideLoader();
                    alert("Error initiating video call. Please retry. ");
                  }
                } else {
                  //self.hideLoader();
                  alert("Error initiating video call. Please retry. ");
                }
              })
              .catch(function (error) {
                console.error("Error on Get Token: ", error);
                //alert("Error initiating video call. Please retry. ");
              });
          }
        }
      }, waitTime);
    },

    saveCallSettings(key, value) {
      if (key && value) {
        Cookies.set(key, value);
      }
    },
    getCallSettings(key) {
      let result = "";
      if (key) {
        if (Cookies.get(key)) {
          result = Cookies.get(key);
        }
      }
      return result;
    },

    startGoLiveTimer() {
      if (goLiveTimer) {
        clearInterval(goLiveTimer);
      }
      goLiveTimer = setInterval(function () {
        if (vm.session) {
          if (
            vm.session.SessionStartTime <= parseInt(new Date().getTime() / 1000)
          ) {
            if (goLiveTimer) {
              clearInterval(goLiveTimer);
              vm.IsGoLive = true;
            }
          }
        }
      }, 1000);
    },

    GoLive() {
      //location.reload();
      vm.$emit("goLive", vm.sessionId);
    },

    takeActionOnDeviceError(err) {
      if (err.type == "error") {
        //alert(err.msg);
        alert("Media Error: (" + err.msg + " : " + err.info + ")");
        switch (err.msg) {
          case "NotAllowedError":
            //alert("Camera not allowed");
            //alert("Please allow your camera and try again");
            break;
          case "MEDIA_NOT_SUPPORT":
            //alert("Media not supported");
            break;
          case "NotFoundError":
            //alert("Media not found");
            break;
          default:
            break;
        }
      }
    },

    AttendeeCount() {
      return vm.allAttendees.length;
    },

    streamInit(uid, attendeeMode, videoProfile, config) {
      let defaultConfig = {
        streamID: uid,
        audio: true,
        video: true,
        screen: false,
      };
      switch (attendeeMode) {
        case "audio-only":
          defaultConfig.video = false;
          break;
        case "audience":
          defaultConfig.video = false;
          defaultConfig.audio = false;
          break;
        case "share":
          defaultConfig.video = false;
          defaultConfig.audio = false;
          defaultConfig.screen = true;
          defaultConfig.screenAudio = true;
          break;
        default:
        case "video":
          //vm.hasMicAccess && !vm.hasCamAccess
          //vm.allowMic = allowMic;
          //vm.allowCam = allowCam;
          if (!vm.IsCameraExist && !vm.IsMicExist) {
            alert(vm.$t("agoracall.bothmicandcameranotavilable"));
            //console.log("Streaming without both video and audio");
            defaultConfig.video = false;
            defaultConfig.audio = false;
          } else {
            if (!vm.IsMicExist || !vm.allowMic || !vm.hasMicAccess) {
              defaultConfig.audio = false;
            }
            if (!vm.IsCameraExist || !vm.hasCamAccess) {
              defaultConfig.video = false;
            }
            if (
              vm.allowMic ||
              vm.allowCam ||
              !vm.hasMicAccess ||
              !vm.hasCamAccess
            ) {
              if (
                vm.allowCam &&
                (!vm.IsCameraExist || !vm.hasCamAccess) &&
                vm.IsMicExist
              ) {
                console.log("Streaming without video");
                alert(
                  "Camera is not available. You are joining without your video."
                );
                //defaultConfig.video = false;
              } else if (
                vm.allowMic &&
                (!vm.IsMicExist || !vm.hasMicAccess) &&
                vm.IsCameraExist
              ) {
                //console.log("Streaming without audio");
                alert(
                  "Mic is not available. You are joining without your audio."
                );
                //defaultConfig.audio = false;
              }
            }
          }
          break;
      }
      let stream = AgoraRTC.createStream(merge(defaultConfig, config));
      //alert(videoProfile);
      stream.setVideoProfile(videoProfile);
      return stream;
    },

    subscribeStreamEvents() {
      let rt = this;
      //alert("subscribeStreamEvents");
      rt.client.on("stream-added", function (evt) {
        //alert("stream-added");
        let stream = evt.stream;
        let id = stream.getId();
        //alert("stream-added:" + id);
        if (id > vm.shareIdStartsAfter) {
          //alert("stream-added:" + id);
          if (vm.PinShareScreen) {
            vm.activeScreenUID = stream.getId();
            vm.displayMode = "pip";
            vm.pinSelected = true;
          }
        }
        //alert("stream-added: " + evt.stream.getId());
        //alert(vm.volumeLevel);
        if (vm.shareUid == id) {
          stream.setAudioVolume(0);
        } else {
          stream.setAudioVolume(vm.volumeLevel);
          //vm.stopShareScreen(true);
        }
        //alert("stream-added: " + stream.getId());
        console.log("New stream added: " + stream.getId());
        console.log("At " + new Date().toLocaleTimeString());
        console.log("Subscribe ", stream);
        if (!vm.pinSelected) {
          //alert(vm.streamList.length);
          if (vm.streamList.length == 0) {
            vm.activeScreenUID = stream.getId();
          }
        }

        //let id = stream.getId();
        rt.client.subscribe(stream, function (err) {
          console.log("Subscribe stream failed", err);
        });
        //rt.client.enableAudioVolumeIndicator(stream, function (err) {
        //  console.log("Subscribe stream failed", err);
        //  alert("enableAudioVolumeIndicator");
        //});
      });

      rt.client.on("stream-published", function (evt) {
        console.log(evt);
        //alert("stream-published:" + evt.stream.userId);
        //alert("stream-published:" + evt.stream.getId());
        //let id = evt.stream.getId();
        //alert("stream-published:" + id);
        //if (id > vm.shareIdStartsAfter) {
        //  //alert("stream-published:" + id);
        //  if (vm.PinShareScreen) {
        //    vm.displayMode = "pip";
        //  }
        //}
        //alert("Me");
        vm.handleVideo();
        vm.handleAudio();

        if (!vm.IsCameraExist || !vm.allowCam) {
          $(".videoControlBtn").addClass("off");
          vm.handleVideo();
        }
        if (!vm.IsMicExist) {
          $(".audioControlBtn").addClass("off");
          vm.handleAudio();
        }
        //alert("vm.uid:" + vm.uid);
        //setTimeout(() => {
        //  //vm.injectStream();
        //  vm.startLiveStream();
        //  //vm.startLStream();
        //}, 5000);
        if (
          vm.attendeeType == 1 &&
          vm.AllowRecording &&
          vm.AutoStartRecording
        ) {
          setTimeout(() => {
            vm.tryAutoStartRecording();
          }, 1000);
        }
      });

      //live transcoding events..
      rt.client.on("liveStreamingStarted", function (evt) {
        //alert("Live streaming started");
        console.log("Live streaming started" + evt);
      });

      rt.client.on("liveStreamingFailed", function (evt) {
        //alert("Live streaming failed" + evt);
        console.log("Live streaming failed" + evt);
      });

      rt.client.on("liveStreamingStopped", function (evt) {
        console.log("Live streaming stopped" + evt);
        //alert("Live streaming stopped" + evt);
      });

      rt.client.on("liveTranscodingUpdated", function (evt) {
        console.log("Live streaming updated" + evt);
        //alert("Live streaming updated" + evt);
      });

      rt.client.on("streamInjectedStatus", function (e) {
        //alert("streamInjectedStatus");
        console.log(e);
      });

      rt.client.on("peer-online", function (evt) {
        //alert("peer-online:" + evt.uid);
        vm.showException(evt.uid, "", "");
        console.log(evt);
      });

      rt.client.on("reconnect", function () {
        //alert("reconnect");
        console.log("reconnect");
      });

      rt.client.on("network-type-changed", function (evt) {
        //alert("network-type-changed");
        //alert("Me")
        console.log("network-type-changed:" + evt);
        //console.log("network-type-changed:" + evt.networkType);
      });

      rt.client.on("stream-removed", function (evt) {
        //alert("stream-removed:" + evt.uid);
        //alert(evt.uid + "stream-removed:" + vm.inProcess);
        if (vm.inProcess) {
          rt.removeStream(evt.uid);
        } else {
          if (vm.displayNetworkError) {
            vm.showException(evt.uid, "", "Connecting...");
          }
          //setTimeout(() => {
          rt.removeStream(evt.uid);
          //}, 10);
        }
      });

      rt.client.on("peer-leave", function (evt) {
        if (vm.activeScreenUID == evt.uid) {
          vm.activeScreenUID = 0;
        }
        //alert("peer-leave:" + evt.uid);
        if (evt.uid > vm.shareIdStartsAfter) {
          //alert("peer-leave:" + evt.uid);
          let shareScreens = vm.streamList.filter(function (item) {
            let id = item.getId();
            return id > vm.shareIdStartsAfter && id != evt.uid;
          });
          if (vm.PinShareScreen) {
            if (shareScreens.length == 0) {
              vm.displayMode = "tile";
              vm.pinSelected = false;
            } else {
              vm.activeScreenUID = shareScreens[0].getId();
              if (vm.activeScreenUID == vm.shareUid) {
                //alert("start rec layout:" + vm.activeScreenUID);
                vm.updateRecordingLayout(true);
              }
            }
          }
        }
        console.log("Peer has left: " + evt.uid);
        console.log(new Date().toLocaleTimeString());
        console.log(evt);
        if (vm.inProcess) {
          rt.removeStream(evt.uid);
        } else {
          if (vm.displayNetworkError) {
            vm.showException(evt.uid, "", "Connecting...");
          }
          //alert(evt.uid + "peer-leave:" + vm.inProcess);
          //setTimeout(() => {
          rt.removeStream(evt.uid);
          //}, 10);
        }
      });

      rt.client.on("stream-subscribed", function (evt) {
        //alert("stream-subscribed");
        let stream = evt.stream;
        let uid = stream.getId();
        //alert("stream-subscribed" + stream.getId());
        //alert("stream-subscribed:" + stream.getId());
        console.log("Got stream-subscribed event");
        console.log(new Date().toLocaleTimeString());
        console.log("Subscribe remote stream successfully: " + stream.getId());
        console.log(evt);
        //if(stream.getId()==vm.uid)
        //{
        //alert("Me subscribed");
        //}
        rt.addStream(stream);
        //let id = stream.getId();
        stream.on("player-status-change", function (e) {
          let msg =
            "isErrorState: " +
            e.isErrorState +
            ", status: " +
            e.status +
            ", mediaType: " +
            e.mediaType +
            ", reason: " +
            e.reason;
          console.log(msg);
          if (vm.DebugMode) {
            // if (e.isErrorState && vm.displayNetworkError) {
            //   vm.showException(uid, "", msg);
            // }
            //alert(msg);
            if (e.isErrorState) {
              vm.savePlayerStatusChangeLog(
                uid,
                e.isErrorState,
                e.status,
                e.mediaType,
                e.reason
              );
              if (e.status === "paused") {
                let errorCode = "isErrorState:true;status:paused";
                let err = streamError[errorCode];
                let msg = "Retrying to connect...";
                if (err) {
                  msg = err.msg;
                }
                console.log(msg);
                if (vm.displayNetworkError) {
                  vm.showException(uid, "", msg);
                }
                console.error(
                  `Stream is paused unexpectedly. Trying to resume...`
                );
                stream
                  .resume()
                  .then(function () {
                    console.log(`Stream is resumed successfully`);
                    //vm.addUserProfile(uid, true);
                  })
                  .catch(function (er) {
                    console.error(
                      `Failed to resume stream. Error ${er.name} Reason ${er.message}`
                    );
                  });
                //setTimeout(() => {
                //  vm.applyMic();
                //}, 2000);
                //setTimeout(() => {
                //  vm.applyCamera();
                //}, 3000);
              }
            } else {
              vm.showException(uid, "", "");
            }
          }
        });
      });

      rt.client.on("mute-video", function (evt) {
        let uid = evt.uid;
        //alert("mute-video:" + uid);
        console.log(evt);
        setTimeout(() => {
          $("#profileImage_" + uid).removeClass("d-none");
        }, 200);
      });

      rt.client.on("unmute-video", function (evt) {
        //alert("unmute-video");
        //let stream = evt.stream;

        //console.log(evt);
        let uid = evt.uid;
        $("#profileImage_" + uid).addClass("d-none");
      });

      rt.client.on("mute-audio", function (evt) {
        vm.micMuteUnmuteInProcess = true;
        //alert("mute-audio");
        //console.log(evt);
        $("#audio-indicator-" + evt.uid)
          .removeClass("sound-unmuted")
          .removeClass("sound-talking")
          .addClass("sound-muted");

        if (vm.hostOptionsEnabled && vm.hostCanMuteSpeaker) {
          $("#ag-option-mute-" + evt.uid + " .ag-option-icon")
            .removeClass("ag-mute")
            .addClass("ag-unmute");
          $("#ag-option-mute-" + evt.uid + " .ag-option-label").html(
            "Request to unmute"
          );
        }
        vm.micMuteUnmuteInProcess = false;
      });

      rt.client.on("unmute-audio", function (evt) {
        vm.micMuteUnmuteInProcess = true;
        //alert("unmute-audio");
        console.log(evt);
        $("#audio-indicator-" + evt.uid)
          .removeClass("sound-muted")
          .removeClass("sound-talking")
          .addClass("sound-unmuted");

        if (vm.hostOptionsEnabled && vm.hostCanMuteSpeaker) {
          $("#ag-option-mute-" + evt.uid + " .ag-option-icon")
            .removeClass("ag-unmute")
            .addClass("ag-mute");
          $("#ag-option-mute-" + evt.uid + " .ag-option-label").html("Mute");
        }
        vm.micMuteUnmuteInProcess = false;
      });

      rt.client.on("player-status-change", function (evt) {
        //alert("player-status-change");
        //alert("Me")
        console.log(evt);
      });

      rt.client.on("connection-state-change", function (evt) {
        //alert("connection-state-change: " + evt.prevState + "/" + evt.curState);
        if (vm.displayNetworkError) {
          if (evt.curState == "CONNECTING") {
            //alert(evt.curState);
            vm.showException(vm.uid, "", evt.curState);
          } else if (evt.curState == "CONNECTED") {
            //alert(evt.curState);
            vm.showException(vm.uid, "", "");
          } else if (evt.curState == "DISCONNECTING") {
            //alert(evt.curState);
            vm.showException(vm.uid, "", evt.curState);
          } else if (evt.curState == "DISCONNECTED") {
            //alert(evt.curState);
            vm.showException(vm.uid, "", evt.curState);
            if (ReConnectCallTimer) {
              clearInterval(ReConnectCallTimer);
            }
            // setTimeout(() => {
            //   ProfileRepairTimer = setInterval(function () {
            //     alert(vm.inProcess)
            //     alert(vm.readyState)
            //     if(!vm.inProcess && !vm.readyState) {
            //       vm.ReConnectCall();
            //       if (ReConnectCallTimer) {
            //         clearInterval(ReConnectCallTimer);
            //       }
            //     }
            //   }, 2000);
            // }, 5000);
            // setTimeout(() => {
            //   if(!vm.inProcess && !vm.readyState) {
            //     vm.ReConnectCall();
            //   } else {
            //     setTimeout(() => {
            //       if(!vm.inProcess && !vm.readyState) {
            //         vm.ReConnectCall();
            //       }
            //     }, 5000);
            //   }
            // }, 5000);
          } else {
            //alert("OTHERS: " + evt.curState);
            //vm.showException(vm.uid, "", evt.curState);
          }
        }
        console.log(evt.prevState, evt.curState);
      });

      rt.client.on("stream-reconnect-start", function (evt) {
        //alert("stream-reconnect-start" + evt.uid);
        console.log("stream-reconnect-start" + evt.uid);
      });

      rt.client.on("rejoin", function () {
        //alert("rejoin");
        console.log("rejoin");
      });

      rt.client.on("stream-reconnect-end", function (evt) {
        //alert(
        //  "stream-reconnect-end: uid:" +
        //    evt.uid +
        //    ", success:" +
        //    evt.success +
        //    ", reason:" +
        //    evt.reason
        //);
        console.log(
          "stream-reconnect-end: uid:" +
            evt.uid +
            ", success:" +
            evt.success +
            ", reason:" +
            evt.reason
        );
      });

      rt.client.on("stream-fallback", function (evt) {
        //alert("stream-fallback: uid:" + evt.uid + ", attr:" + evt.attr);
        //alert("Me")
        console.log(evt.uid);
      });

      rt.client.on("volume-indicator", function (evt) {
        if (!vm.micMuteUnmuteInProcess) {
          //if (evt.attr.length > 0) {
          //  alert("volume-indicator:length=" + evt.attr.length);
          //}
          let users = evt.attr.filter(function (user) {
            //alert("volume-indicator:level=" + user.level);
            return user.level > vm.ActiveSpeakerMinVolume;
          });
          if (vm.localStream != null) {
            var myAudioLevel = parseInt(vm.localStream.getAudioLevel() * 100);
            if (myAudioLevel > vm.ActiveSpeakerMinVolume) {
              //alert("volume-indicator:" + myAudioLevel);
              users.push({
                uid: vm.localStream.getId(),
                level: myAudioLevel,
              });
            }
          }
          vm.setVolumeIndicator(users);
        }
      });

      rt.client.on("connected", function () {
        //alert("connected");
        console.log("connected");
      });

      rt.client.on("stream-updated", function (evt) {
        console.log("stream-updated: " + evt.getId());
      });

      rt.client.on("channel-media-relay-event", function (evt) {
        console.log(evt);
      });

      rt.client.on("channel-media-relay-state", function (evt) {
        console.log(evt);
      });

      //setInterval(() => {
      //  if (vm.logUserIDs.includes(vm.uid)) {
      //    rt.client.getLocalAudioStats((localAudioStats) => {
      //      for (var uid in localAudioStats) {
      //        console.log(localAudioStats);
      //        vm.SendLogMessage(
      //          `Local Audio CodecType from ${uid}: ${localAudioStats[uid].CodecType}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Audio MuteState from ${uid}: ${localAudioStats[uid].MuteState}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Audio RecordingLevel from ${uid}: ${localAudioStats[uid].RecordingLevel}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Audio SamplingRate from ${uid}: ${localAudioStats[uid].SamplingRate}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Audio SendBitrate from ${uid}: ${localAudioStats[uid].SendBitrate}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Audio SendLevel from ${uid}: ${localAudioStats[uid].SendLevel}`
      //        );
      //      }
      //    });
      //    rt.client.getLocalVideoStats((localVideoStats) => {
      //      for (var uid in localVideoStats) {
      //        vm.SendLogMessage(
      //          `Local Video CaptureFrameRate from ${uid}: ${localVideoStats[uid].CaptureFrameRate}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video CaptureResolutionHeight from ${uid}: ${localVideoStats[uid].CaptureResolutionHeight}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video CaptureResolutionWidth from ${uid}: ${localVideoStats[uid].CaptureResolutionWidth}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video EncodeDelay from ${uid}: ${localVideoStats[uid].EncodeDelay}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video MuteState from ${uid}: ${localVideoStats[uid].MuteState}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video SendBitrate from ${uid}: ${localVideoStats[uid].SendBitrate}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video SendFrameRate from ${uid}: ${localVideoStats[uid].SendFrameRate}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video SendResolutionHeight from ${uid}: ${localVideoStats[uid].SendResolutionHeight}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video SendResolutionWidth from ${uid}: ${localVideoStats[uid].SendResolutionWidth}`
      //        );
      //        vm.SendLogMessage(
      //          `Local Video TargetSendBitrate from ${uid}: ${localVideoStats[uid].TargetSendBitrate}`
      //        );
      //        //vm.SendLogMessage(
      //        //  `Local Video TotalDuration from ${uid}: ${localVideoStats[uid].TotalDuration}`
      //        //);
      //        //vm.SendLogMessage(
      //        //  `Local Video TotalFreezeTime from ${uid}: ${localVideoStats[uid].TotalFreezeTime}`
      //        //);
      //      }
      //    });
      //    rt.client.getRemoteAudioStats((remoteAudioStatsMap) => {
      //      for (var uid in remoteAudioStatsMap) {
      //        vm.SendLogMessage(
      //          `Remote Audio CodecType from ${uid}: ${remoteAudioStatsMap[uid].CodecType}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Audio End2EndDelay from ${uid}: ${remoteAudioStatsMap[uid].End2EndDelay}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Audio MuteState from ${uid}: ${remoteAudioStatsMap[uid].MuteState}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Audio PacketLossRate from ${uid}: ${remoteAudioStatsMap[uid].PacketLossRate}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Audio RecvBitrate from ${uid}: ${remoteAudioStatsMap[uid].RecvBitrate}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Audio RecvLevel from ${uid}: ${remoteAudioStatsMap[uid].RecvLevel}`
      //        );
      //        //vm.SendLogMessage(
      //        //  `Remote Audio TotalFreezeTime from ${uid}: ${remoteAudioStatsMap[uid].TotalFreezeTime}`
      //        //);
      //        //vm.SendLogMessage(
      //        //  `Remote Audio TotalPlayDuration from ${uid}: ${remoteAudioStatsMap[uid].TotalPlayDuration}`
      //        //);
      //        vm.SendLogMessage(
      //          `Remote Audio TransportDelay from ${uid}: ${remoteAudioStatsMap[uid].TransportDelay}`
      //        );
      //      }
      //    });
      //    rt.client.getRemoteVideoStats((remoteVideoStatsMap) => {
      //      for (var uid in remoteVideoStatsMap) {
      //        vm.SendLogMessage(
      //          `Remote Video End2EndDelay from ${uid}: ${remoteVideoStatsMap[uid].End2EndDelay}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video MuteState from ${uid}: ${remoteVideoStatsMap[uid].MuteState}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video PacketLossRate from ${uid}: ${remoteVideoStatsMap[uid].PacketLossRate}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video RecvBitrate from ${uid}: ${remoteVideoStatsMap[uid].RecvBitrate}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video RecvResolutionHeight from ${uid}: ${remoteVideoStatsMap[uid].RecvResolutionHeight}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video RecvResolutionWidth from ${uid}: ${remoteVideoStatsMap[uid].RecvResolutionWidth}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video RenderFrameRate from ${uid}: ${remoteVideoStatsMap[uid].RenderFrameRate}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video RenderResolutionHeight from ${uid}: ${remoteVideoStatsMap[uid].RenderResolutionHeight}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video RenderResolutionWidth from ${uid}: ${remoteVideoStatsMap[uid].RenderResolutionWidth}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video TotalFreezeTime from ${uid}: ${remoteVideoStatsMap[uid].TotalFreezeTime}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video TotalPlayDuration from ${uid}: ${remoteVideoStatsMap[uid].TotalPlayDuration}`
      //        );
      //        vm.SendLogMessage(
      //          `Remote Video TransportDelay from ${uid}: ${remoteVideoStatsMap[uid].TransportDelay}`
      //        );
      //      }
      //    });
      //  }
      //}, 2000);

      rt.client.on("network-quality", function (stats) {
        if (vm.logUserIDs.includes(vm.uid)) {
          vm.SendLogMessage(
            "downlinkNetworkQuality:" + stats.downlinkNetworkQuality
          );
          vm.SendLogMessage(
            "uplinkNetworkQuality:" + stats.uplinkNetworkQuality
          );
        }
      });

      rt.client.on("exception", function (evt) {
        //alert("exception")
        //alert(evt.msg);
        let videoErrorCodes = [1003, 1005, 3003, 3005];
        if (vm.agoraPlayerClientsideLog) {
          vm.saveAgoraLog(
            "exception",
            `ex: ${evt.code}: ${(evt.code, evt.msg)}`,
            `${evt.uid}`
          );
        }
        if (vm.advancedAutoRecovery || vm.autoRecovery) {
          if (videoErrorCodes.includes(evt.code)) {
            //vm.repairStream(evt.uid, `ex: ${evt.code}: ${(evt.code, evt.msg)}`);
          }
        }
        if (vm.DebugMode && vm.displayNetworkError) {
          if (videoErrorCodes.includes(evt.code)) {
            let err = clientError[evt.code];
            let msg = "";
            if (err) {
              msg = err.msg;
            } else {
              msg = evt.msg;
            }
            vm.showException(evt.uid, "", msg);
          }
        }

        if (vm.logUserIDs.includes(vm.uid)) {
          vm.SendLogMessage(
            `exception ${evt.code}:${evt.uid}: ${(evt.code, evt.msg)}`
          );
          vm.ShowAlertMessage(
            `exception ${evt.code}:${evt.uid}: ${(evt.code, evt.msg)}`
          );
        }
      });
    },

    ShowAlertMessage(msg) {
      if (location.origin.startsWith("http://localhost")) {
        //alert(msg);
      }
      console.log(msg);
    },

    SendLogMessage(msg) {
      console.log(msg);
      //vm.playerLog.sendP2PMessage(msg);
    },

    saveAgoraLog(actiontype, actionLabel, agoraUserId) {
      //alert(
      //  "actiontype:" +
      //    actiontype +
      //    "; actionLabel:" +
      //    actionLabel +
      //    "; agoraUserId:" +
      //    agoraUserId
      //);
      let errorType = "AUDIO";
      if (actionLabel.includes("VIDEO")) {
        errorType = "VIDEO";
      }
      let headers = {
        "content-type": "application/json",
      };
      let requestData = {
        instanceId: "OA_UAT",
        clientId: vm.clientId,
        eventId: vm.eventId,
        sessionId: vm.sessionId,
        agoraChannelId: vm.channelName,
        agoraUserId: agoraUserId,
        errorType: errorType, //"Audio/Video", //-- Audio/Video
        streamStatus: actiontype,
        errorReason: "clientUserId:" + vm.uid + ":" + actionLabel,
      };

      //{
      //        instanceId: "OA_UAT",
      //        clientId: vm.clientId,
      //        eventId: vm.eventId,
      //        origin: "Responsive", //-- CMS/Responsive/MobileApp
      //        userId: vm.uid,
      //        userName: vm.name,
      //        userEmail: "",
      //        action: action,
      //        actionLabel: actionLabel,
      //        actionType: actiontype,
      //        pageName: "Player_" + vm.channelName,
      //        eventName: vm.eventName,
      //      };
      axios
        .post(APIs.AgoraErrorLog, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          //alert("Success");
          console.log(responseData);
        })
        .catch((error) => {
          //alert("AgoraErrorLog:" + error);
          console.log("AgoraErrorLog: " + error);
        });
    },

    setVolumeIndicator(users) {
      //if (vm.localStreamVolume > 0) {
      //  users.push({
      //    uid: vm.localStream.getId(),
      //    level: vm.localStreamVolume,
      //  });
      //}
      $(".ag-user").attr("asrank", "0");
      if (vm.ShowAudioVolume) {
        $(".ag-user .ag-asr").html("0");
      }
      $(".sound-talking")
        .removeClass("sound-talking")
        .addClass("sound-unmuted");

      if (users.length > 0) {
        users.forEach(function (user) {
          //alert(user.uid + " : " + user.level);
          if ($("#debugPanel")) {
            vm.showLog("v:" + user.uid + "=" + user.level);
          }
          $("#ag-user-" + user.uid).attr("asrank", user.level);
          if (vm.ShowAudioVolume) {
            $("#ag-user-" + user.uid + " .ag-asr").html(user.level);
          }
          $("#audio-indicator-" + user.uid).addClass("sound-talking");
        });
        users.sort(function (a, b) {
          if (a.level > b.level) {
            return -1;
          }
          if (a.level < b.level) {
            return 1;
          }
          return 0;
        });
        //alert(vm.activeScreenUID);
        if (!vm.pinSelected) {
          if (vm.ActiveSpeakerFocus) {
            //vm.pinVideoTile(users[0].uid);
            vm.activeScreenUID = users[0].uid;
            //alert(users[0].uid);
            vm.arrangeVideoFrame();
            //vm.setActiveVideoFrame();
          }
        } else {
          if (vm.ActiveSpeakerSorting) {
            vm.sortByActiveSpeaker();
          } else {
            if (
              vm.shareClient != null ||
              (vm.activeScreenUID > vm.shareIdStartsAfter &&
                vm.activeScreenUID != vm.shareUid)
            ) {
              //alert(vm.shareUid);
              //alert(vm.activeScreenUID);
              vm.sortByActiveSpeaker();
            }
          }
        }
      }
    },

    arrangeVideoFrame() {
      vm.showLog("arrangeVideoFrame");
      if (vm.activeScreenUID == 0 && vm.streamList.length > 0) {
        vm.activeScreenUID = vm.streamList[0].getId();
        //if (!this.readyShareState) {
        //  vm.activeScreenUID = vm.streamList[0].getId();
        //} else {
        //  alert("sid: " + vm.streamList[vm.streamList.length - 1]);
        //}
      }

      let canvas = document.querySelector("#ag-canvas");
      let parentPanel = document.querySelector("#ag-parent-canvas");
      let leftPanel = document.querySelector("#ag-left-panel");
      let rightPanel = document.querySelector("#ag-right-panel");
      //if (vm.displayMode === "tile" && vm.streamList.length > 4) {
      //  vm.displayMode = "pip";
      //}
      let makeSingleActive = false;
      //if (vm.displayMode === "pip" && vm.streamList.length > 4) {
      if (vm.displayMode === "pip") {
        if (vm.activeScreenUID != 0) {
          makeSingleActive = true;
        }
        if (parentPanel) {
          if (vm.streamList.length > 1) {
            parentPanel.setAttribute("class", "ag-2col");
          } else {
            parentPanel.setAttribute("class", "");
          }
        }
        if (leftPanel) {
          leftPanel.setAttribute("class", "");
        }
        if (rightPanel) {
          rightPanel.setAttribute("class", "d-none");
        }
      } else if (vm.displayMode === "tile") {
        if (
          vm.streamList.length >= vm.specialTileViewMinTiles &&
          vm.streamList.length <= vm.specialTileViewMaxTiles
        ) {
          if (vm.activeScreenUID != 0) {
            makeSingleActive = true;
          }
          if (parentPanel) {
            parentPanel.setAttribute("class", "ag-3col");
          }
          if (leftPanel) {
            leftPanel.setAttribute("class", "");
          }
          if (rightPanel) {
            rightPanel.setAttribute("class", "");
          }
        } else {
          if (parentPanel) {
            parentPanel.setAttribute("class", "");
          }
          if (leftPanel) {
            leftPanel.setAttribute("class", "d-none");
          }
          if (rightPanel) {
            rightPanel.setAttribute("class", "d-none");
          }
        }
      }

      // pip mode (can only use when less than 4 people in channel)
      //let indx = -1;
      //let indx = 0;
      //alert(canvas.children.length);
      //alert(vm.displayMode);
      if (vm.displayMode === "pip") {
        //let no = vm.streamList.length;
        //if (no > 4) {
        //  vm.displayMode = "tile";
        //  return;
        //}
        vm.streamList.map((item) => {
          //indx++;

          let id = item.getId();
          let isHost = vm.isUserHost(id);
          let user = document.querySelector("#ag-user-" + id);
          if (!user) {
            user = document.createElement("div");
            user.setAttribute("id", "ag-user-" + id);
            user.setAttribute("class", "ag-user");

            if (canvas.children.length == 0 || !isHost) {
              canvas.appendChild(user);
            } else {
              canvas.insertBefore(
                user,
                canvas.children[canvas.children.length - 1]
              );
            }
          }
          let dom = document.querySelector("#ag-item-" + id);
          if (user && !dom) {
            //alert("newpip: " + indx);
            dom = document.createElement("section");
            dom.setAttribute("id", "ag-item-" + id);
            if (id === vm.activeScreenUID) {
              dom.setAttribute("class", "ag-item");
            } else {
              dom.setAttribute("class", "ag-item ag-pip");
            }
            user.appendChild(dom);
            //dom.addEventListener("click", function () {
            //  vm.pinVideoTile(id);
            //});
            //dom.addEventListener("click", function () {
            //  vm.pinVideoTile(id);
            //});
            //if (makeSingleActive) {
            //  if (leftPanel.childNodes.length > rightPanel.childNodes.length) {
            //    rightPanel.appendChild(dom);
            //  } else {
            //    leftPanel.appendChild(dom);
            //  }
            //} else {
            //if (canvas.children.length == 0 || !isHost) {
            //  canvas.appendChild(dom);
            //} else {
            //  canvas.insertBefore(
            //    dom,
            //    canvas.children[canvas.children.length - 1]
            //  );
            //}
            //}
            if (id == vm.uid && !vm.allowCam) {
              item.muteVideo();
            }
            if (item.isPlaying()) {
              //alert("true");
              //item.resume("ag-item-" + id);
              //item.pause();
              //item.play("ag-item-" + id);
            } else {
              //alert("false");
              item.play("ag-item-" + id);
            }
            //setTimeout(() => {
            this.addUserProfile(id);
            //  }, 1000);
          } else {
            if (vm.autoRecovery) {
              if (item.isPlaying()) {
                // item.resume("ag-item-" + id);
                // this.addUserProfile(id, true);
                //alert("pip true");
                //alert("Playing");
              } else {
                //alert("pip false");
                item.play("ag-item-" + id);
                this.addUserProfile(id);
              }
              //setTimeout(() => {
              //}, 2000);
            }
          }
          if (id === vm.activeScreenUID) {
            user.setAttribute("class", "ag-user active");
          } else {
            user.setAttribute("class", "ag-user ag-pip");
            //dom.setAttribute("style", `grid-area: span 12/span 24/13/25`);
          }
          //if (index === no - 1) {
          if (id === vm.activeScreenUID) {
            //dom.setAttribute("style", `grid-area: span 12/span 24/13/25`);
          } else {
            //indx++;
            //dom.setAttribute(
            //  "style",
            //  `grid-area: span 3/span 4/${4 + 3 * index}/25;
            //z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            //);
            //dom.setAttribute(
            //  "style",
            //  `grid-area: span 3/span 5/${4 + 3 * indx}/6;
            //z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            //);
          }
          //if (dom.getAttribute("style") != "grid-area: span 12/span 24/13/25") {
          //  dom.setAttribute("class", "ag-item ag-pip");
          //}
          //"grid-area: span 12/span 24/13/25"
          item.player.resize && item.player.resize();
        });
      } else if (vm.displayMode === "tile") {
        // tile mode
        let no = vm.streamList.length;
        vm.streamList.map((item) => {
          //indx++;
          //alert("newtile: " + indx);
          //if (id !== vm.activeScreenUID) {
          //  //indx++;
          //}
          let id = item.getId();
          let isHost = vm.isUserHost(id);
          let user = document.querySelector("#ag-user-" + id);
          if (!user) {
            user = document.createElement("div");
            user.setAttribute("id", "ag-user-" + id);
            user.setAttribute("class", "ag-user");

            if (canvas.children.length == 0 || !isHost) {
              canvas.appendChild(user);
            } else {
              canvas.insertBefore(
                user,
                canvas.children[canvas.children.length - 1]
              );
            }
          }
          let dom = document.querySelector("#ag-item-" + id);
          if (user && !dom) {
            dom = document.createElement("section");
            dom.setAttribute("id", "ag-item-" + id);
            dom.setAttribute("class", "ag-item");
            user.appendChild(dom);

            //dom.addEventListener("click", function () {
            //  vm.pinVideoTile(id);
            //  //alert("q");
            //});

            //if (canvas.children.length == 0 || !isHost) {
            //  canvas.appendChild(dom);
            //} else {
            //  canvas.insertBefore(dom, canvas.children[canvas.children.length - 1]);
            //}
            if (id == vm.uid && !vm.allowCam) {
              item.muteVideo();
            }
            //setTimeout(() => {
            console.log(
              "---------------------------------isPlaying: " + item.isPlaying()
            );
            if (item.isPlaying()) {
              //alert("true");
              //item.resume("ag-item-" + id);
              //item.pause();
              //item.play("ag-item-" + id);
            } else {
              //alert("false");
              item.play("ag-item-" + id);
            }
            //setTimeout(() => {
            this.addUserProfile(id);
            //  }, 1000);
            //}, 1000);
          } else {
            if (vm.autoRecovery) {
              if (item.isPlaying()) {
                // item.resume("ag-item-" + id);
                // this.addUserProfile(id, true);
                //alert("tile true");
                //alert("Playing");
              } else {
                //alert("tile false");
                item.play("ag-item-" + id);
                this.addUserProfile(id);
              }
              //setTimeout(() => {
              //}, 2000);
            }
          }
          if (no == 1) {
            user.setAttribute("class", "ag-user active");
          } else {
            user.setAttribute("class", "ag-user");
          }

          //dom.setAttribute("style", `grid-area: ${tile_canvas[no][indx]}`);
          item.player.resize && item.player.resize();
        });
      } else if (vm.displayMode === "share") {
        // screen share mode (tbd)
        //this.addUserProfile(id);
      }
      console.log(makeSingleActive);
      //if (makeSingleActive) {
      vm.streamList.map((item) => {
        let id = item.getId();
        let isHost = vm.isUserHost(id);
        let dom = document.querySelector("#ag-user-" + id);

        //if (dom && canvas.childNodes.length > 1) {
        if (dom) {
          if (
            vm.displayMode === "tile" &&
            vm.streamList.length >= vm.specialTileViewMinTiles &&
            vm.streamList.length <= vm.specialTileViewMaxTiles
          ) {
            if (makeSingleActive && id == vm.activeScreenUID) {
              $("#ag-user-" + vm.activeScreenUID)
                .detach()
                .appendTo("#ag-canvas");
              //vm.setActiveVideoFrame();
            } else {
              //alert("////debugger");
              if (id != vm.activeScreenUID) {
                if (
                  leftPanel.childNodes.length > rightPanel.childNodes.length
                ) {
                  $("#ag-user-" + id)
                    .detach()
                    .appendTo("#ag-right-panel");
                } else {
                  $("#ag-user-" + id)
                    .detach()
                    .appendTo("#ag-left-panel");
                }
                leftPanel = document.querySelector("#ag-left-panel");
                rightPanel = document.querySelector("#ag-right-panel");
              }
            }
          } else {
            if (
              vm.displayMode === "tile" ||
              (makeSingleActive && id == vm.activeScreenUID)
            ) {
              if (isHost) {
                $("#ag-user-" + id)
                  .detach()
                  .prependTo("#ag-canvas");
              } else {
                $("#ag-user-" + id)
                  .detach()
                  .appendTo("#ag-canvas");
                //vm.setActiveVideoFrame();
              }
            } else {
              if (isHost) {
                $("#ag-user-" + id)
                  .detach()
                  .prependTo("#ag-left-panel");
              } else {
                $("#ag-user-" + id)
                  .detach()
                  .appendTo("#ag-left-panel");
              }
            }
          }
        }
      });
      //}

      //Re-Arrange left-right panel

      //if (makeSingleActive) {
      vm.streamList.map((item) => {
        let id = item.getId();
        let isHost = vm.isUserHost(id);
        let dom = document.querySelector("#ag-user-" + id);

        //if (dom && canvas.childNodes.length > 1) {
        if (dom) {
          if (
            vm.displayMode === "tile" &&
            vm.streamList.length >= vm.specialTileViewMinTiles &&
            vm.streamList.length <= vm.specialTileViewMaxTiles
          ) {
            if (makeSingleActive && id == vm.activeScreenUID) {
              //$("#ag-user-" + vm.activeScreenUID)
              //  .detach()
              //  .appendTo("#ag-canvas");
              //vm.setActiveVideoFrame();
            } else {
              if (id != vm.activeScreenUID) {
                if (
                  leftPanel.childNodes.length > rightPanel.childNodes.length
                ) {
                  $("#ag-user-" + id)
                    .detach()
                    .appendTo("#ag-right-panel");
                } else {
                  $("#ag-user-" + id)
                    .detach()
                    .appendTo("#ag-left-panel");
                }
                leftPanel = document.querySelector("#ag-left-panel");
                rightPanel = document.querySelector("#ag-right-panel");
              }
            }
          } else {
            if (
              vm.displayMode === "tile" ||
              (makeSingleActive && id == vm.activeScreenUID)
            ) {
              //$("#ag-user-" + id)
              //  .detach()
              //  .appendTo("#ag-canvas");
              //vm.setActiveVideoFrame();
            } else {
              //$("#ag-user-" + id)
              //  .detach()
              //  .appendTo("#ag-left-panel");

              if (isHost) {
                $("#ag-user-" + id)
                  .detach()
                  .prependTo("#ag-left-panel");
              } else {
                $("#ag-user-" + id)
                  .detach()
                  .appendTo("#ag-left-panel");
              }
            }
          }
        }
      });
      //}

      //@@@@@@@@@@@@@@@@@@@@@
      if (vm.useE2MInjection) {
        let dom = document.querySelector("#ag-item-vpLivePlayer");
        if (!dom) {
          //alert("newpip: " + indx);
          dom = document.createElement("section");
          dom.setAttribute("id", "ag-item-vpLivePlayer");
          //if (id === vm.activeScreenUID) {
          dom.setAttribute("class", "ag-item");
          //} else {
          //  dom.setAttribute("class", "ag-item ag-pip");
          //}
          canvas.appendChild(dom);
          //}

          $("#vpLivePlayer").detach().appendTo("#ag-item-vpLivePlayer");
        }
      }
      //@@@@@@@@@@@@@@@@@@@@@
      //setTimeout(() => {
      vm.setCanvasRowColumn();
      vm.setLeftCanvasRowColumn();
      vm.setRightCanvasRowColumn();
      //}, 2000);
      if (vm.streamList.length > 2 && vm.displayMode == "pip") {
        if (vm.ActiveSpeakerSorting) {
          vm.sortByActiveSpeaker();
        }
        //else {
        //  if (
        //    vm.shareClient != null ||
        //    (vm.activeScreenUID > vm.shareIdStartsAfter &&
        //      vm.activeScreenUID != vm.shareUid)
        //  ) {
        //    //alert(vm.shareUid);
        //    //alert(vm.activeScreenUID);
        //    vm.sortByActiveSpeaker();
        //  }
        //}
      }
    },

    isUserHost(id) {
      let result = false;
      vm.allHosts.forEach(function (item) {
        if (id == item.AttendeeId) {
          result = true;
        }
      });
      return result;
    },
    isUserCoHost(id) {
      let result = false;
      vm.allCoHosts.forEach(function (item) {
        if (id == item.AttendeeId) {
          result = true;
        }
      });
      return result;
    },

    setActiveVideoFrame() {
      //
      vm.showLog("setActiveVideoFrame");
      if (vm.activeScreenUID != 0 && vm.streamList.length > 0) {
        let canvas = document.querySelector("#ag-canvas");
        //let parentPanel = document.querySelector("#ag-parent-canvas");
        //let leftPanel = document.querySelector("#ag-left-panel");
        //let rightPanel = document.querySelector("#ag-right-panel");
        let dom = document.querySelector("#ag-user-" + vm.activeScreenUID);
        if (dom) {
          //alert(dom.getAttribute("class"));
          if (canvas.childNodes.length == 1) {
            let position = 0;

            if (dom.parentNode.getAttribute("id") == "ag-left-panel") {
              position = 1;
            }
            if (dom.parentNode.getAttribute("id") == "ag-right-panel") {
              position = 2;
            }

            let id = canvas.childNodes[0].getAttribute("id");
            if (position == 1) {
              $(id).detach().appendTo("#ag-left-panel");
            } else if (position == 2) {
              $(id).detach().appendTo("#ag-right-panel");
            }
            if (position == 1 || position == 2) {
              $("#ag-canvas").html("");
              $("#ag-user-" + vm.activeScreenUID)
                .detach()
                .appendTo("#ag-canvas");
            }
            vm.setCanvasRowColumn();
            vm.setLeftCanvasRowColumn();
            vm.setRightCanvasRowColumn();
          }
        }
      }
    },

    sortByActiveSpeaker() {
      var sortOption = "0";
      //if ($("#ddlQNASort") != undefined) {
      //  sortOption = $("#ddlQNASort").val();
      //}
      var list, i, switching, b, shouldSwitch;
      list = document.getElementById("ag-left-panel");
      switching = true;
      /* Make a loop that will continue until no switching has been done: */
      while (switching) {
        // Start by saying: no switching is done:
        switching = false;
        b = list.getElementsByClassName("ag-user");
        // Loop through all list items:
        //alert("b.length:" + b.length);
        for (i = 0; i < b.length - 1; i++) {
          // Start by saying there should be no switching:
          shouldSwitch = false;
          /* Check if the next item should
            switch place with the current item: */
          if (sortOption == "1") {
            var firstName1 = $(b[i]).attr("firstName");
            var firstName2 = $(b[i + 1]).attr("firstName");
            if (firstName2 > firstName1) {
              /* If next item is alphabetically lower than current item,
                    mark as a switch and break the loop: */
              shouldSwitch = true;
              break;
            }
          } else if (sortOption == "0") {
            //alert("sortOption:" + sortOption);
            var activeSpeakerRank1 = parseInt($(b[i]).attr("asrank"));
            var activeSpeakerRank2 = parseInt($(b[i + 1]).attr("asrank"));

            if (activeSpeakerRank2 > activeSpeakerRank1) {
              /* If next item is alphabetically lower than current item,
                    mark as a switch and break the loop: */
              //alert(
              //  "activeSpeakerRank1: " +
              //    activeSpeakerRank1 +
              //    " activeSpeakerRank2: " +
              //    activeSpeakerRank2
              //);
              shouldSwitch = true;
              break;
            } else {
              //alert(
              //  "activeSpeakerRank1: " +
              //    activeSpeakerRank1 +
              //    " activeSpeakerRank2: " +
              //    activeSpeakerRank2
              //);
            }
          }
        }
        if (shouldSwitch) {
          /* If a switch has been marked, make the switch
            and mark the switch as done: */
          b[i].parentNode.insertBefore(b[i + 1], b[i]);
          switching = true;
        }
      }
    },

    checkMyVolumeIndicator() {
      if (vm.localStream == null) {
        //if (vm.streamList.length) {
        //  alert(vm.streamList.length);
        //}
        let users = [];
        vm.streamList.forEach(function (item) {
          let uid = item.getId();
          let volumeLevel = item.getAudioLevel();
          volumeLevel = parseInt(volumeLevel * 100);
          if (volumeLevel > 0) {
            //alert("checkMyVolumeIndicator:" + volumeLevel);
            users.push({
              uid: uid,
              level: volumeLevel,
            });
          }
        });
        vm.setVolumeIndicator(users);
      } else {
        //vm.localStreamVolume = parseInt(vm.localStream.getAudioLevel() * 100);
        ////alert(audioLevel);
        ////audioLevel *= 100;
        ////alert(audioLevel);
        //$(".ag-item-" + vm.uid).attr("asrank", "0");
        //if (vm.ShowAudioVolume) {
        //  $(".ag-item-" + vm.uid + " .ag-asr").html("0");
        //}
        //$("#audio-indicator-" + vm.uid)
        //  .removeClass("sound-talking")
        //  .addClass("sound-unmuted");
        //$("#ag-item-" + vm.uid).attr("asrank", audioLevel);
        //if (vm.ShowAudioVolume) {
        //  $("#ag-item-" + vm.uid + " .ag-asr").html(audioLevel);
        //}
        //$("#audio-indicator-" + vm.uid).addClass("sound-talking");
        ////if (!vm.pinSelected) {
        ////  if (vm.ActiveSpeakerFocus) {
        ////    //vm.pinVideoTile(users[0].uid);
        ////    vm.activeScreenUID = vm.uid;
        ////    //vm.setActiveFrameInCenter();
        ////    //vm.arrangeVideoFrame();
        ////  }
        ////} else {
        ////  if (vm.ActiveSpeakerSorting) {
        ////    vm.sortByActiveSpeaker();
        ////  }
        ////}
        //////var audioLevel = localStream.getAudioLevel() * 100;
        ////////console.log('audioLevel',audioLevel);
        //////if (!$("#player_" + uid).hasClass("active-speaker")) {
        //////  $("#player_" + uid).addClass("active-speaker");
        //////}
        //////if (audioLevel > 10) {
        //////  $("#player_" + uid + " span.speaker-wave > img").attr(
        //////    "src",
        //////    "images/volume-indicator.gif"
        //////  );
        //////} else {
        //////  //$("#player_"+volume.uid).removeClass('active-speaker');
        //////  $("#player_" + uid + " span.speaker-wave > img").attr(
        //////    "src",
        //////    "images/volume-indicator-pause.png"
        //////  );
        //////}
      }
    },

    removeStream(uid) {
      //alert("removeStream");
      //if (uid == 666) {
      //  return;
      //}
      //vm.removeStreamUserList(uid);

      vm.streamList.map((item, index) => {
        if (item.getId() === uid) {
          item.close();
          let element = document.querySelector("#ag-user-" + uid);
          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...this.streamList];
          tempList.splice(index, 1);
          vm.streamList = tempList;
        }
      });
      if (vm.streamList.length > 0 && vm.activeScreenUID == uid) {
        vm.activeScreenUID = vm.streamList[0].getId();
      }
      //let canvas = document.querySelector("#ag-canvas");
      //let leftPanel = document.querySelector("#ag-left-panel");
      //let rightPanel = document.querySelector("#ag-right-panel");
      //canvas.childNodes.clear();
      //leftPanel.childNodes.clear();
      //rightPanel.childNodes.clear();
      vm.setCanvasRowColumn();
      vm.setLeftCanvasRowColumn();
      vm.setRightCanvasRowColumn();
      if (vm.streamList.length == 0) {
        vm.changePlayerStatus(0);
      }
    },

    changePlayerStatus(status) {
      if (status == 1) {
        if (vm.userType != 4 || vm.streamList.length > 0) {
          $("#player-not-ready").addClass("d-none");
          $("#ag-parent-canvas").removeClass("d-none");
          //$("#ag-sponsor-panel").removeClass("d-none");
          //$("#ag-button-panel").removeClass("d-none");
          //$(".view-count").removeClass("d-none");
          $(".show-on-call").removeClass("d-none");

          if (myVoiceDetectTimer) {
            clearInterval(myVoiceDetectTimer);
          }
          //if (!location.origin.startsWith("http://localhost")) {
          if (vm.userType != 4) {
            myVoiceDetectTimer = setInterval(function () {
              if (vm.localStream != null) {
                if (!$("#audio-indicator-" + vm.uid).hasClass("sound-muted")) {
                  //vm.checkMyVolumeIndicator();
                }
              } else {
                //vm.checkMyVolumeIndicator();
              }
            }, 2000);
          }
        }
        //}
      } else {
        $("#player-not-ready").removeClass("d-none");
        $("#ag-parent-canvas").addClass("d-none");
        //$("#ag-sponsor-panel").addClass("d-none");
        //$(".view-count").addClass("d-none");
        $(".show-on-call").addClass("d-none");
        //alert($("#ag-canvas").html());
        $("#ag-canvas").html("");
        //alert($("#ag-canvas").html());
        $("#ag-left-panel").html("");
        $("#ag-right-panel").html("");

        if (myVoiceDetectTimer) {
          clearInterval(myVoiceDetectTimer);
        }
      }
    },

    addStream(stream, push = false) {
      //vm.addStreamUserList(stream.getId());
      let repeatition = vm.streamList.some((item) => {
        return item.getId() === stream.getId();
      });
      if (repeatition) {
        return;
      }
      if (push) {
        vm.streamList = vm.streamList.concat([stream]);
      } else {
        vm.streamList = [stream].concat(vm.streamList);
      }
    },

    addStreamUserList(uid) {
      let streamUsers = vm.streamUserList.filter((item) => {
        return item.uid == uid;
      });
      if (streamUsers.length == 0) {
        vm.streamUserList.push({ uid: uid, IsLocal: uid == vm.uid });
      }
    },
    removeStreamUserList(uid) {
      vm.streamUserList = vm.streamUserList.filter((item) => {
        return item.uid != uid;
      });
    },

    handleCamera(e) {
      //console.log(e);
      //vm.localStream.setVideoProfile("720p_1");
      //vm.shareStream.setScreenProfile("720p_1");
      e.currentTarget.classList.toggle("off");
      vm.handleVideo();
      //this.localStream.isVideoOn()
      //  ? this.localStream.disableVideo()
      //  : this.localStream.enableVideo();
    },

    handleVideo() {
      if ($(".videoControlBtn").hasClass("off")) {
        if (this.localStream.hasVideo() && this.localStream.isVideoOn()) {
          this.localStream.muteVideo();
        }
        vm.isVideoOn = false;
        let uid = this.localStream.getId();
        $("#profileImage_" + uid).removeClass("d-none");
      } else {
        if (this.localStream.hasVideo() && !this.localStream.isVideoOn()) {
          this.localStream.unmuteVideo();
        }
        vm.isVideoOn = true;
        vm.allowCam = true;
        let uid = this.localStream.getId();
        $("#profileImage_" + uid).addClass("d-none");
      }
    },

    handleMic(e) {
      e.currentTarget.classList.toggle("off");
      vm.handleAudio();
      //this.localStream.isAudioOn()
      //  ? this.localStream.muteAudio()
      //  : this.localStream.unmuteAudio();
    },
    getUnmuteRequester(requesterId) {
      let result = "Host";
      //if (vm.sessionTypeId == 3) {
      //  if (vm.session) {
      //  }
      //}
      let attendees = vm.allAttendees.filter(function (item) {
        return item.AttendeeId == requesterId;
      });
      if (attendees.length > 0) {
        result = attendees[0].FirstName;
      }
      return result;
    },
    forceMuteSpeaker(requesterId, type, forceMute) {
      vm.unmuteRequester = vm.getUnmuteRequester(requesterId);
      vm.unmuteRequester = "[" + vm.unmuteRequester.trim() + "]";
      if (vm.userType < 4) {
        if (type == 0) {
          if (!$(".audioControlBtn").hasClass("off")) {
            if (forceMute) {
              $(".audioControlBtn").addClass("off");
              vm.handleAudio();
            } else {
              alert("You have requested to Mute");
            }
          }
        } else {
          if ($(".audioControlBtn").hasClass("off")) {
            $("#popupUnmute").modal({ backdrop: "static" }, "show");
            //alert("You have requested to Unmute");
          }
        }
      }
    },
    forceSpotlight(uid) {
      //alert("forceSpotlight" + uid);
      if (uid > 0) {
        //let speakers = vm.allSpeakers.filter(function (item) {
        //  return item.AttendeeId == uid;
        //});
        let speakers = vm.streamList.filter(function (item) {
          return item.getId() == uid;
        });
        if (speakers.length > 0) {
          //alert("forceSpotlight");
          vm.pinVideoTile(uid);
          $(".ag-spotlight .ag-option-icon")
            .removeClass("ag-spotlight-on")
            .addClass("ag-spotlight-off");
          $("#ag-option-spotlight-" + uid + " .ag-option-icon")
            .removeClass("ag-spotlight-off")
            .addClass("ag-spotlight-on");

          $(".ag-option-pin").removeClass("disabled");
          $(".ag-option-pin  .ag-option-icon")
            .removeClass("ag-unpin-user")
            .addClass("ag-pin-user");

          $("#ag-option-pin-" + uid).addClass("disabled");
          $("#ag-option-pin-" + uid + " .ag-option-icon")
            .removeClass("ag-pin-user")
            .addClass("ag-unpin-user");
        }
      } else {
        vm.switchToTileView();
        $(".ag-spotlight .ag-option-icon")
          .removeClass("ag-spotlight-on")
          .addClass("ag-spotlight-off");
      }
      //vm.activeScreenUID = uid;
      //vm.displayMode = "pip";
      //vm.pinSelected = true;
    },
    onUnmute(option) {
      //alert(option);
      //alert($(".audioControlBtn").hasClass("off"));
      if (option == 1) {
        if ($(".audioControlBtn").hasClass("off")) {
          $(".audioControlBtn").removeClass("off");
          vm.handleAudio();
        }
      }
      $("#popupUnmute").modal("hide");
    },
    handleAudio() {
      if ($(".audioControlBtn").hasClass("off")) {
        if (this.localStream.hasAudio() && this.localStream.isAudioOn()) {
          this.localStream.muteAudio();
        }
      } else {
        if (this.localStream.hasAudio() && !this.localStream.isAudioOn()) {
          this.localStream.unmuteAudio();
        }
      }

      let id = this.localStream.getId();
      if (this.localStream.hasAudio() && this.localStream.isAudioOn()) {
        vm.isMicOn = true;
        $("#audio-indicator-" + id)
          .removeClass("sound-muted")
          .removeClass("sound-talking")
          .addClass("sound-unmuted");
      } else {
        vm.isMicOn = false;
        $("#audio-indicator-" + id)
          .removeClass("sound-unmuted")
          .removeClass("sound-talking")
          .addClass("sound-muted");
      }
    },

    toggleHideMoreOption(e) {
      if (!vm.moreOptionVisibility) {
        vm.hidePopup();
      }
      vm.moreOptionVisibility = !vm.moreOptionVisibility;
      if (e) {
        e.stopPropagation();
      }
    },
    toggleHideSpeaker(e) {
      vm.hiddenSpeakerListVisibility = !vm.hiddenSpeakerListVisibility;
      if (e) {
        e.stopPropagation();
      }
    },
    unhideSpeaker(e) {
      //let id = $(e.currentTarget).attr("data-val");
      //alert(id);
      if (e) {
        e.stopPropagation();
      }
    },
    unhideAllSpeakers(e) {
      //vm.hiddenSpeakerList.forEach(function (item) {
      //  let id = item.AttendeeId;
      //  alert(id);
      //});
      vm.hiddenSpeakerListVisibility = !vm.hiddenSpeakerListVisibility;
      if (e) {
        this.stopPropagation();
      }
    },
    switchToTileView(e) {
      if (e != undefined) {
        if (e.currentTarget.classList.contains("disabled")) {
          //alert("disabled");
          return;
        }
      }
      if (vm.streamList.length > 1 && vm.displayMode === "pip") {
        $(".ag-user-pin a").removeClass("ag-unpin").addClass("ag-pin");
        $(".ag-option-pin").removeClass("disabled");
        $(".ag-option-pin .ag-unpin-user")
          .removeClass("ag-unpin-user")
          .addClass("ag-pin-user");
        $(".ag-option-pin .ag-option-label").html("Pin");

        $(".ag-spotlight .ag-option-icon")
          .removeClass("ag-spotlight-on")
          .addClass("ag-spotlight-off");

        vm.pinSelected = false;
        vm.displayMode = "tile";
        //vm.activeScreenUID = 0;
        ////let canvas = document.querySelector("#ag-canvas");
        //let parentPanel = document.querySelector("#ag-parent-canvas");
        //let leftPanel = document.querySelector("#ag-left-panel");
        //let rightPanel = document.querySelector("#ag-right-panel");
        //if (parentPanel) {
        //  parentPanel.setAttribute("class", "ag-2col");
        //}
        //if (leftPanel) {
        //  leftPanel.setAttribute("class", "");
        //}
        //if (rightPanel) {
        //  rightPanel.setAttribute("class", "d-none");
        //}
        //vm.setCanvasRowColumn();
        //vm.setLeftCanvasRowColumn();
        //vm.setRightCanvasRowColumn();
      }
    },

    switchDisplay(e) {
      //console.log(elId);
      //if (e.currentTarget != undefined) {
      //  let eId = e.currentTarget.getAttribute("id").replace("ag-item-", "");
      //  if (eId != undefined || eId != "") {
      //    vm.activeScreenUID = parseInt(eId);
      //  }
      //}
      if (vm.streamList.length <= 1) {
        //alert("vm.streamList.length <= 1");
        vm.switchView("tile");
      } else if (!e.currentTarget.classList.contains("disabled")) {
        if (vm.displayMode === "pip") {
          vm.switchView("tile");
        } else if (vm.displayMode === "tile") {
          vm.switchView("pip");
        }
      }
    },

    switchView(elId) {
      //alert("viewMode:" + viewMode);
      //alert("elId:" + elId);
      if (vm.displayMode === "pip" || vm.displayMode === "tile") {
        if (vm.displayMode === "pip" && elId != undefined) {
          //if (dom.getAttribute("style") != "grid-area: span 12/span 24/13/25") {
          //  dom.setAttribute("class", "ag-item ag-pip");
          //}
        }
      } else if (vm.displayMode === "share") {
        // do nothing or alert, tbd
        this.startShareScreen();
      } else {
        console.error("Display Mode can only be tile/pip/share");
      }
    },

    pinVideoTile(elId) {
      //if (vm.streamList.length > 1 && vm.activeScreenUID != elId) {
      if (vm.streamList.length > 1) {
        vm.activeScreenUID = elId;
        vm.displayMode = "tile";
        vm.displayMode = "pip";
      }
      //////vm.switchView("pip", elId);
      ////if (vm.displayMode === "tile") {
      ////  vm.displayMode === "pip";
      ////} else if (vm.displayMode === "pip") {
      ////  vm.displayMode === "tile";
      ////}
      ////vm.activeScreenUID = elId;
      ////vm.resetTiles();
      //////let dom = document.querySelector("#ag-item-" + elId);
      //////if (dom) {
      //////  if (dom.getAttribute("style") == "grid-area: span 12/span 24/13/25") {
      //////    //dom.setAttribute("style", "grid-area: span 12/span");
      //////    vm.displayMode === "tile";
      //////    vm.resetTiles();
      //////  } else {
      //////    dom.setAttribute("style", "grid-area: span 12/span 24/13/25");
      //////    vm.displayMode === "pip";
      //////  }
      //////}

      //let canvas = document.querySelector("#ag-canvas");
      ////let parentPanel = document.querySelector("#ag-parent-canvas");
      //let leftPanel = document.querySelector("#ag-left-panel");
      //let rightPanel = document.querySelector("#ag-right-panel");
      //let panelClicked = "";

      //canvas.childNodes.forEach((item) => {
      //  let id = $(item).attr("id");
      //  id = id.replace("ag-item-", "");
      //  if (id == elId) {
      //    panelClicked = "c";
      //  }
      //});
      //if (panelClicked == "") {
      //  leftPanel.childNodes.forEach((item) => {
      //    let id = $(item).attr("id");
      //    id = id.replace("ag-item-", "");
      //    if (id == elId) {
      //      panelClicked = "l";
      //    }
      //  });
      //}
      //if (panelClicked == "") {
      //  rightPanel.childNodes.forEach((item) => {
      //    let id = $(item).attr("id");
      //    id = id.replace("ag-item-", "");
      //    if (id == elId) {
      //      panelClicked = "r";
      //    }
      //  });
      //}
      //vm.displayMode === "pip";
      //if (
      //  vm.streamList.length > 1 &&
      //  ((panelClicked == "c" && canvas.childNodes.length > 1) ||
      //    (panelClicked == "l" && leftPanel.childNodes.length > 1) ||
      //    (panelClicked == "r" && rightPanel.childNodes.length > 1))
      //) {
      //  //if (vm.displayMode === "tile") {
      //  //  vm.displayMode === "pip";
      //  //} else if (vm.displayMode === "pip") {
      //  //  vm.displayMode === "tile";
      //  //}
      //  vm.activeScreenUID = elId;
      //  vm.resetTiles(panelClicked);
      //}
    },
    pinVideoTileStatusUpdate(uid, isPinned) {
      //alert("pinVideoTileStatusUpdate:" + uid);
      if (uid > 0) {
        if (isPinned) {
          let speakers = vm.streamList.filter(function (item) {
            return item.getId() == uid;
          });
          if (speakers.length > 0) {
            $(".ag-spotlight .ag-option-icon")
              .removeClass("ag-spotlight-on")
              .addClass("ag-spotlight-off");

            $(".ag-option-pin").removeClass("disabled");
            $(".ag-option-pin  .ag-option-icon")
              .removeClass("ag-unpin-user")
              .addClass("ag-pin-user");

            $("#ag-option-pin-" + uid).addClass("disabled");
            $("#ag-option-pin-" + uid + " .ag-option-icon")
              .removeClass("ag-pin-user")
              .addClass("ag-unpin-user");
          }
        }
      } else {
        vm.switchToTileView();
      }
    },

    hideRemote(e) {
      console.log(e);
      //alert("hideRemote");
      if (this.readyShareState) {
        this.stopShareScreen();
      } else {
        this.startShareScreen();
      }
      //if (
      //  e.currentTarget.classList.contains("disabled") ||
      //  this.streamList.length <= 1
      //) {
      //  return;
      //}
      //let list;
      //let id = this.streamList[this.streamList.length - 1].getId();
      //list = Array.from(
      //  document.querySelectorAll(`.ag-item:not(#ag-item-${id})`)
      //);
      //list.map((item) => {
      //  if (item.style.display !== "none") {
      //    item.style.display = "none";
      //  } else {
      //    item.style.display = "block";
      //  }
      //});
    },

    onConfirmEndCall() {
      $("#popupLeaveConfirm").modal("show");
    },

    onCanceEndCall() {
      $("#popupLeaveConfirm").modal("hide");
    },
    ReConnectCall() {
      //vm.onEndCall();
      // alert("ReConnectCall")
      // alert(vm.inProcess)
      // alert(vm.readyState)
      //alert(vm.readyState);
      if (!vm.inProcess) {
        vm.readyState = false;
        vm.StartCall(
          vm.tempValues.clientId,
          vm.tempValues.eventId,
          vm.tempValues.channelName,
          vm.tempValues.sessionTypeId,
          vm.tempValues.session,
          vm.tempValues.roundTable,
          vm.tempValues.o2oMeeting,
          vm.tempValues.attendeeType,
          vm.tempValues.callSettings,
          vm.tempValues.exMeetingId,
          vm.tempValues.meetingHostId,
          1
        );
      }
    },
    ReStartCall() {
      //alert("ReStartCall");
      $("#popupLeaveConfirm").modal("hide");
      //if (!vm.inProcess && !vm.readyState) {
      vm.inProcess = true;
      //$(".exitBtn").removeClass("start-call-btn");
      vm.StartCall(
        vm.tempValues.clientId,
        vm.tempValues.eventId,
        vm.tempValues.channelName,
        vm.tempValues.sessionTypeId,
        vm.tempValues.session,
        vm.tempValues.roundTable,
        vm.tempValues.o2oMeeting,
        vm.tempValues.attendeeType,
        vm.tempValues.callSettings,
        vm.tempValues.exMeetingId,
        vm.tempValues.meetingHostId,
        1
      );
      //}
    },
    onEndSession() {
      $("#popupLeaveConfirm").modal("hide");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        //alert("Not Implemented");
        if (vm.sessionTypeId == vm.LivePanelTypeID && vm.sessionId != "") {
          db.collection(obj.eventcollectionname)
            .doc("SessionList")
            .collection("Sessions")
            .doc(vm.sessionId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                vm.BroadCastStopRecording();
                setTimeout(() => {
                  ////////////////////
                  let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + vm.getSessionToken(),
                  };
                  let requestData = {
                    key: {
                      instanceId: "OA_UAT",
                      clientId: vm.clientId,
                      eventId: vm.eventId,
                    },
                    data: {
                      Sessions: { SessionId: [vm.sessionId] },
                      Tables: { TableId: [], TopicId: [] },
                    },
                  };
                  axios
                    .post(APIs.EndCall, requestData, {
                      headers: headers,
                    })
                    .then((responseData) => {
                      //alert("Ended By Host");
                      console.log(responseData);
                    })
                    .catch(function (error) {
                      console.log("Error : " + error);
                    });

                  //let headers = {
                  //  "content-type": "application/json",
                  //  Authorization: "Bearer " + vm.getSessionToken(),
                  //};
                  //let requestData = {
                  //  collection: "SessionList/Sessions",
                  //  instance: obj.eventcollectionname,
                  //  data: {
                  //    //EndedByHost: true,
                  //    EndRequest: new Date().getTime(),
                  //    EndedBy: vm.uid,
                  //    id: vm.sessionId,
                  //  },
                  //};
                  //axios
                  //  .put(APIs.WriteObject, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((responseData) => {
                  //    //alert("Ended By Host");
                  //    console.log(responseData);
                  //  })
                  //  .catch(function (error) {
                  //    console.log("Error : " + error);
                  //  });
                }, 1000);
              }
            });
        } else if (
          vm.sessionTypeId == vm.RoundTableTypeID &&
          vm.roundTableId != ""
        ) {
          db.collection(obj.eventcollectionname)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(vm.roundTableId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                vm.BroadCastStopRecording();
                setTimeout(() => {
                  let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + vm.getSessionToken(),
                  };
                  let requestData = {
                    key: {
                      instanceId: "OA_UAT",
                      clientId: vm.clientId,
                      eventId: vm.eventId,
                    },
                    data: {
                      Sessions: { SessionId: [] },
                      Tables: { TableId: [vm.roundTableId], TopicId: [] },
                    },
                  };
                  axios
                    .post(APIs.EndCall, requestData, {
                      headers: headers,
                    })
                    .then((responseData) => {
                      //alert("Ended By Host");
                      console.log(responseData);
                    })
                    .catch(function (error) {
                      console.log("Error : " + error);
                    });
                  //let headers = {
                  //  "content-type": "application/json",
                  //  Authorization: "Bearer " + vm.getSessionToken(),
                  //};
                  //let requestData = {
                  //  collection: "RoundTableList/RoundTables",
                  //  instance: obj.eventcollectionname,
                  //  data: {
                  //    //EndedByHost: true,
                  //    EndRequest: new Date().getTime(),
                  //    EndedBy: vm.uid,
                  //    id: vm.roundTableId,
                  //  },
                  //};
                  //axios
                  //  .put(APIs.WriteObject, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((responseData) => {
                  //    console.log(responseData);
                  //  });
                }, 1000);
              }
            });
        }
      }
    },
    restoreSession(session, roundTable) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        //alert("Not Implemented");
        if (vm.sessionTypeId == vm.LivePanelTypeID && session) {
          db.collection(obj.eventcollectionname)
            .doc("SessionList")
            .collection("Sessions")
            .doc(session.SessionId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                if (
                  doc.data().MappedHosts &&
                  doc.data().MappedHosts.length > 0
                ) {
                  let hosts = doc.data().MappedHosts.filter(function (item) {
                    return item.AttendeeId == vm.uid;
                  });
                  let allCoHosts = doc.data().MappedCoHost
                    ? [doc.data().MappedCoHost]
                    : [];
                  let coHosts = allCoHosts.filter(function (item) {
                    return item.AttendeeId == vm.uid;
                  });
                  if (hosts.length > 0 || coHosts.length > 0) {
                    let headers = {
                      "content-type": "application/json",
                      Authorization: "Bearer " + vm.getSessionToken(),
                    };
                    let requestData = {
                      collection: "SessionList/Sessions",
                      instance: obj.eventcollectionname,
                      data: {
                        EndedByHost: false,
                        id: session.SessionId,
                      },
                    };
                    axios
                      .put(APIs.WriteObject, requestData, {
                        headers: headers,
                      })
                      .then((responseData) => {
                        console.log(responseData);
                      });
                  }
                }
              }
            });
        } else if (vm.sessionTypeId == vm.RoundTableTypeID && roundTable) {
          db.collection(obj.eventcollectionname)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(roundTable.TableId)
            .get()
            .then((doc) => {
              if (doc.exists) {
                if (doc.data().Host && doc.data().Host.length > 0) {
                  let hosts = doc.data().Host.filter(function (item) {
                    return item.AttendeeId == vm.uid;
                  });
                  let allCoHosts = doc.data().CoHost ? [doc.data().CoHost] : [];
                  let coHosts = allCoHosts.filter(function (item) {
                    return item.AttendeeId == vm.uid;
                  });
                  if (hosts.length > 0 || coHosts.length > 0) {
                    let headers = {
                      "content-type": "application/json",
                      Authorization: "Bearer " + vm.getSessionToken(),
                    };
                    let requestData = {
                      collection: "RoundTableList/RoundTables",
                      instance: obj.eventcollectionname,
                      data: {
                        EndedByHost: false,
                        id: roundTable.TableId,
                      },
                    };
                    axios
                      .put(APIs.WriteObject, requestData, {
                        headers: headers,
                      })
                      .then((responseData) => {
                        console.log(responseData);
                      });
                  }
                }
              }
            });
        }
      }
    },
    onCallEndedByHost() {
      vm.playerWaitText = "This meeting has been ended by host";
    },
    onEndCall(e) {
      $("#popupLeaveConfirm").modal("hide");
      if (!vm.inProcess) {
        if (e != undefined) {
          if (e.currentTarget.classList.contains("disabled")) {
            //alert("disabled");
            return;
          }
        }
        //if ($(".exitBtn").hasClass("start-call-btn")) {
        if (!vm.readyState) {
          if (e != undefined) {
            $(".exitBtn").removeClass("start-call-btn");
            //vm.StartCall(
            //  vm.clientId,
            //  vm.eventId,
            //  vm.channelName,
            //  vm.sessionTypeId,
            //  vm.session,
            //  vm.roundTable,
            //  vm.o2oMeeting,
            //  vm.attendeeType
            //);
            if (vm.tempValues) {
              vm.StartCall(
                vm.tempValues.clientId,
                vm.tempValues.eventId,
                vm.tempValues.channelName,
                vm.tempValues.sessionTypeId,
                vm.tempValues.session,
                vm.tempValues.roundTable,
                vm.tempValues.o2oMeeting,
                vm.tempValues.attendeeType,
                vm.tempValues.callSettings,
                vm.tempValues.exMeetingId,
                vm.tempValues.meetingHostId
              );
            }
          }
        } else {
          if ((!vm.IsLive && !vm.IsGoLive) || vm.IsGoLive) {
            vm.playerWaitText = "You are in back stage, Please click on Join.";
          } else {
            vm.playerWaitText = "Session is live, Please click on Join.";
          }
          $(".exitBtn").addClass("start-call-btn");
          if (!vm.roomId && !vm.callSwitchingInProcess) {
            router.push(vm.stageUrl);
          }
          if (e) {
            //alert("DIRECT");
            vm.EndCall(true);
          } else {
            //alert("INDIRECT");
            vm.EndCall();
          }
        }
      }
    },

    EndCall(forceEnd) {
      vm.inProcess = true;
      //alert(vm.readyState);
      if (!forceEnd) {
        forceEnd = false;
      }
      vm.$emit("livePanelOnEnd", vm.roundTableId, forceEnd);
      if (vm.readyState) {
        //$(".single-call-handle-butn").hide();
        vm.stopShareScreen();
        try {
          vm.client &&
            vm.localStream &&
            this.client.unpublish(this.localStream);
          vm.localStream && this.localStream.close();
          if (vm.client && vm.EnableAgoraProxy) {
            vm.client.stopProxyServer();
          }
          vm.client &&
            vm.client.leave(
              () => {
                console.log("Client succeed to leave.");
                vm.inProcess = false;
              },
              () => {
                console.log("Client failed to leave.");
              }
            );
        } finally {
          if (ProfileRepairTimer) {
            clearInterval(ProfileRepairTimer);
          }
          vm.outgoungBandwidth = vm.minOutgoungBandwidth;
          vm.incomingBandwidth = vm.minIncomingBandwidth;
          vm.readyState = false;
          vm.client = null;
          vm.localStream = null;
          vm.recordingStarted = false;
          vm.streamList.map((item) => {
            let id = item.getId();
            vm.removeStream(id);
          });
          //vm.changePlayerStatus(0);
          //vm.$router.push("/sessions");
        }
      } else {
        vm.inProcess = false;
      }
    },
    startMeeting(meetingId) {
      if (meetingId) {
        vm.$emit("startMeeting", meetingId);
      }
    },
    startShareScreen() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //alert();
      if (obj != undefined && obj != null) {
        if (
          vm.shareClient == {} ||
          vm.shareClient == undefined ||
          vm.shareClient == null
        ) {
          vm.shareClient = AgoraRTC.createClient({ mode: vm.transcode });
          //vm.shareClient = AgoraRTC.createClient({ mode: vm.transcode, codec: "vp8" });
        }
        if (vm.shareClient && vm.EnableAgoraProxy) {
          //vm.shareClient.startProxyServer(3);
        }
        vm.shareClient.init(
          vm.liveVideoApiDetails.AppID,
          () => {
            //console.log("AgoraRTC shareClient initialized");
            vm.subscribeShareStreamEvents();
            //alert("vm.channel:" + vm.channel);
            //vm.shareClient.join(
            //  vm.appId,
            //  vm.channelName,
            //  vm.shareUid,
            //  (uid) => {
            vm.shareClient.join(
              vm.token,
              vm.channelName,
              vm.shareUid,
              (uid) => {
                //vm.shareClient.join(token, vm.channel, 0, (uid) => {
                //shareClient.join(token, channelName, 0, function(uid) {
                console.log("User " + uid + " join channel successfully");
                console.log("At " + new Date().toLocaleTimeString());
                // create local stream
                // It is not recommended to setState in function addStream
                vm.shareStream = this.streamInit(
                  uid,
                  "share",
                  vm.shareVideoProfile
                );

                vm.shareStream.on("stopScreenSharing", function (evt) {
                  console.log("" + evt);
                  //if(screenShareActive) {
                  vm.stopShareScreen();
                  //}
                });
                vm.shareStream.init(
                  () => {
                    if (vm.attendeeMode !== "audience") {
                      //	vm.addStream(vm.shareStream, true);
                      vm.shareClient.publish(vm.shareStream, (err) => {
                        console.log("Publish local stream error: " + err);
                      });
                      setTimeout(() => {
                        vm.updateRecordingLayout(true);
                      }, 1000);
                    }
                    vm.readyShareState = true;
                  },
                  (err) => {
                    vm.stopShareScreen(true);
                    console.log("getUserMedia failed", err);
                    //vm.readyShareState = true;
                  }
                );
              }
            );
          },
          (err) => {
            vm.stopShareScreen(true);
            console.log("getUserMedia failed", err);
            //vm.readyShareState = true;
          }
        );
        //}
      }
    },

    updateRecordingLayout(hasScreenShare) {
      if (vm.recordingStarted) {
        let headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        var requestData;
        if (hasScreenShare) {
          //alert("start layout");
          requestData = {
            channel: vm.channelName.replace("_gr", ""),
            resourceId: vm.RecResourceId,
            sId: vm.RecSid,
            primeUserId: vm.shareUid,
          };
        } else {
          //alert("stop layout");
          requestData = {
            channel: vm.channelName.replace("_gr", ""),
            resourceId: vm.RecResourceId,
            sId: vm.RecSid,
          };
        }

        axios
          .post(vm.PlayerAPIConfig.UpdateRecordingLayout, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            let data = responseData.data;
            console.log(data);
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },

    subscribeShareStreamEvents() {
      //let rt = this;
      ////alert("subscribeStreamEvents");
      //rt.shareClient.on("stream-added", function (evt) {
      //  let stream = evt.stream;
      //  //alert("share-stream-added:" + stream.getId());
      //  console.log("New stream added: " + stream.getId());
      //  console.log("At " + new Date().toLocaleTimeString());
      //  console.log("Subscribe ", stream);
      //  //alert(stream.getId());
      //  //vm.activeScreenUID = stream.getId();
      //  //let id = stream.getId();
      //  rt.shareClient.subscribe(stream, function (err) {
      //    console.log("Subscribe stream failed", err);
      //    alert("Subscribe stream failed", err);
      //  });
      //  //rt.client.enableAudioVolumeIndicator(stream, function (err) {
      //  //  console.log("Subscribe stream failed", err);
      //  //  alert("enableAudioVolumeIndicator");
      //  //});
      //});
      //rt.shareClient.on("peer-leave", function (evt) {
      //  //alert("share-peer-leave");
      //  //vm.activeScreenUID = 0;
      //  console.log("Peer has left: " + evt.uid);
      //  console.log(new Date().toLocaleTimeString());
      //  console.log(evt);
      //  rt.removeStream(evt.uid);
      //});
      //rt.shareClient.on("stream-unsubscribed", function (evt) {
      //  let stream = evt.stream;
      //  alert("share-stream-unsubscribed:" + stream.getId());
      //});
      //rt.shareClient.on("stream-subscribed", function (evt) {
      //  let stream = evt.stream;
      //  //alert(stream.getId());
      //  //alert("share-stream-subscribed:" + stream.getId());
      //  console.log("Got stream-subscribed event");
      //  console.log(new Date().toLocaleTimeString());
      //  console.log("Subscribe remote stream successfully: " + stream.getId());
      //  console.log(evt);
      //  rt.addStream(stream);
      //  //let id = stream.getId();
      //});
    },

    stopShareScreen(skipLayoutUpdate) {
      //alert("stopShareScreen");
      //console.log(e);
      //if (e.currentTarget.classList.contains("disabled")) {
      //  return;
      //}
      try {
        this.shareClient && this.shareClient.unpublish(this.shareStream);
        this.shareStream && this.shareStream.close();
        //if (vm.shareClient && vm.EnableAgoraProxy) {
        //  vm.shareClient.stopProxyServer();
        //}
        this.shareClient &&
          this.shareClient.leave(
            () => {
              console.log("shareClient succeed to leave.");
            },
            () => {
              console.log("shareClient failed to leave.");
            }
          );
      } finally {
        this.readyShareState = false;
        this.shareClient = null;
        this.shareStream = null;
        // redirect to index
        //this.$router.push("/");
        if (!skipLayoutUpdate && vm.shareScreenCount() == 1) {
          //alert("stop rec layout:" + vm.shareScreenCount());
          vm.updateRecordingLayout(false);
        }
      }
    },

    readAllAttendees() {
      this.allAttendees = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        db.collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("Attendees")
          .where("IsPublished", "==", true)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let objA = {};
              objA.AttendeeId = doc.data().AttendeeId;
              objA.Name = doc.data().Name;
              objA.FirstName = doc.data().FirstName;
              objA.LastName = doc.data().LastName;
              objA.Email = doc.data().Email;
              objA.ProfilePictureURL = vm.getCDNUrl(
                doc.data().ProfilePictureURL
              );
              objA.Designation = doc.data().Designation;
              objA.Company = doc.data().Company;
              vm.allAttendees.push(objA);
            });
            //vm.addAllUserProfile();
          });
      }
    },
    onRequestAllSpeakersToMute() {
      if (!$(".ag-option-mute-all").hasClass("disabled")) {
        //$(".more-action-notification").html("Request sent");
        //$(".more-action-notification").removeClass("hidden");
        //setTimeout(() => {
        //  $(".more-action-notification").addClass("hidden");
        //}, 5000);
        $(".ag-option-mute-all").addClass("disabled");
        vm.requestAllSpeakersToMute(0, true);
      }
    },
    requestAllSpeakersToMute(type, forceMute) {
      vm.$emit("requestAllSpeakersToMute", {
        type: type,
        forceMute: forceMute,
      });
    },
    requestAllSpeakersToMuteResult(success) {
      if (success) {
        alert("Success");
      }
    },
    requestSpeakerToMute(uid, type, forceMute) {
      vm.$emit("requestSpeakerToMute", {
        uid: uid,
        type: type,
        forceMute: forceMute,
      });
    },
    //requestSpeakerToUnmute(uid) {
    //  vm.$emit("requestSpeakerToUnmute", { uid: uid, type: 1 });
    //},
    requestSpotlight(uid, type) {
      //vm.activeScreenUID = uid;
      //vm.displayMode = "pip";
      //vm.pinSelected = true;
      vm.$emit("requestSpotlight", {
        uid: uid,
        type: type,
      });
    },
    addAllUserProfile() {
      vm.streamList.map(() => {
        //let id = item.getId();
        //vm.addUserProfile(id);
      });
    },
    openSpeakerPanel(uid) {
      vm.$emit("openSpeakerPanel", uid);
    },
    openAttendeePanel(e) {
      vm.$emit("openAttendeePanel");
      e.stopPropagation();
    },
    replay(uid) {
      let streams = vm.streamList.filter(function (item) {
        return item.getId() == uid;
      });
      if (streams.length > 0) {
        streams[0].play("ag-item-" + uid);
      }
    },
    addUserProfile(uid, resume) {
      let isVideoOn = true;
      if (uid == vm.uid) {
        isVideoOn = vm.localStream.isVideoOn();
      } else {
        let userType = document.querySelector("#utype-" + uid);
        if (!userType || !resume) {
          var streams = vm.streamList.filter(function (item) {
            return item.getId() == uid;
          });
          if (streams.length > 0) {
            isVideoOn = streams[0].hasVideo() && streams[0].isVideoOn();
          }
        } else {
          let speakers = vm.allSpeakers.filter((item) => {
            return item.AttendeeId == uid;
          });
          if (speakers.length > 0) {
            if (speakers[0].IsVideoOn) {
              isVideoOn = speakers[0].IsVideoOn;
            }
          }
        }
      }

      //var stream = vm.streamList.filter(function (item) {
      //  return item.getId() == uid;
      //});
      //if (stream.length > 0) {
      //  isVideoOn = stream[0].hasVideo() && stream[0].isVideoOn();
      //}
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj) {
        if (obj.user) {
          let name = "";
          let fName = "";
          let nameInitial = "";
          let profileImage = "";
          let title = "";
          let company = "";
          let userFound = false;
          let UserTypeName = ""; //"ATTENDEE";
          let user = null;
          //let canvas = document.querySelector("#ag-canvas");
          //let leftPanel = document.querySelector("#ag-left-panel");
          //let rightPanel = document.querySelector("#ag-right-panel");

          let hosts = vm.allHosts.filter(function (item) {
            return item.AttendeeId == uid;
          });
          let coHosts = vm.allCoHosts.filter(function (item) {
            return item.AttendeeId == uid;
          });
          //let hosts = [];
          //if (vm.allHosts.length > 0) {
          //  if (vm.allHosts[0].AttendeeId == uid) {
          //    hosts.push(vm.allHosts[0]);
          //  }
          //}
          if (hosts.length > 0) {
            UserTypeName = "HOST";
            userFound = true;
            user = hosts[0];
          } else if (coHosts.length > 0) {
            UserTypeName = "CO-HOST";
            userFound = true;
            user = coHosts[0];
          } else {
            let speakers = vm.allSpeakers.filter(function (item) {
              return item.AttendeeId == uid;
            });
            if (speakers.length > 0) {
              user = speakers[0];
              if (vm.sessionTypeId == vm.LivePanelTypeID) {
                UserTypeName = "SPEAKER";
                userFound = true;
              } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
                UserTypeName = "GUEST";
                userFound = true;
              }
            } else {
              //if (vm.sessionTypeId == vm.O2OTypeID) {
              //  if (vm.attendeeType == 1) {
              //    UserTypeName = "HOST";
              //    userFound = true;
              //  } else {
              //    UserTypeName = "GUEST";
              //    userFound = true;
              //  }
              //} else if (vm.sessionTypeId == vm.E2OTypeID) {
              //  UserTypeName = "GUEST";
              //  userFound = true;
              //}
            }
          }
          if (user == null) {
            //alert(vm.sessionTypeId);
            //alert(uid);
            if (vm.sessionTypeId == vm.RoundTableTypeID) {
              let attendees = vm.allAttendees.filter(function (item) {
                return item.AttendeeId == uid;
              });
              if (attendees.length > 0) {
                user = attendees[0];
                UserTypeName = "GUEST";
                userFound = true;
              }
            } else if (vm.sessionTypeId == vm.O2OTypeID) {
              let attendees = vm.allAttendees.filter(function (item) {
                return item.AttendeeId == uid;
              });
              if (attendees.length > 0) {
                user = attendees[0];
                UserTypeName = "";
                userFound = true;
              }
            } else if (vm.sessionTypeId == vm.E2OTypeID) {
              let attendees = vm.allAttendees.filter(function (item) {
                return item.AttendeeId == uid;
              });
              if (attendees.length > 0) {
                user = attendees[0];
                UserTypeName = "VISITOR";
                if (vm.meetingHostId && vm.meetingHostId == uid) {
                  UserTypeName = "BOOTH REP.";
                }
                userFound = true;
              }
            } else if (vm.sessionTypeId == 100) {
              let attendees = vm.allAttendees.filter(function (item) {
                return item.AttendeeId == uid;
              });
              if (attendees.length > 0) {
                user = attendees[0];
                UserTypeName = "";
                if (vm.meetingHostId && vm.meetingHostId == uid) {
                  UserTypeName = "";
                }
                userFound = true;
              }
            }
          }
          //alert("share");
          //if (UserTypeName == "") {
          //  //if (UserTypeName == "" && uid.toString().indexOf("share") == -1) {
          //  if (vm.sessionTypeId == vm.LivePanelTypeID) {
          //    UserTypeName = "SPEAKER";
          //    userFound = true;
          //  } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
          //    UserTypeName = "GUEST";
          //    userFound = true;
          //  }
          //}
          //alert(uid);
          if (UserTypeName == "" && uid < vm.shareIdStartsAfter) {
            //if (UserTypeName == "" && uid.toString().indexOf("share") == -1) {
            if (vm.sessionTypeId == vm.LivePanelTypeID) {
              UserTypeName = "SPEAKER";
              userFound = true;
            } else if (vm.sessionTypeId == vm.RoundTableTypeID) {
              UserTypeName = "GUEST";
              userFound = true;
            }
          }
          if (user != null) {
            name = user.Name == undefined ? "" : user.Name;
            fName = user.FirstName == undefined ? "" : user.FirstName;
            nameInitial = common.getInitials(name);
            profileImage =
              user.ProfilePictureURL == undefined ? "" : user.ProfilePictureURL;
            title = user.Designation == undefined ? "" : user.Designation;
            company = user.Company == undefined ? "" : user.Company;
          }
          //if (
          //  canvas.childNodes.length +
          //    leftPanel.childNodes.length +
          //    rightPanel.childNodes.length ==
          //  1
          //) {
          //  UserTypeName = "HOST";
          //} else {
          //  UserTypeName = "SPEAKER";
          //}
          //if (obj.user[0].id == uid) {
          //  name = obj.user[0].name;
          //  fName = obj.user[0].fname;
          //  profileImage = obj.user[0].profilepic;
          //  title = obj.user[0].title;
          //  company = obj.user[0].company;
          //  userFound = true;
          //} else {
          //  var attendees = vm.allAttendees.filter(function (value) {
          //    return value.AttendeeId == uid;
          //  });
          //  if (attendees.length > 0) {
          //    name = attendees[0].name;
          //    fName = attendees[0].fname;
          //    profileImage = attendees[0].profilepic;
          //    title = attendees[0].title;
          //    company = attendees[0].company;
          //    userFound = true;
          //  }
          //}

          if (userFound) {
            let domPlayer = document.querySelector("#ag-user-" + uid);

            //domFrame.addEventListener("click", function () {
            //  vm.replay(uid);
            //});
            let domPlayer1 = document.querySelector("#player_" + uid);
            if (domPlayer) {
              domPlayer.setAttribute("firstName", fName);
              domPlayer.setAttribute("asrank", "0");
              domPlayer1.setAttribute("class", "ag-player player-share");
              //HOST OR SPEAKER
              let domUserType = document.querySelector("#utype-" + uid);
              if (!domUserType) {
                if (UserTypeName != "") {
                  domUserType = document.createElement("div");
                  domUserType.setAttribute("id", "utype-" + uid);
                  domUserType.setAttribute("class", "ag-user-type");

                  let elp = document.createElement("a");
                  elp.setAttribute("class", "ag-h4");
                  let nodep = document.createTextNode(UserTypeName);
                  elp.appendChild(nodep);
                  domUserType.appendChild(elp);

                  domPlayer.appendChild(domUserType);
                }
              }

              let optionMenu = document.querySelector("#ag-option-menu-" + uid);
              if (!optionMenu) {
                optionMenu = document.createElement("div");
                optionMenu.setAttribute("id", "ag-option-menu-" + uid);
                optionMenu.setAttribute("class", "ag-option-menu d-none");
                let el = document.createElement("span");
                optionMenu.appendChild(el);
                el = document.createElement("span");
                optionMenu.appendChild(el);
                el = document.createElement("span");
                optionMenu.appendChild(el);
                domPlayer.appendChild(optionMenu);

                optionMenu.addEventListener("click", function (e) {
                  if (
                    $("#ag-option-group-" + uid + ".ag-option-group").hasClass(
                      "hidden"
                    )
                  ) {
                    vm.hidePopup();
                    $(
                      "#ag-option-group-" + uid + ".ag-option-group"
                    ).removeClass("hidden");
                  } else {
                    $("#ag-option-group-" + uid + ".ag-option-group").addClass(
                      "hidden"
                    );
                  }
                  e.stopPropagation();
                });
              }

              //////PIN
              //if (vm.AllowPinVideoTile) {
              //  let domUserPin = document.querySelector("#upin-" + uid);
              //  if (!domUserPin) {
              //    domUserPin = document.createElement("div");
              //    domUserPin.setAttribute("id", "upin-" + uid);
              //    domUserPin.setAttribute("class", "ag-user-pin hidden");

              //    let elp = document.createElement("a");
              //    elp.setAttribute("class", "ag-pin");
              //    elp.setAttribute("id", "pin-" + uid);
              //    elp.addEventListener("click", function () {
              //      if ($("#pin-" + uid).hasClass("ag-pin")) {
              //        $(".ag-user-pin a")
              //          .removeClass("ag-unpin")
              //          .addClass("ag-pin");
              //        $("#pin-" + uid).removeClass("ag-pin");
              //        $("#pin-" + uid).addClass("ag-unpin");
              //        vm.pinSelected = true;
              //      } else {
              //        $("#pin-" + uid).removeClass("ag-unpin");
              //        $("#pin-" + uid).addClass("ag-pin");
              //        vm.pinSelected = false;
              //      }
              //      //vm.pinSelected = !vm.pinSelected;
              //      if (vm.pinSelected) {
              //        vm.pinVideoTile(uid);
              //      }
              //    });
              //    domUserPin.appendChild(elp);

              //    domPlayer.appendChild(domUserPin);
              //  }
              //}

              //OPTIONS
              let domUserOptionGroup = document.querySelector(
                "#ag-option-group-" + uid
              );
              if (!domUserOptionGroup) {
                domUserOptionGroup = document.createElement("div");
                domUserOptionGroup.setAttribute("id", "ag-option-group-" + uid);
                domUserOptionGroup.setAttribute(
                  "class",
                  "ag-option-group hidden"
                );

                let notification = document.createElement("div");
                notification.setAttribute(
                  "id",
                  "ag-action-notification-" + uid
                );
                notification.setAttribute(
                  "class",
                  "action-notification hidden"
                );

                domUserOptionGroup.appendChild(notification);
                domUserOptionGroup.addEventListener("click", function (e) {
                  e.stopPropagation();
                });

                //PIN
                if (vm.AllowPinVideoTile) {
                  let domUserOption = document.querySelector(
                    "#ag-option-pin-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute("id", "ag-option-pin-" + uid);
                    domUserOption.setAttribute(
                      "class",
                      "ag-option ag-option-pin"
                    );

                    let elp = document.createElement("a");
                    elp.setAttribute("class", "ag-option-icon ag-pin-user");
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Pin");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOption.addEventListener("click", function () {
                      if (
                        $(
                          "#ag-option-pin-" + uid + " .ag-option-icon"
                        ).hasClass("ag-pin-user")
                      ) {
                        $(".ag-option-pin").removeClass("disabled");
                        $("#ag-option-pin-" + uid).addClass("disabled");
                        $(".ag-option-pin .ag-option-icon")
                          .removeClass("ag-unpin-user")
                          .addClass("ag-pin-user");
                        $(
                          "#ag-option-pin-" + uid + " .ag-option-icon"
                        ).addClass("ag-unpin-user");
                        //$(
                        //  "#ag-option-pin-" + uid + " .ag-option-label"
                        //).html("Unpin");

                        $(".ag-spotlight .ag-spotlight-on")
                          .removeClass("ag-spotlight-on")
                          .addClass("ag-spotlight-off");
                        vm.pinSelected = true;
                        vm.pinVideoTile(uid);
                      } else {
                        //$("#ag-option-pin-" + uid + " .ag-option-icon")
                        //  .removeClass("ag-unpin-user")
                        //  .addClass("ag-pin-user");
                        //$(
                        //  "#ag-option-pin-" + uid + " .ag-option-label"
                        //).html("Pin");
                        //vm.pinSelected = false;
                      }
                    });

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }

                if (
                  vm.hostOptionsEnabled &&
                  [3, 4].includes(vm.sessionTypeId) &&
                  (vm.hostCanMuteSpeaker ||
                    vm.hostCanHideSpeaker ||
                    vm.hostCanSpotlightSpeaker)
                ) {
                  if (vm.userType == 1 || vm.isUserCoHost(vm.uid)) {
                    //Mute
                    if (vm.hostCanMuteSpeaker && vm.uid != uid) {
                      let domUserOption = document.querySelector(
                        "#ag-option-mute-" + uid
                      );
                      if (!domUserOption) {
                        domUserOption = document.createElement("div");
                        domUserOption.setAttribute(
                          "id",
                          "ag-option-mute-" + uid
                        );
                        domUserOption.setAttribute("class", "ag-option");

                        let elp = document.createElement("a");
                        elp.setAttribute("class", "ag-option-icon ag-mute");
                        domUserOption.appendChild(elp);

                        elp = document.createElement("span");
                        elp.setAttribute("class", "ag-option-label");
                        let nodep = document.createTextNode("Mute");
                        elp.appendChild(nodep);
                        domUserOption.appendChild(elp);

                        domUserOption.addEventListener("click", function () {
                          if (
                            $(
                              "#ag-option-mute-" + uid + " .ag-option-icon"
                            ).hasClass("ag-mute")
                          ) {
                            $("#ag-option-mute-" + uid + " .ag-option-icon")
                              .removeClass("ag-mute")
                              .addClass("ag-unmute");
                            $(
                              "#ag-option-mute-" + uid + " .ag-option-label"
                            ).html("Request to unmute");
                            vm.requestSpeakerToMute(uid, 0, true);
                            //$("#ag-action-notification-" + uid).html(
                            //  "Request sent"
                            //);
                            //$("#ag-action-notification-" + uid).removeClass(
                            //  "hidden"
                            //);
                            //setTimeout(() => {
                            //  $("#ag-action-notification-" + uid).addClass(
                            //    "hidden"
                            //  );
                            //}, 5000);
                          } else {
                            //$("#ag-option-mute-" + uid + " .ag-option-icon")
                            //  .removeClass("ag-unmute")
                            //  .addClass("ag-mute");
                            //$(
                            //  "#ag-option-mute-" + uid + " .ag-option-label"
                            //).html("Mute");
                            vm.requestSpeakerToMute(uid, 1);
                            $("#ag-action-notification-" + uid).html(
                              "Request sent"
                            );
                            $("#ag-action-notification-" + uid).removeClass(
                              "hidden"
                            );
                            setTimeout(() => {
                              $("#ag-action-notification-" + uid).addClass(
                                "hidden"
                              );
                            }, 5000);
                          }
                        });

                        domUserOptionGroup.appendChild(domUserOption);
                      }

                      //Mute All
                      //domUserOption = document.querySelector(
                      //  "#ag-option-muteall-" + uid
                      //);
                      //if (!domUserOption) {
                      //  domUserOption = document.createElement("div");
                      //  domUserOption.setAttribute(
                      //    "id",
                      //    "ag-option-muteall-" + uid
                      //  );
                      //  domUserOption.setAttribute(
                      //    "class",
                      //    "ag-option-muteall ag-option"
                      //  );

                      //  let elp = document.createElement("a");
                      //  elp.setAttribute("class", "ag-option-icon ag-muteall");
                      //  domUserOption.appendChild(elp);

                      //  elp = document.createElement("span");
                      //  elp.setAttribute("class", "ag-option-label");
                      //  let nodep = document.createTextNode("Mute All");
                      //  elp.appendChild(nodep);
                      //  domUserOption.appendChild(elp);

                      //  domUserOption.addEventListener("click", function () {
                      //    if (
                      //      !$("#ag-option-muteall-" + uid).hasClass("disabled")
                      //    ) {
                      //      vm.requestAllSpeakersToMute(0, true);

                      //      //$("#ag-action-notification-" + uid).html(
                      //      //  "Request sent to mute all"
                      //      //);
                      //      //$("#ag-action-notification-" + uid).removeClass(
                      //      //  "hidden"
                      //      //);
                      //      //setTimeout(() => {
                      //      //  $("#ag-action-notification-" + uid).addClass(
                      //      //    "hidden"
                      //      //  );
                      //      //}, 5000);
                      //    }
                      //  });

                      //  domUserOptionGroup.appendChild(domUserOption);
                      //}

                      ////Unmute All
                      //domUserOption = document.querySelector(
                      //  "#ag-option-unmuteall-" + uid
                      //);
                      //if (!domUserOption) {
                      //  domUserOption = document.createElement("div");
                      //  domUserOption.setAttribute(
                      //    "id",
                      //    "ag-option-unmuteall-" + uid
                      //  );
                      //  domUserOption.setAttribute(
                      //    "class",
                      //    "ag-option-unmuteall ag-option"
                      //  );

                      //  let elp = document.createElement("a");
                      //  elp.setAttribute(
                      //    "class",
                      //    "ag-option-icon ag-unmuteall"
                      //  );
                      //  domUserOption.appendChild(elp);

                      //  elp = document.createElement("span");
                      //  elp.setAttribute("class", "ag-option-label");
                      //  let nodep = document.createTextNode("Unmute All");
                      //  elp.appendChild(nodep);
                      //  domUserOption.appendChild(elp);

                      //  domUserOption.addEventListener("click", function () {
                      //    if (
                      //      !$("#ag-option-unmuteall-" + uid).hasClass(
                      //        "disabled"
                      //      )
                      //    ) {
                      //      vm.requestAllSpeakersToMute(1);

                      //      $("#ag-action-notification-" + uid).html(
                      //        "Request sent to unmute all"
                      //      );
                      //      $("#ag-action-notification-" + uid).removeClass(
                      //        "hidden"
                      //      );
                      //      setTimeout(() => {
                      //        $("#ag-action-notification-" + uid).addClass(
                      //          "hidden"
                      //        );
                      //      }, 5000);
                      //    }
                      //  });

                      //  domUserOptionGroup.appendChild(domUserOption);
                      //}
                    }

                    //Visibility
                    if (vm.hostCanHideSpeaker) {
                      let domUserOption = document.querySelector(
                        "#ag-option-hide-" + uid
                      );
                      if (!domUserOption) {
                        domUserOption = document.createElement("div");
                        domUserOption.setAttribute(
                          "id",
                          "ag-option-hide-" + uid
                        );
                        domUserOption.setAttribute("class", "ag-option");

                        let elp = document.createElement("a");
                        elp.setAttribute("class", "ag-option-icon ag-hide");
                        domUserOption.appendChild(elp);

                        elp = document.createElement("span");
                        elp.setAttribute("class", "ag-option-label");
                        let nodep = document.createTextNode("Hide");
                        elp.appendChild(nodep);
                        domUserOption.appendChild(elp);

                        domUserOptionGroup.appendChild(domUserOption);
                      }
                    }

                    //Spotlight
                    if (vm.hostCanSpotlightSpeaker) {
                      let domUserOption = document.querySelector(
                        "#ag-option-spotlight-" + uid
                      );
                      if (!domUserOption) {
                        domUserOption = document.createElement("div");
                        domUserOption.setAttribute(
                          "id",
                          "ag-option-spotlight-" + uid
                        );
                        domUserOption.setAttribute(
                          "class",
                          "ag-option ag-spotlight"
                        );

                        let elp = document.createElement("a");
                        elp.setAttribute(
                          "class",
                          "ag-option-icon ag-spotlight-off"
                        );
                        domUserOption.appendChild(elp);

                        elp = document.createElement("span");
                        elp.setAttribute("class", "ag-option-label");
                        let nodep = document.createTextNode("Spotlight");
                        elp.appendChild(nodep);
                        domUserOption.appendChild(elp);

                        domUserOption.addEventListener("click", function () {
                          //vm.requestSpotlight(uid);
                          if (
                            $(
                              "#ag-option-spotlight-" + uid + " .ag-option-icon"
                            ).hasClass("ag-spotlight-off")
                          ) {
                            vm.requestSpotlight(uid, 1);
                            $(
                              "#ag-option-spotlight-" + uid + " .ag-option-icon"
                            )
                              .removeClass("ag-spotlight-off")
                              .addClass("ag-spotlight-on");
                            //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                            //  "Spotlight"
                            //);

                            //$("#ag-action-notification-" + uid).html(
                            //  "Request sent to Spotlight"
                            //);
                            //$("#ag-action-notification-" + uid).removeClass(
                            //  "hidden"
                            //);
                            //setTimeout(() => {
                            //  $("#ag-action-notification-" + uid).addClass(
                            //    "hidden"
                            //  );
                            //}, 5000);
                          } else {
                            vm.requestSpotlight(uid, 0);
                            $(
                              "#ag-option-spotlight-" + uid + " .ag-option-icon"
                            )
                              .removeClass("ag-spotlight-on")
                              .addClass("ag-spotlight-off");
                            //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                            //  "Spotlight"
                            //);

                            //$("#ag-action-notification-" + uid).html(
                            //  "Request sent to Remove Spotlight"
                            //);
                            //$("#ag-action-notification-" + uid).removeClass(
                            //  "hidden"
                            //);
                            //setTimeout(() => {
                            //  $("#ag-action-notification-" + uid).addClass(
                            //    "hidden"
                            //  );
                            //}, 5000);
                          }
                        });

                        domUserOptionGroup.appendChild(domUserOption);
                      }
                    }
                  }
                }
                domPlayer.appendChild(domUserOptionGroup);
              }
              //$('.ag-option-group:empty').remove();

              let domProfile = document.querySelector("#profile-" + uid);
              if (!domProfile) {
                domProfile = document.createElement("div");
                domProfile.setAttribute("id", "profile-" + uid);
                domProfile.setAttribute("class", "ag-profile");

                let profileDesc = document.createElement("div");
                profileDesc.setAttribute("class", "profile-desc");

                profileDesc.addEventListener("click", function (e) {
                  vm.openSpeakerPanel(uid);
                  e.stopPropagation();
                });
                //alert("profileDesc");
                //profileDesc.addEventListener("click", function (event) {
                //  //alert("profileDesc");
                //  vm.MakeVideoFullscreen(uid);
                //  event.stopPropagation();
                //});
                domProfile.appendChild(profileDesc);

                let el = document.createElement("div");
                el.setAttribute("class", "ag-profile-name");
                let node = document.createTextNode(name);
                el.appendChild(node);
                profileDesc.appendChild(el);

                if (vm.ShowAudioVolume) {
                  //el = document.createElement("div");
                  //el.setAttribute("class", "ag-asr");
                  //node = document.createTextNode("0");
                  //el.appendChild(node);
                  //profileDesc.appendChild(el);
                }

                if (vm.DisplayCompanyAndTitleInVideoTile) {
                  el = document.createElement("div");
                  el.setAttribute("class", "ag-profile-title");
                  node = document.createTextNode(title);
                  el.appendChild(node);
                  profileDesc.appendChild(el);

                  el = document.createElement("div");
                  el.setAttribute("class", "ag-profile-company");
                  node = document.createTextNode(company);
                  el.appendChild(node);
                  profileDesc.appendChild(el);
                }

                let profileVolumeControl = document.createElement("div");
                profileVolumeControl.setAttribute("class", "sound-gif");

                domProfile.appendChild(profileVolumeControl);

                let imgS = document.createElement("a");
                //imgS.setAttribute(
                //  "src",
                //  "../../../assets/Player/images/icon-muted.png"
                //);
                //imgS.setAttribute("src", "../assets/Player/images/ag-logo.png");
                imgS.setAttribute("class", "sound-unmuted");
                //imgS.setAttribute("height", "132px");
                //imgS.setAttribute("width", "132px");
                imgS.setAttribute("id", "audio-indicator-" + uid);

                //if (vm.attendeeType == 1 && vm.uid != uid) {
                //  imgS.addEventListener("click", function (e) {
                //    if (!e.target.classList.contains("sound-muted")) {
                //      vm.requestSpeakerToMute(uid, true);
                //    }
                //    e.stopPropagation();
                //  });
                //}
                profileVolumeControl.appendChild(imgS);

                domPlayer.appendChild(domProfile);

                if (vm.DebugMode) {
                  if (uid == vm.uid) {
                    el = document.createElement("div");
                    el.setAttribute("class", "ag-ul");
                    profileDesc.appendChild(el);
                  } else {
                    el = document.createElement("div");
                    el.setAttribute("class", "ag-dl");
                    profileDesc.appendChild(el);
                  }
                }
              }

              let networkProfile = document.querySelector(
                "#player-network-error-" + uid
              );
              if (!networkProfile) {
                networkProfile = document.createElement("div");
                networkProfile.setAttribute(
                  "id",
                  "player-network-error-" + uid
                );
                networkProfile.setAttribute("class", "ag-network-error d-none");
                let el = document.createElement("div");
                el.setAttribute("class", "network-error-loader");
                networkProfile.appendChild(el);

                el = document.createElement("span");
                el.setAttribute("class", "ag-err-msg");
                let node = document.createTextNode("Trying to reconnect");
                el.appendChild(node);
                networkProfile.appendChild(el);
                domPlayer.appendChild(networkProfile);
              }

              //if (isVideoOn==true) {
              //Display Profile Pecture
              let el1 = document.querySelector("#profileImage_" + uid);
              if (!el1) {
                el1 = document.createElement("div");
                el1.setAttribute("id", "profileImage_" + uid);
                el1.setAttribute(
                  "class",
                  "ag-profile-image name-initial d-none"
                );
                if (profileImage == avatarImageUrl) {
                  profileImage = "";
                }
                if (profileImage == "") {
                  let h4 = document.createElement("h4");
                  let nameInit = document.createTextNode(nameInitial);
                  h4.appendChild(nameInit);
                  el1.appendChild(h4);
                } else {
                  let img = document.createElement("img");
                  img.setAttribute("src", profileImage);
                  img.setAttribute("height", "132px");
                  img.setAttribute("width", "132px");
                  el1.appendChild(img);
                }
                domPlayer.appendChild(el1);
                //console.log(profileImage);
              }
              //}
              if (isVideoOn) {
                el1.setAttribute(
                  "class",
                  "ag-profile-image name-initial d-none"
                );
              } else {
                el1.setAttribute("class", "ag-profile-image name-initial");
              }
            }
          } else {
            //alert("");
            let domPlayer = document.querySelector("#ag-user-" + uid);
            let domPlayer1 = document.querySelector("#player_" + uid);
            if (domPlayer) {
              domPlayer.setAttribute("firstName", fName);
              domPlayer.setAttribute("asrank", "0");
              //domPlayer.setAttribute("class", "ag-player");
              //if (uid.indexOf("share_" >= 0)) {
              if (uid > vm.shareIdStartsAfter) {
                domPlayer1.setAttribute("class", "ag-player player-share");
              } else {
                domPlayer1.setAttribute("class", "ag-player");
              }

              let isShareScreen = false;
              name = uid.toString();
              //if (uid.indexOf("share") >= 0) {
              if (uid > vm.shareIdStartsAfter) {
                isShareScreen = true;
                //var shareUserId = uid.replace("share_", "");
                //alert(uid);
                var shareUserId = uid - vm.shareIdStartsAfter;
                //alert(shareUserId);
                //attendees = vm.allAttendees.filter(function (value) {
                //  return value.id == shareUserId;
                //});
                //if (attendees.length > 0) {
                //  name = attendees[0].name;
                //  fName = attendees[0].fname;
                //  profileImage = attendees[0].profilepic;
                //  title = attendees[0].title;
                //  company = attendees[0].company;
                //}
                //name = name + " is presenting";

                let hosts = vm.allHosts.filter(function (item) {
                  return item.AttendeeId == shareUserId;
                });
                if (hosts.length > 0) {
                  name = hosts[0].Name;
                } else {
                  let speakers = vm.allSpeakers.filter(function (item) {
                    return item.AttendeeId == shareUserId;
                  });
                  if (speakers.length > 0) {
                    name = speakers[0].Name;
                  }
                }
              }
              if (name == uid) {
                let attendees = vm.allAttendees.filter(function (item) {
                  return item.AttendeeId == shareUserId;
                });
                if (attendees.length > 0) {
                  name = attendees[0].Name;
                }
              }
              name = name + " is presenting";

              //SCREEN
              if (isShareScreen) {
                UserTypeName = "SCREEN";
              }
              let domUserType = document.querySelector("#utype-" + uid);
              if (!domUserType) {
                let domUserType = document.createElement("div");
                domUserType.setAttribute("id", "utype-" + uid);
                domUserType.setAttribute("class", "ag-user-type");

                let elp = document.createElement("a");
                elp.setAttribute("class", "ag-h4");
                let nodep = document.createTextNode(UserTypeName);
                elp.appendChild(nodep);
                domUserType.appendChild(elp);

                domPlayer.appendChild(domUserType);
              }

              let optionMenu = document.querySelector("#ag-option-menu-" + uid);
              if (!optionMenu) {
                optionMenu = document.createElement("div");
                optionMenu.setAttribute("id", "ag-option-menu-" + uid);
                optionMenu.setAttribute("class", "ag-option-menu d-none");
                let el = document.createElement("span");
                optionMenu.appendChild(el);
                el = document.createElement("span");
                optionMenu.appendChild(el);
                el = document.createElement("span");
                optionMenu.appendChild(el);
                domPlayer.appendChild(optionMenu);

                optionMenu.addEventListener("click", function (e) {
                  if (
                    $("#ag-option-group-" + uid + ".ag-option-group").hasClass(
                      "hidden"
                    )
                  ) {
                    vm.hidePopup();
                    $(
                      "#ag-option-group-" + uid + ".ag-option-group"
                    ).removeClass("hidden");
                  } else {
                    $("#ag-option-group-" + uid + ".ag-option-group").addClass(
                      "hidden"
                    );
                  }
                  e.stopPropagation();
                });
              }
              //PIN
              //let domUserPin = document.querySelector("#upin-" + uid);
              //if (!domUserPin) {
              //  let domUserPin = document.createElement("div");
              //  domUserPin.setAttribute("id", "upin-" + uid);
              //  domUserPin.setAttribute("class", "ag-user-pin hidden");

              //  let elp = document.createElement("a");
              //  elp.setAttribute("class", "ag-pin");
              //  elp.setAttribute("id", "pin-" + uid);
              //  elp.addEventListener("click", function (event) {
              //    if ($("#pin-" + uid).hasClass("ag-pin")) {
              //      $(".ag-user-pin a")
              //        .removeClass("ag-unpin")
              //        .addClass("ag-pin");
              //      $("#pin-" + uid).removeClass("ag-pin");
              //      $("#pin-" + uid).addClass("ag-unpin");
              //      vm.pinSelected = true;
              //    } else {
              //      $("#pin-" + uid).removeClass("ag-unpin");
              //      $("#pin-" + uid).addClass("ag-pin");
              //      vm.pinSelected = false;
              //    }
              //    //vm.pinSelected = !vm.pinSelected;
              //    if (vm.pinSelected) {
              //      vm.pinVideoTile(uid);
              //    }
              //    event.stopPropagation();
              //  });
              //  domUserPin.appendChild(elp);

              //  domPlayer.appendChild(domUserPin);
              //}

              //OPTIONS
              let domUserOptionGroup = document.querySelector(
                "#ag-option-group-" + uid
              );
              if (!domUserOptionGroup) {
                domUserOptionGroup = document.createElement("div");
                domUserOptionGroup.setAttribute("id", "ag-option-group-" + uid);
                domUserOptionGroup.setAttribute(
                  "class",
                  "ag-option-group hidden"
                );

                let notification = document.createElement("div");
                notification.setAttribute(
                  "id",
                  "ag-action-notification-" + uid
                );
                notification.setAttribute(
                  "class",
                  "action-notification hidden"
                );

                domUserOptionGroup.appendChild(notification);
                domUserOptionGroup.addEventListener("click", function (e) {
                  e.stopPropagation();
                });

                //PIN
                if (vm.AllowPinVideoTile) {
                  let domUserOption = document.querySelector(
                    "#ag-option-pin-" + uid
                  );
                  if (!domUserOption) {
                    domUserOption = document.createElement("div");
                    domUserOption.setAttribute("id", "ag-option-pin-" + uid);
                    domUserOption.setAttribute(
                      "class",
                      "ag-option ag-option-pin"
                    );

                    let elp = document.createElement("a");
                    elp.setAttribute("class", "ag-option-icon ag-pin-user");
                    domUserOption.appendChild(elp);

                    elp = document.createElement("span");
                    elp.setAttribute("class", "ag-option-label");
                    let nodep = document.createTextNode("Pin");
                    elp.appendChild(nodep);
                    domUserOption.appendChild(elp);

                    domUserOption.addEventListener("click", function () {
                      if (
                        $(
                          "#ag-option-pin-" + uid + " .ag-option-icon"
                        ).hasClass("ag-pin-user")
                      ) {
                        $("#ag-option-pin-" + uid + " .ag-option-icon")
                          .removeClass("ag-pin-user")
                          .addClass("ag-unpin-user");
                        $("#ag-option-pin-" + uid).addClass("disabled");
                        //$(
                        //  "#ag-option-pin-" + uid + " .ag-option-label"
                        //).html("Unpin");
                        vm.pinSelected = true;
                        vm.pinVideoTile(uid);
                      } else {
                        //$("#ag-option-pin-" + uid + " .ag-option-icon")
                        //  .removeClass("ag-unpin-user")
                        //  .addClass("ag-pin-user");
                        //$(
                        //  "#ag-option-pin-" + uid + " .ag-option-label"
                        //).html("Pin");
                        //vm.pinSelected = false;
                      }
                    });

                    domUserOptionGroup.appendChild(domUserOption);
                  }
                }
                if (
                  vm.hostOptionsEnabled &&
                  [3, 4].includes(vm.sessionTypeId) &&
                  (vm.hostCanMuteSpeaker ||
                    vm.hostCanHideSpeaker ||
                    vm.hostCanSpotlightSpeaker)
                ) {
                  if (vm.userType == 1 || vm.isUserCoHost(vm.uid)) {
                    //Mute
                    //if (vm.hostCanMuteSpeaker && vm.uid != uid) {
                    //  let domUserOption = document.querySelector(
                    //    "#ag-option-mute-" + uid
                    //  );
                    //  if (!domUserOption) {
                    //    domUserOption = document.createElement("div");
                    //    domUserOption.setAttribute(
                    //      "id",
                    //      "ag-option-mute-" + uid
                    //    );
                    //    domUserOption.setAttribute("class", "ag-option");

                    //    let elp = document.createElement("a");
                    //    elp.setAttribute("class", "ag-option-icon ag-mute");
                    //    domUserOption.appendChild(elp);

                    //    elp = document.createElement("span");
                    //    elp.setAttribute("class", "ag-option-label");
                    //    let nodep = document.createTextNode("Mute");
                    //    elp.appendChild(nodep);
                    //    domUserOption.appendChild(elp);

                    //    domUserOption.addEventListener("click", function () {
                    //      if (
                    //        $(
                    //          "#ag-option-mute-" + uid + " .ag-option-icon"
                    //        ).hasClass("ag-mute")
                    //      ) {
                    //        $("#ag-option-mute-" + uid + " .ag-option-icon")
                    //          .removeClass("ag-mute")
                    //          .addClass("ag-unmute");
                    //        $(
                    //          "#ag-option-mute-" + uid + " .ag-option-label"
                    //        ).html("Request to unmute");
                    //        vm.requestSpeakerToMute(uid, 0, true);
                    //        //$("#ag-action-notification-" + uid).html(
                    //        //  "Request sent to mute"
                    //        //);
                    //        //$("#ag-action-notification-" + uid).removeClass(
                    //        //  "hidden"
                    //        //);
                    //        //setTimeout(() => {
                    //        //  $("#ag-action-notification-" + uid).addClass(
                    //        //    "hidden"
                    //        //  );
                    //        //}, 5000);
                    //      } else {
                    //        //$("#ag-option-mute-" + uid + " .ag-option-icon")
                    //        //  .removeClass("ag-unmute")
                    //        //  .addClass("ag-mute");
                    //        //$(
                    //        //  "#ag-option-mute-" + uid + " .ag-option-label"
                    //        //).html("Mute");
                    //        vm.requestSpeakerToMute(uid, 1);
                    //        //$("#ag-action-notification-" + uid).html(
                    //        //  "Request sent to unmute"
                    //        //);
                    //        //$("#ag-action-notification-" + uid).removeClass(
                    //        //  "hidden"
                    //        //);
                    //        //setTimeout(() => {
                    //        //  $("#ag-action-notification-" + uid).addClass(
                    //        //    "hidden"
                    //        //  );
                    //        //}, 5000);
                    //      }
                    //    });

                    //    domUserOptionGroup.appendChild(domUserOption);
                    //  }

                    //  //Mute All
                    //  //domUserOption = document.querySelector(
                    //  //  "#ag-option-muteall-" + uid
                    //  //);
                    //  //if (!domUserOption) {
                    //  //  domUserOption = document.createElement("div");
                    //  //  domUserOption.setAttribute(
                    //  //    "id",
                    //  //    "ag-option-muteall-" + uid
                    //  //  );
                    //  //  domUserOption.setAttribute(
                    //  //    "class",
                    //  //    "ag-option-muteall ag-option"
                    //  //  );

                    //  //  let elp = document.createElement("a");
                    //  //  elp.setAttribute("class", "ag-option-icon ag-muteall");
                    //  //  domUserOption.appendChild(elp);

                    //  //  elp = document.createElement("span");
                    //  //  elp.setAttribute("class", "ag-option-label");
                    //  //  let nodep = document.createTextNode("Mute All");
                    //  //  elp.appendChild(nodep);
                    //  //  domUserOption.appendChild(elp);

                    //  //  domUserOption.addEventListener("click", function () {
                    //  //    if (
                    //  //      !$("#ag-option-muteall-" + uid).hasClass("disabled")
                    //  //    ) {
                    //  //      vm.requestAllSpeakersToMute(0, true);

                    //  //      //$("#ag-action-notification-" + uid).html(
                    //  //      //  "Request sent to mute all"
                    //  //      //);
                    //  //      //$("#ag-action-notification-" + uid).removeClass(
                    //  //      //  "hidden"
                    //  //      //);
                    //  //      //setTimeout(() => {
                    //  //      //  $("#ag-action-notification-" + uid).addClass(
                    //  //      //    "hidden"
                    //  //      //  );
                    //  //      //}, 5000);
                    //  //    }
                    //  //  });

                    //  //  domUserOptionGroup.appendChild(domUserOption);
                    //  //}

                    //  ////Unmute All
                    //  //domUserOption = document.querySelector(
                    //  //  "#ag-option-unmuteall-" + uid
                    //  //);
                    //  //if (!domUserOption) {
                    //  //  domUserOption = document.createElement("div");
                    //  //  domUserOption.setAttribute(
                    //  //    "id",
                    //  //    "ag-option-unmuteall-" + uid
                    //  //  );
                    //  //  domUserOption.setAttribute(
                    //  //    "class",
                    //  //    "ag-option-unmuteall ag-option"
                    //  //  );

                    //  //  let elp = document.createElement("a");
                    //  //  elp.setAttribute(
                    //  //    "class",
                    //  //    "ag-option-icon ag-unmuteall"
                    //  //  );
                    //  //  domUserOption.appendChild(elp);

                    //  //  elp = document.createElement("span");
                    //  //  elp.setAttribute("class", "ag-option-label");
                    //  //  let nodep = document.createTextNode("Unmute All");
                    //  //  elp.appendChild(nodep);
                    //  //  domUserOption.appendChild(elp);

                    //  //  domUserOption.addEventListener("click", function () {
                    //  //    if (
                    //  //      !$("#ag-option-unmuteall-" + uid).hasClass(
                    //  //        "disabled"
                    //  //      )
                    //  //    ) {
                    //  //      vm.requestAllSpeakersToMute(1);

                    //  //      $("#ag-action-notification-" + uid).html(
                    //  //        "Request sent to unmute all"
                    //  //      );
                    //  //      $("#ag-action-notification-" + uid).removeClass(
                    //  //        "hidden"
                    //  //      );
                    //  //      setTimeout(() => {
                    //  //        $("#ag-action-notification-" + uid).addClass(
                    //  //          "hidden"
                    //  //        );
                    //  //      }, 5000);
                    //  //    }
                    //  //  });

                    //  //  domUserOptionGroup.appendChild(domUserOption);
                    //  //}
                    //}

                    //Visibility
                    if (vm.hostCanHideSpeaker) {
                      let domUserOption = document.querySelector(
                        "#ag-option-hide-" + uid
                      );
                      if (!domUserOption) {
                        domUserOption = document.createElement("div");
                        domUserOption.setAttribute(
                          "id",
                          "ag-option-hide-" + uid
                        );
                        domUserOption.setAttribute("class", "ag-option");

                        let elp = document.createElement("a");
                        elp.setAttribute("class", "ag-option-icon ag-hide");
                        domUserOption.appendChild(elp);

                        elp = document.createElement("span");
                        elp.setAttribute("class", "ag-option-label");
                        let nodep = document.createTextNode("Hide");
                        elp.appendChild(nodep);
                        domUserOption.appendChild(elp);

                        domUserOptionGroup.appendChild(domUserOption);
                      }
                    }

                    //Spotlight
                    if (vm.hostCanSpotlightSpeaker) {
                      let domUserOption = document.querySelector(
                        "#ag-option-spotlight-" + uid
                      );
                      if (!domUserOption) {
                        domUserOption = document.createElement("div");
                        domUserOption.setAttribute(
                          "id",
                          "ag-option-spotlight-" + uid
                        );
                        domUserOption.setAttribute(
                          "class",
                          "ag-option ag-spotlight"
                        );

                        let elp = document.createElement("a");
                        elp.setAttribute(
                          "class",
                          "ag-option-icon ag-spotlight-off"
                        );
                        domUserOption.appendChild(elp);

                        elp = document.createElement("span");
                        elp.setAttribute("class", "ag-option-label");
                        let nodep = document.createTextNode("Spotlight");
                        elp.appendChild(nodep);
                        domUserOption.appendChild(elp);

                        domUserOption.addEventListener("click", function () {
                          //vm.requestSpotlight(uid);
                          if (
                            $(
                              "#ag-option-spotlight-" + uid + " .ag-option-icon"
                            ).hasClass("ag-spotlight-off")
                          ) {
                            vm.requestSpotlight(uid, 1);
                            $(
                              "#ag-option-spotlight-" + uid + " .ag-option-icon"
                            )
                              .removeClass("ag-spotlight-off")
                              .addClass("ag-spotlight-on");
                            //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                            //  "Spotlight"
                            //);

                            //$("#ag-action-notification-" + uid).html(
                            //  "Request sent to Spotlight"
                            //);
                            //$("#ag-action-notification-" + uid).removeClass(
                            //  "hidden"
                            //);
                            //setTimeout(() => {
                            //  $("#ag-action-notification-" + uid).addClass(
                            //    "hidden"
                            //  );
                            //}, 5000);
                          } else {
                            vm.requestSpotlight(uid, 0);
                            $(
                              "#ag-option-spotlight-" + uid + " .ag-option-icon"
                            )
                              .removeClass("ag-spotlight-on")
                              .addClass("ag-spotlight-off");
                            //$("#ag-option-spotlight-" + uid + " .ag-option-label").html(
                            //  "Spotlight"
                            //);

                            //$("#ag-action-notification-" + uid).html(
                            //  "Request sent to Remove Spotlight"
                            //);
                            //$("#ag-action-notification-" + uid).removeClass(
                            //  "hidden"
                            //);
                            //setTimeout(() => {
                            //  $("#ag-action-notification-" + uid).addClass(
                            //    "hidden"
                            //  );
                            //}, 5000);
                          }
                        });

                        domUserOptionGroup.appendChild(domUserOption);
                      }
                    }
                  }
                }
                domPlayer.appendChild(domUserOptionGroup);
              }
              let domProfile = document.querySelector("#profile-" + uid);
              if (!domProfile) {
                domProfile = document.createElement("div");
                domProfile.setAttribute("id", "profile-" + uid);
                domProfile.setAttribute("class", "ag-profile");

                let profileDesc = document.createElement("div");
                profileDesc.setAttribute("class", "profile-desc");
                domProfile.appendChild(profileDesc);

                let el = document.createElement("div");
                el.setAttribute("class", "ag-profile-name");
                let node = document.createTextNode(name);
                el.appendChild(node);
                profileDesc.appendChild(el);

                if (vm.ShowAudioVolume) {
                  //el = document.createElement("div");
                  //el.setAttribute("class", "ag-asr");
                  //node = document.createTextNode("0");
                  //el.appendChild(node);
                  //profileDesc.appendChild(el);
                }

                if (name == uid) {
                  let profileControl = document.createElement("div");
                  profileControl.setAttribute("class", "sound-gif");
                  domProfile.appendChild(profileControl);

                  let imgS = document.createElement("a");
                  imgS.setAttribute("class", "sound-unmuted");
                  imgS.setAttribute("id", "audio-indicator-" + uid);
                  profileControl.appendChild(imgS);

                  //imgS = document.createElement("a");
                  //imgS.setAttribute("class", "sound-muted d-none");
                  //profileControl.appendChild(imgS);

                  //imgS = document.createElement("a");
                  //imgS.setAttribute("class", "sound-talking d-none");
                  //profileControl.appendChild(imgS);
                }
                domPlayer.appendChild(domProfile);

                vm.pinVideoTileStatusUpdate(uid, true);
              }
            }
          }
        }
      }
    },
    MakeVideoFullscreen(id) {
      console.log(id);
      //alert(id); //ag-item-" + id
      if ($("#app").hasClass("full-screen-video")) {
        $("#app").removeClass("full-screen-video");
        vm.closeFullscreen();
      } else {
        $("#app").addClass("full-screen-video");
        vm.openFullscreen();
      }
    },
    openFullscreen() {
      let elem = document.getElementById("vueplayer");
      ///let elem = document.getElementById("LiveStage");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    IsFullScreenCurrently() {
      var full_screen_element =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement ||
        null;

      // If no element is in full-screen
      if (full_screen_element === null) {
        //alert("FULL SCREEN");
        return false;
      } else {
        //alert("SCREEN");
        return true;
      }
    },

    //getInitials: function (str) {
    //  var matches = str.match(/\b(\w)/g);
    //  var result = matches.join("");
    //  if (result.length > 2) {
    //    result = result.substring(0, 2);
    //  }
    //  return result;
    //},
    onMicChange(e) {
      //let microphone = "";
      //console.log(e.target.value);
      //console.log(vm.microphone);
      if (e.target.value) {
        //microphone = vm.microphone.deviceId;
        //alert(microphone);
        vm.applyMic();
        //if (vm.userType < 4 && microphone != "") {
        //  vm.localStream.switchDevice(
        //    "audio",
        //    microphone,
        //    function () {
        //      //vm.addUserProfile(vm.uid.toString());
        //      console.log("Microphone applied successfully");
        //      if (vm.rememberSettings) {
        //        vm.saveCallSettings("microphone", microphone);
        //      }
        //    },
        //    function () {
        //      console.log("Microphone apply faild");
        //    }
        //  );
        //}
      }
    },
    applyMic() {
      let microphone = "";
      if (vm.microphone) {
        microphone = vm.microphone.deviceId;
      }
      if (microphone) {
        vm.localStream.switchDevice(
          "audio",
          microphone,
          function () {
            //vm.addUserProfile(vm.uid.toString());
            console.log("Microphone applied successfully");
            if (vm.rememberSettings) {
              vm.saveCallSettings("microphone", microphone);
            }
          },
          function () {
            console.log("Microphone apply faild");
          }
        );
      }
    },
    onSpeakerChange(e) {
      let speaker = "";
      console.log(e.target.value);
      console.log(vm.speaker);
      if (e.target.value) {
        speaker = vm.speaker.deviceId;
        //alert(speaker);
        if (speaker != "") {
          vm.localStream.setAudioOutput(
            speaker,
            function () {
              //vm.addUserProfile(vm.uid.toString());
              console.log("Speaker applied successfully");
              if (vm.rememberSettings) {
                vm.saveCallSettings("speaker", speaker);
              }
            },
            function () {
              console.log("Microphone apply failed");
            }
          );
        }
      }
    },
    onCameraChange(e) {
      //let camera = "";
      console.log(e.target.value);
      console.log(vm.camera);
      if (e.target.value) {
        //camera = vm.camera.deviceId;
        //alert(camera);
        vm.applyCamera();
        //if (camera != "") {
        //  vm.localStream.switchDevice(
        //    "video",
        //    camera,
        //    function () {
        //      //vm.addUserProfile(vm.uid.toString());
        //      console.log("Camera applied successfully");
        //      if (vm.rememberSettings) {
        //        vm.saveCallSettings("camera", camera);
        //      }
        //    },
        //    function () {
        //      console.log("Camera apply failed");
        //    }
        //  );
        //}
      }
    },
    applyCamera() {
      let camera = "";
      if (vm.camera) {
        camera = vm.camera.deviceId;
      }
      if (camera) {
        vm.localStream.switchDevice(
          "video",
          camera,
          function () {
            //vm.addUserProfile(vm.uid.toString());
            console.log("Camera applied successfully");
            if (vm.rememberSettings) {
              vm.saveCallSettings("camera", camera);
            }
          },
          function () {
            console.log("Camera apply failed");
          }
        );
      }
    },
    onVideoResolutionChange(e) {
      let videoResolution = "";
      console.log(e.target.value);
      console.log(vm.videoResolution);
      if (e.target.value) {
        videoResolution = vm.videoResolution;
        //alert(videoResolution);
        if (videoResolution != "") {
          vm.localStream.setVideoProfile(videoResolution);
          //vm.addUserProfile(vm.uid.toString());
          vm.videoResolution = videoResolution;
          if (vm.rememberSettings) {
            vm.saveCallSettings("videoProfile", videoResolution);
          }
        }
      }
    },
    getAudioSettings() {
      AgoraRTC.getDevices(function (devices) {
        let savedMicrophone = vm.getCallSettings("microphone");
        let savedSpeaker = vm.getCallSettings("speaker");
        vm.microphoneOptions = [];
        vm.speakerOptions = [];
        devices.forEach(function (item) {
          let device = {
            deviceId: item.deviceId,
            groupId: item.groupId,
            kind: item.kind,
            label: item.label,
          };
          if (item.kind == "audioinput") {
            if (!vm.microphone.deviceId) {
              vm.microphone = device;
            }
            vm.microphoneOptions.push(device);
          } else if (item.kind == "audiooutput") {
            if (!vm.speaker.deviceId) {
              vm.speaker = device;
            }
            vm.speakerOptions.push(device);
          }
        });
        console.log(vm.microphoneOptions);
        console.log(vm.speakerOptions);

        if (vm.rememberSettings) {
          if (savedMicrophone != "") {
            let microphones = vm.microphoneOptions.find(function (item) {
              return item.deviceId == savedMicrophone;
            });
            if (microphones) {
              vm.microphone = microphones;
            }
          }
          if (savedSpeaker != "") {
            let speakers = vm.speakerOptions.find(function (item) {
              return item.deviceId == savedSpeaker;
            });
            if (speakers) {
              vm.speaker = speakers;
            }
          }
        }
      });
    },
    getVideoSettings() {
      AgoraRTC.getDevices(function (devices) {
        //var devCount = devices.length;
        let savedCamera = vm.getCallSettings("camera");
        let savedVideoProfile = vm.getCallSettings("videoProfile");
        //alert(savedVideoProfile);
        //alert(vm.videoResolution);
        vm.cameraOptions = [];
        devices.forEach(function (item) {
          let device = {
            deviceId: item.deviceId,
            groupId: item.groupId,
            kind: item.kind,
            label: item.label,
          };
          if (item.kind == "videoinput") {
            if (!vm.camera.deviceId || vm.camera.deviceId == "undefiled") {
              if (device.label == vm.localStream.videoName) {
                vm.camera = device;
              }
            }
            vm.cameraOptions.push(device);
          }
        });
        console.log(vm.cameraOptions);
        if (vm.rememberSettings) {
          if (savedCamera != "") {
            let cameras = vm.cameraOptions.find(function (item) {
              return item.deviceId == savedCamera;
            });
            if (cameras) {
              vm.camera = cameras;
            }
          }
          if (savedVideoProfile != "") {
            vm.videoResolution = savedVideoProfile;
          }
        }
      });
    },
    getPlayerSettings() {
      //vm.client.getCameras(function (cameraList) {
      //  vm.cameraList = [];
      //  if (cameraList && cameraList.length > 0) {
      //    cameraList.forEach(function (item) {
      //      vm.cameraList.push({
      //        deviceId: item.deviceId,
      //        groupId: item.groupId,
      //        kind: item.kind,
      //        label: item.label,
      //      });
      //    });
      //    console.log("cameraList: " + vm.cameraList);

      //    vm.$emit("setPlayerSettings", { cameraOptions: vm.cameraList });
      //  }
      //});
      //.catch(function () {});
      AgoraRTC.getDevices(function (devices) {
        //var devCount = devices.length;
        vm.playerSettings.cameraOptions = [];
        vm.playerSettings.microphoneOptions = [];
        vm.playerSettings.speakerOptions = [];
        let savedMicrophone = vm.getCallSettings("microphone");
        let savedCamera = vm.getCallSettings("camera");
        let savedSpeaker = vm.getCallSettings("speaker");
        let savedVideoProfile = vm.getCallSettings("videoProfile");
        devices.forEach(function (item) {
          //alert(item.kind);
          //console.log(item);
          let device = {
            deviceId: item.deviceId,
            groupId: item.groupId,
            kind: item.kind,
            label: item.label,
          };
          if (item.kind == "audioinput") {
            if (!vm.playerSettings.microphone.deviceId) {
              vm.playerSettings.microphone = device;
            }
            vm.playerSettings.microphoneOptions.push(device);
          } else if (item.kind == "audiooutput") {
            if (!vm.playerSettings.speaker.deviceId) {
              vm.playerSettings.speaker = device;
            }
            //alert(device);
            vm.playerSettings.speakerOptions.push(device);
            // vm.playerSettings.speakerOptions.push(item);
          } else if (item.kind == "videoinput") {
            //alert()
            if (
              !vm.playerSettings.camera.deviceId ||
              vm.playerSettings.camera.deviceId == "undefiled"
            ) {
              if (device.label == vm.localStream.videoName) {
                vm.playerSettings.camera = device;
              }
            }
            vm.playerSettings.cameraOptions.push(device);
          }
        });

        if (vm.rememberSettings) {
          if (savedMicrophone != "") {
            let microphones = vm.playerSettings.microphoneOptions.find(
              function (item) {
                return item.deviceId == savedMicrophone;
              }
            );
            if (microphones) {
              vm.playerSettings.microphone = microphones;
            }
          }
          if (savedCamera != "") {
            let cameras = vm.playerSettings.cameraOptions.find(function (item) {
              return item.deviceId == savedCamera;
            });
            if (cameras) {
              vm.playerSettings.camera = cameras;
            }
          }
          //alert("savedSpeaker:" + savedSpeaker);
          if (savedSpeaker != "") {
            let speakers = vm.playerSettings.speakerOptions.find(function (
              item
            ) {
              return item.deviceId == savedSpeaker;
            });
            if (speakers) {
              vm.playerSettings.speaker = speakers;
              //alert(speakers.deviceId);
            }
          }
          //alert("getPlayerSettings:" + vm.videoProfile);
          if (savedVideoProfile != "") {
            vm.videoProfile = savedVideoProfile;
            vm.videoResolution = savedVideoProfile;
          }
        }
        if (vm.videoProfile != "") {
          vm.playerSettings.videoProfile = vm.videoProfile;
        }
        //alert("vm.playerSettings");
        console.log(vm.playerSettings);
        vm.$emit("setPlayerSettings", vm.playerSettings);
      });
    },

    applyAudioVideoSettings(e) {
      //alert("applyAudioVideoSettings");
      //alert(e.videoProfile);
      //alert(e.microphone);
      //alert(e.camera);
      //alert(e.speaker);
      //alert(e.videoProfile);
      let microphone = "";
      let camera = "";
      let speaker = "";
      let videoProfile = "";
      if (
        e.microphone != undefined &&
        e.microphone != null &&
        e.microphone != ""
      ) {
        microphone = e.microphone;
      }
      if (e.camera != undefined && e.camera != null && e.camera != "") {
        camera = e.camera;
      }
      if (e.speaker != undefined && e.speaker != null && e.speaker != "") {
        speaker = e.speaker;
      }
      if (
        e.videoProfile != undefined &&
        e.videoProfile != null &&
        e.videoProfile != ""
      ) {
        videoProfile = e.videoProfile;
      }
      //vm.localStream.getAudeoTrack().stop();
      if (vm.userType < 4 && microphone != "") {
        vm.localStream.switchDevice(
          "audio",
          microphone,
          function () {
            //let microphones = vm.playerSettings.microphoneOptions.filter(
            //  function (item) {
            //    return item.deviceId == e.microphone;
            //  }
            //);
            //if (microphones.length > 0) {
            //  vm.playerSettings.microphoneOld = microphones[0];
            //}
            console.log("Microphone applied successfully");
            if (vm.rememberSettings) {
              vm.saveCallSettings("microphone", microphone);
            }
          },
          function () {
            console.log("Microphone apply faild");
          }
        );
      }
      //vm.localStream.getVideoTrack().stop();
      if (vm.userType < 4 && camera != "") {
        setTimeout(() => {
          vm.localStream.switchDevice(
            "video",
            camera,
            function () {
              console.log("Camera applied successfully");
              if (vm.rememberSettings) {
                vm.saveCallSettings("camera", camera);
              }
            },
            function () {
              console.log("Camera apply failed");
            }
          );
        }, 1000);
      }
      //alert(speaker);
      if (speaker != "") {
        setTimeout(() => {
          vm.localStream.setAudioOutput(
            speaker,
            function () {
              console.log("Speaker applied successfully");
              if (vm.rememberSettings) {
                vm.saveCallSettings("speaker", speaker);
              }
            },
            function () {
              console.log("Microphone apply failed");
            }
          );
        }, 2000);
      }
      //alert(videoProfile)
      if (vm.userType < 4 && videoProfile != "") {
        vm.videoProfile = videoProfile;
        vm.videoResolution = videoProfile;
        vm.localStream.setVideoProfile(videoProfile);
        if (vm.rememberSettings) {
          vm.saveCallSettings("videoProfile", videoProfile);
        }
      }
      setTimeout(() => {
        vm.addUserProfile(vm.uid.toString());
      }, 5000);

      //vm.localStreams.camera.micId = e.microphone.deviceId;
      //vm.localStreams.camera.camId = e.camera.deviceId;
      //let deviceId = e.speaker;
      //// localStream.getVideoTrack().stop();
      //vm.localStream.camera.stream.switchDevice(
      //  "",
      //  deviceId,
      //  function () {
      //    console.log(
      //      "successfully switched to new device with id: " +
      //        JSON.stringify(deviceId)
      //    );
      //    //// set the active device ids
      //    //if(deviceType === "audio") {
      //    //  localStreams.camera.micId = deviceId;
      //    //} else if (deviceType === "video") {
      //    //  localStreams.camera.camId = deviceId;
      //    //} else {
      //    //  console.log("unable to determine deviceType: " + deviceType);
      //    //}
      //  },
      //  function () {
      //    console.log(
      //      "failed to switch to new device with id: " +
      //        JSON.stringify(deviceId)
      //    );
      //  }
      //);
    },

    togglRecording() {
      //
      //$("#btnRecording").toggleClass("start-record");
      if (!$("#btnRecording").hasClass("start-record")) {
        //$("#lblRecording").text(vm.$t("agoracall.stoprecording"));
        //alert("BroadCastStartRecording");
        //alert(vm.eventId);
        //alert(vm.eventId.substring(1));
        vm.BroadCastStartRecording();
      } else {
        //$("#lblRecording").text(vm.$t("agoracall.startrecording"));
        //alert("BroadCastStopRecording");
        vm.BroadCastStopRecording();
      }
    },
    tryAutoStartRecording() {
      var hostUrl = location.host.toLowerCase();
      if (!hostUrl.includes("localhost")) {
        //if (!vm.recordingStarted) {
        vm.BroadCastStartRecording();
        //}
      }
    },
    BroadCastStartRecording() {
      let SessionIdForRec = vm.sessionId;
      if (vm.sessionTypeId == vm.RoundTableTypeID) {
        SessionIdForRec = vm.roundTableId;
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      var requestData = {
        key: {
          instanceId: vm.PlayerAPIConfig.EnvPrefix,
          clientId: vm.clientId,
          eventId: vm.eventId.substring(1),
          sessionId: SessionIdForRec,
          channel: vm.channelName.replace("_gr", ""),
        },
      };
      vm.recordingStartStopInProcess = true;
      axios
        .post(vm.PlayerAPIConfig.StartRecording, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          let data = responseData.data;
          vm.recordingStartStopInProcess = false;
          //alert(data);
          //alert("Recording Started 1");
          let lStatusCode = -1;
          if (typeof data != "undefined") {
            //alert("Recording Started 2");
            lStatusCode = data.status;
            //alert("Start rec data.status: " + data.status);
          }
          //alert("BroadCastStartRecording:" + lStatusCode);
          if (lStatusCode == 0) {
            //alert("Recording Started 3");
            if (typeof data.result.resourceId != "undefined") {
              vm.RecResourceId = data.result.resourceId;
              //alert("data.result.resourceId:" + data.result.resourceId);
            }
            if (typeof data.result.sid != "undefined") {
              vm.RecSid = data.result.sid;
              //alert("data.result.sid:" + data.result.sid);
            }
            $("#btnRecording").addClass("start-record");
            $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
            vm.recordingStarted = true;
            vm.setRecordingParamToFirebase(1);
          } else {
            $("#btnRecording").addClass("start-record");
            if ($("#btnRecording").hasClass("start-record")) {
              $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
            } else {
              $("#lblRecording").text(vm.$t("agoracall.startrecording"));
            }
            vm.recordingStarted = true;
            vm.setRecordingParamToFirebase(1);
          }
        })
        .catch((e) => {
          vm.recordingStartStopInProcess = false;
          console.log(e);
          //console.log("Error in Start Recording: " + attendeeID);
          //alert("Error : Recording Started");
          $("#btnRecording").removeClass("start-record");
          //$("#btnRecording").toggleClass("start-record");
          if ($("#btnRecording").hasClass("start-record")) {
            $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
          } else {
            $("#lblRecording").text(vm.$t("agoracall.startrecording"));
          }
        });

      //$.ajax({
      //  url: vm.PlayerAPIConfig.StartRecording,
      //  headers: {
      //    "Content-Type": "application/json",
      //    Authorization: "Bearer " + vm.getSessionToken(),
      //  },
      //  type: "POST",
      //  mode: "cors",
      //  credentials: "include",
      //  crossDomain: true,
      //  dataType: "json",
      //  processData: false,
      //  data: JSON.stringify(requestData),
      //  success: function (data) {
      //    vm.recordingStartStopInProcess = false;
      //    //alert(data);
      //    //alert("Recording Started 1");
      //    let lStatusCode = -1;
      //    if (typeof data != "undefined") {
      //      //alert("Recording Started 2");
      //      lStatusCode = data.status;
      //      //alert("Start rec data.status: " + data.status);
      //    }
      //    //alert("BroadCastStartRecording:" + lStatusCode);
      //    if (lStatusCode == 0) {
      //      //alert("Recording Started 3");
      //      if (typeof data.result.resourceId != "undefined") {
      //        vm.RecResourceId = data.result.resourceId;
      //        //alert("data.result.resourceId:" + data.result.resourceId);
      //      }
      //      if (typeof data.result.sid != "undefined") {
      //        vm.RecSid = data.result.sid;
      //        //alert("data.result.sid:" + data.result.sid);
      //      }
      //      $("#btnRecording").addClass("start-record");
      //      $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
      //      vm.recordingStarted = true;
      //      vm.setRecordingParamToFirebase(1);
      //    } else {
      //      $("#btnRecording").addClass("start-record");
      //      if ($("#btnRecording").hasClass("start-record")) {
      //        $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
      //      } else {
      //        $("#lblRecording").text(vm.$t("agoracall.startrecording"));
      //      }
      //      vm.recordingStarted = true;
      //      vm.setRecordingParamToFirebase(1);
      //    }
      //  },
      //  error: function (e) {
      //    vm.recordingStartStopInProcess = false;
      //    console.log(e);
      //    //console.log("Error in Start Recording: " + attendeeID);
      //    //alert("Error : Recording Started");
      //    $("#btnRecording").removeClass("start-record");
      //    //$("#btnRecording").toggleClass("start-record");
      //    if ($("#btnRecording").hasClass("start-record")) {
      //      $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
      //    } else {
      //      $("#lblRecording").text(vm.$t("agoracall.startrecording"));
      //    }
      //  },
      //});
    },

    BroadCastStopRecording() {
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      var requestData = {
        key: {
          appId: vm.liveVideoApiDetails.AppID,
          channel: vm.channelName.replace("_gr", ""),
        },
        rec: { resourceId: vm.RecResourceId, sId: vm.RecSid },
      };
      vm.recordingStartStopInProcess = true;

      axios
        .post(vm.PlayerAPIConfig.StopRecording, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          vm.recordingStartStopInProcess = false;
          let data = responseData.data;
          //alert(data);
          //alert("Recording Ended 1");
          let lStatusCode = -1;
          if (typeof data != "undefined") {
            //alert("Recording Ended 2");
            lStatusCode = data.status;
            //alert("Stop Rec data.status: " + data.status);
          }
          //alert("BroadCastStartRecording:" + lStatusCode);
          if (lStatusCode == 0) {
            $("#btnRecording").removeClass("start-record");
            $("#lblRecording").text(vm.$t("agoracall.startrecording"));
            vm.recordingStarted = false;
            vm.setRecordingParamToFirebase(0);
            //alert("Recording Ended 3");
            //CreateBroadcastSettings("recording", 0);
            //$("#lblRecording").text("Start Recording");
            //alert("Recording Ended 4");
          } else {
            $("#btnRecording").removeClass("start-record");
            if ($("#btnRecording").hasClass("start-record")) {
              $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
            } else {
              $("#lblRecording").text(vm.$t("agoracall.startrecording"));
            }
            vm.recordingStarted = false;
            vm.setRecordingParamToFirebase(0);
          }
        })
        .catch((e) => {
          vm.recordingStartStopInProcess = false;
          console.log(e);
          //console.log("Error in Stop Recording: " + attendeeID);
          //alert("Error : Recording Ended");
          $("#btnRecording").addClass("start-record");
          //$("#btnRecording").toggleClass("start-record");
          if ($("#btnRecording").hasClass("start-record")) {
            $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
          } else {
            $("#lblRecording").text(vm.$t("agoracall.startrecording"));
          }
        });

      //$.ajax({
      //  url: vm.PlayerAPIConfig.StopRecording,
      //  headers: {
      //    "Content-Type": "application/json",
      //    Authorization: "Bearer " + vm.getSessionToken(),
      //  },
      //  type: "POST",
      //  mode: "cors",
      //  credentials: "include",
      //  crossDomain: true,
      //  dataType: "json",
      //  processData: false,
      //  data: JSON.stringify(requestData),
      //  success: function (data) {
      //    vm.recordingStartStopInProcess = false;
      //    //alert(data);
      //    //alert("Recording Ended 1");
      //    let lStatusCode = -1;
      //    if (typeof data != "undefined") {
      //      //alert("Recording Ended 2");
      //      lStatusCode = data.status;
      //      //alert("Stop Rec data.status: " + data.status);
      //    }
      //    //alert("BroadCastStartRecording:" + lStatusCode);
      //    if (lStatusCode == 0) {
      //      $("#btnRecording").removeClass("start-record");
      //      $("#lblRecording").text(vm.$t("agoracall.startrecording"));
      //      vm.recordingStarted = false;
      //      vm.setRecordingParamToFirebase(0);
      //      //alert("Recording Ended 3");
      //      //CreateBroadcastSettings("recording", 0);
      //      //$("#lblRecording").text("Start Recording");
      //      //alert("Recording Ended 4");
      //    } else {
      //      $("#btnRecording").removeClass("start-record");
      //      if ($("#btnRecording").hasClass("start-record")) {
      //        $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
      //      } else {
      //        $("#lblRecording").text(vm.$t("agoracall.startrecording"));
      //      }
      //      vm.recordingStarted = false;
      //      vm.setRecordingParamToFirebase(0);
      //    }
      //  },
      //  error: function (e) {
      //    vm.recordingStartStopInProcess = false;
      //    console.log(e);
      //    //console.log("Error in Stop Recording: " + attendeeID);
      //    //alert("Error : Recording Ended");
      //    $("#btnRecording").addClass("start-record");
      //    //$("#btnRecording").toggleClass("start-record");
      //    if ($("#btnRecording").hasClass("start-record")) {
      //      $("#lblRecording").text(vm.$t("agoracall.stoprecording"));
      //    } else {
      //      $("#lblRecording").text(vm.$t("agoracall.startrecording"));
      //    }
      //  },
      //});
    },
  },
};
</script>
<style>
/*#ag-canvas .ag-item .ag-player:not(.player-share) {
  height: 100vh !important;
  max-height: 100% !important;
  width: 100vh !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}*/
</style>